// Generated by `python manage.py build_support_kb` from the page guides
// (scripts/regen_support_kb.sh). Do not edit by hand.
/** Every documented `data-help` anchor and the static route it may be highlighted on. */
export const HELP_ANCHORS: ReadonlyArray<readonly [anchor: string, route: string]> = [
  ["accounts.deposit-details", "/accounts"],
  ["accounts.deposit-details", "/finance-accounts"],
  ["accounts.notify-accounts", "/accounts"],
  ["accounts.notify-accounts", "/finance-accounts"],
  ["accounts.pagination", "/accounts"],
  ["accounts.pagination", "/finance-accounts"],
  ["accounts.tab-all", "/accounts"],
  ["accounts.tab-all", "/finance-accounts"],
  ["accounts.tab-pending", "/accounts"],
  ["accounts.tab-pending", "/finance-accounts"],
  ["accounts.tab-ready", "/accounts"],
  ["accounts.tab-ready", "/finance-accounts"],
  ["activity.date-from", "/admin/activity"],
  ["activity.date-from", "/crm/oversight/activity"],
  ["activity.date-month", "/accounts"],
  ["activity.date-month", "/admin/activity"],
  ["activity.date-month", "/admin/agent-usage"],
  ["activity.date-month", "/admin/attorney-pipeline"],
  ["activity.date-month", "/admin/bond-analytics"],
  ["activity.date-month", "/admin/business"],
  ["activity.date-month", "/admin/commission"],
  ["activity.date-month", "/admin/commission-sheet"],
  ["activity.date-month", "/admin/communications"],
  ["activity.date-month", "/admin/compliance"],
  ["activity.date-month", "/admin/compliance/agents"],
  ["activity.date-month", "/admin/deal-pipeline"],
  ["activity.date-month", "/admin/deals"],
  ["activity.date-month", "/admin/document-vault"],
  ["activity.date-month", "/admin/kpi-upload"],
  ["activity.date-month", "/admin/leaderboard"],
  ["activity.date-month", "/admin/listing-to-registration"],
  ["activity.date-month", "/admin/monthly-deals"],
  ["activity.date-month", "/admin/pipeline-cashflow"],
  ["activity.date-month", "/admin/sales-targets"],
  ["activity.date-month", "/crm/bond-analytics"],
  ["activity.date-month", "/crm/commission"],
  ["activity.date-month", "/crm/commission-sheet"],
  ["activity.date-month", "/crm/compliance/agents"],
  ["activity.date-month", "/crm/dashboard"],
  ["activity.date-month", "/crm/deals"],
  ["activity.date-month", "/crm/document-vault"],
  ["activity.date-month", "/crm/farm"],
  ["activity.date-month", "/crm/kpis"],
  ["activity.date-month", "/crm/leaderboard"],
  ["activity.date-month", "/crm/my-documents"],
  ["activity.date-month", "/crm/oversight/activity"],
  ["activity.date-month", "/crm/oversight/agent-usage"],
  ["activity.date-month", "/crm/oversight/attorney-pipeline"],
  ["activity.date-month", "/crm/oversight/bond-analytics"],
  ["activity.date-month", "/crm/oversight/communications"],
  ["activity.date-month", "/crm/oversight/compliance"],
  ["activity.date-month", "/crm/oversight/deal-pipeline"],
  ["activity.date-month", "/crm/oversight/deal-queue"],
  ["activity.date-month", "/crm/oversight/kpi-upload"],
  ["activity.date-month", "/crm/oversight/monthly-deals"],
  ["activity.date-month", "/crm/oversight/pipeline-cashflow"],
  ["activity.date-month", "/crm/tasks"],
  ["activity.date-month", "/finance"],
  ["activity.date-month", "/finance-accounts"],
  ["activity.date-to", "/admin/activity"],
  ["activity.date-to", "/crm/oversight/activity"],
  ["activity.date-today", "/accounts"],
  ["activity.date-today", "/admin/activity"],
  ["activity.date-today", "/admin/agent-usage"],
  ["activity.date-today", "/admin/attorney-pipeline"],
  ["activity.date-today", "/admin/bond-analytics"],
  ["activity.date-today", "/admin/business"],
  ["activity.date-today", "/admin/commission"],
  ["activity.date-today", "/admin/commission-sheet"],
  ["activity.date-today", "/admin/communications"],
  ["activity.date-today", "/admin/compliance"],
  ["activity.date-today", "/admin/compliance/agents"],
  ["activity.date-today", "/admin/deal-pipeline"],
  ["activity.date-today", "/admin/deals"],
  ["activity.date-today", "/admin/document-vault"],
  ["activity.date-today", "/admin/kpi-upload"],
  ["activity.date-today", "/admin/leaderboard"],
  ["activity.date-today", "/admin/listing-to-registration"],
  ["activity.date-today", "/admin/monthly-deals"],
  ["activity.date-today", "/admin/pipeline-cashflow"],
  ["activity.date-today", "/admin/sales-targets"],
  ["activity.date-today", "/crm/bond-analytics"],
  ["activity.date-today", "/crm/commission"],
  ["activity.date-today", "/crm/commission-sheet"],
  ["activity.date-today", "/crm/compliance/agents"],
  ["activity.date-today", "/crm/dashboard"],
  ["activity.date-today", "/crm/deals"],
  ["activity.date-today", "/crm/document-vault"],
  ["activity.date-today", "/crm/farm"],
  ["activity.date-today", "/crm/kpis"],
  ["activity.date-today", "/crm/leaderboard"],
  ["activity.date-today", "/crm/my-documents"],
  ["activity.date-today", "/crm/oversight/activity"],
  ["activity.date-today", "/crm/oversight/agent-usage"],
  ["activity.date-today", "/crm/oversight/attorney-pipeline"],
  ["activity.date-today", "/crm/oversight/bond-analytics"],
  ["activity.date-today", "/crm/oversight/communications"],
  ["activity.date-today", "/crm/oversight/compliance"],
  ["activity.date-today", "/crm/oversight/deal-pipeline"],
  ["activity.date-today", "/crm/oversight/deal-queue"],
  ["activity.date-today", "/crm/oversight/kpi-upload"],
  ["activity.date-today", "/crm/oversight/monthly-deals"],
  ["activity.date-today", "/crm/oversight/pipeline-cashflow"],
  ["activity.date-today", "/crm/tasks"],
  ["activity.date-today", "/finance"],
  ["activity.date-today", "/finance-accounts"],
  ["activity.date-year", "/accounts"],
  ["activity.date-year", "/admin/activity"],
  ["activity.date-year", "/admin/agent-usage"],
  ["activity.date-year", "/admin/attorney-pipeline"],
  ["activity.date-year", "/admin/bond-analytics"],
  ["activity.date-year", "/admin/business"],
  ["activity.date-year", "/admin/commission"],
  ["activity.date-year", "/admin/commission-sheet"],
  ["activity.date-year", "/admin/communications"],
  ["activity.date-year", "/admin/compliance"],
  ["activity.date-year", "/admin/compliance/agents"],
  ["activity.date-year", "/admin/deal-pipeline"],
  ["activity.date-year", "/admin/deals"],
  ["activity.date-year", "/admin/document-vault"],
  ["activity.date-year", "/admin/kpi-upload"],
  ["activity.date-year", "/admin/leaderboard"],
  ["activity.date-year", "/admin/listing-to-registration"],
  ["activity.date-year", "/admin/monthly-deals"],
  ["activity.date-year", "/admin/pipeline-cashflow"],
  ["activity.date-year", "/admin/sales-targets"],
  ["activity.date-year", "/crm/bond-analytics"],
  ["activity.date-year", "/crm/commission"],
  ["activity.date-year", "/crm/commission-sheet"],
  ["activity.date-year", "/crm/compliance/agents"],
  ["activity.date-year", "/crm/dashboard"],
  ["activity.date-year", "/crm/deals"],
  ["activity.date-year", "/crm/document-vault"],
  ["activity.date-year", "/crm/farm"],
  ["activity.date-year", "/crm/kpis"],
  ["activity.date-year", "/crm/leaderboard"],
  ["activity.date-year", "/crm/my-documents"],
  ["activity.date-year", "/crm/oversight/activity"],
  ["activity.date-year", "/crm/oversight/agent-usage"],
  ["activity.date-year", "/crm/oversight/attorney-pipeline"],
  ["activity.date-year", "/crm/oversight/bond-analytics"],
  ["activity.date-year", "/crm/oversight/communications"],
  ["activity.date-year", "/crm/oversight/compliance"],
  ["activity.date-year", "/crm/oversight/deal-pipeline"],
  ["activity.date-year", "/crm/oversight/deal-queue"],
  ["activity.date-year", "/crm/oversight/kpi-upload"],
  ["activity.date-year", "/crm/oversight/monthly-deals"],
  ["activity.date-year", "/crm/oversight/pipeline-cashflow"],
  ["activity.date-year", "/crm/tasks"],
  ["activity.date-year", "/finance"],
  ["activity.date-year", "/finance-accounts"],
  ["activity.log-date", "/admin/activity"],
  ["activity.log-date", "/crm/oversight/activity"],
  ["activity.log-notes", "/admin/activity"],
  ["activity.log-notes", "/crm/oversight/activity"],
  ["activity.log-submit", "/admin/activity"],
  ["activity.log-submit", "/crm/oversight/activity"],
  ["activity.log-type", "/admin/activity"],
  ["activity.log-type", "/crm/oversight/activity"],
  ["activity.mandate-dual", "/admin/activity"],
  ["activity.mandate-dual", "/crm/dashboard"],
  ["activity.mandate-dual", "/crm/oversight/activity"],
  ["activity.mandate-open", "/admin/activity"],
  ["activity.mandate-open", "/crm/dashboard"],
  ["activity.mandate-open", "/crm/oversight/activity"],
  ["activity.mandate-sole", "/admin/activity"],
  ["activity.mandate-sole", "/crm/dashboard"],
  ["activity.mandate-sole", "/crm/oversight/activity"],
  ["activity.mandate-total", "/admin/activity"],
  ["activity.mandate-total", "/crm/dashboard"],
  ["activity.mandate-total", "/crm/oversight/activity"],
  ["activity.next-week", "/admin/activity"],
  ["activity.next-week", "/crm/oversight/activity"],
  ["activity.previous-week", "/admin/activity"],
  ["activity.previous-week", "/crm/oversight/activity"],
  ["activity.snapshot-calls", "/admin/activity"],
  ["activity.snapshot-calls", "/crm/dashboard"],
  ["activity.snapshot-calls", "/crm/oversight/activity"],
  ["activity.snapshot-new-listings", "/admin/activity"],
  ["activity.snapshot-new-listings", "/crm/dashboard"],
  ["activity.snapshot-new-listings", "/crm/oversight/activity"],
  ["activity.snapshot-offers-accepted", "/admin/activity"],
  ["activity.snapshot-offers-accepted", "/crm/dashboard"],
  ["activity.snapshot-offers-accepted", "/crm/oversight/activity"],
  ["activity.snapshot-offers-received", "/admin/activity"],
  ["activity.snapshot-offers-received", "/crm/dashboard"],
  ["activity.snapshot-offers-received", "/crm/oversight/activity"],
  ["activity.snapshot-valuations", "/admin/activity"],
  ["activity.snapshot-valuations", "/crm/dashboard"],
  ["activity.snapshot-valuations", "/crm/oversight/activity"],
  ["activity.snapshot-viewings", "/admin/activity"],
  ["activity.snapshot-viewings", "/crm/dashboard"],
  ["activity.snapshot-viewings", "/crm/oversight/activity"],
  ["admin-analytics.activation-funnel", "/admin/analytics"],
  ["admin-analytics.active-agent-rate", "/admin/analytics"],
  ["admin-analytics.ai-adoption", "/admin/analytics"],
  ["admin-analytics.ai-calls-pages", "/admin/analytics"],
  ["admin-analytics.ai-failure-hotspots", "/admin/analytics"],
  ["admin-analytics.ai-tab-adoption", "/admin/analytics"],
  ["admin-analytics.ai-window", "/admin/analytics"],
  ["admin-analytics.completeness-details", "/admin/analytics"],
  ["admin-analytics.correlation-details", "/admin/analytics"],
  ["admin-analytics.dormant-but-loaded", "/admin/analytics"],
  ["admin-analytics.dormant-details", "/admin/analytics"],
  ["admin-analytics.enable-analytics", "/admin/analytics"],
  ["admin-analytics.feature-details", "/admin/analytics"],
  ["admin-analytics.feedback-area-details", "/admin/analytics"],
  ["admin-analytics.monthly-report", "/admin/analytics"],
  ["admin-analytics.outside-details", "/admin/analytics"],
  ["admin-analytics.refresh", "/admin/analytics"],
  ["admin-analytics.report-excel", "/admin/analytics"],
  ["admin-analytics.report-month", "/admin/analytics"],
  ["admin-analytics.report-pdf", "/admin/analytics"],
  ["admin-analytics.report-year", "/admin/analytics"],
  ["admin-analytics.tab-agents", "/admin/analytics"],
  ["admin-analytics.tab-ai-usage", "/admin/analytics"],
  ["admin-analytics.tab-correlation", "/admin/analytics"],
  ["admin-analytics.tab-features", "/admin/analytics"],
  ["admin-analytics.tab-overview", "/admin/analytics"],
  ["admin-analytics.view-raw-activity", "/admin/analytics"],
  ["admin-analytics.workflow-completion", "/admin/analytics"],
  ["admin-analytics.working-outside", "/admin/analytics"],
  ["admin-business.accent-colour", "/admin/business"],
  ["admin-business.accent-colour-picker", "/admin/business"],
  ["admin-business.account-holder", "/admin/business"],
  ["admin-business.address-line-1", "/admin/business"],
  ["admin-business.address-line-2", "/admin/business"],
  ["admin-business.analytics-consent", "/admin/business"],
  ["admin-business.analytics-consent-cancel", "/admin/business"],
  ["admin-business.analytics-consent-confirm", "/admin/business"],
  ["admin-business.auto-allocate-file-numbers", "/admin/business"],
  ["admin-business.bank-name", "/admin/business"],
  ["admin-business.business-account-number", "/admin/business"],
  ["admin-business.business-branch-code", "/admin/business"],
  ["admin-business.city", "/admin/business"],
  ["admin-business.commission-cutoff-day", "/admin/business"],
  ["admin-business.company-reg-no", "/admin/business"],
  ["admin-business.connect-ai", "/admin/business"],
  ["admin-business.country", "/admin/business"],
  ["admin-business.data-import", "/admin/business"],
  ["admin-business.delete-document", "/admin/business"],
  ["admin-business.document-purpose", "/admin/business"],
  ["admin-business.download-document", "/admin/business"],
  ["admin-business.email", "/admin/business"],
  ["admin-business.ffc-no", "/admin/business"],
  ["admin-business.font", "/admin/business"],
  ["admin-business.fy-confirm", "/admin/business"],
  ["admin-business.fy-start-day", "/admin/business"],
  ["admin-business.fy-start-month", "/admin/business"],
  ["admin-business.idle-timeout-minutes", "/admin/business"],
  ["admin-business.legal-name", "/admin/business"],
  ["admin-business.logo-file", "/admin/business"],
  ["admin-business.manage-users", "/admin/business"],
  ["admin-business.open-usage-analytics", "/admin/business"],
  ["admin-business.payout-worklist-from", "/admin/business"],
  ["admin-business.phone", "/admin/business"],
  ["admin-business.postal-code", "/admin/business"],
  ["admin-business.primary-colour", "/admin/business"],
  ["admin-business.primary-colour-picker", "/admin/business"],
  ["admin-business.privacy-notice", "/admin/business"],
  ["admin-business.promote-template", "/admin/business"],
  ["admin-business.province", "/admin/business"],
  ["admin-business.run-setup-wizard", "/admin/business"],
  ["admin-business.same-person-authorise", "/admin/business"],
  ["admin-business.save", "/admin/business"],
  ["admin-business.tab-banking", "/admin/business"],
  ["admin-business.tab-branding", "/admin/business"],
  ["admin-business.tab-documents", "/admin/business"],
  ["admin-business.tab-financial", "/admin/business"],
  ["admin-business.tab-profile", "/admin/business"],
  ["admin-business.tab-users", "/admin/business"],
  ["admin-business.trading-name", "/admin/business"],
  ["admin-business.trust-account-number", "/admin/business"],
  ["admin-business.trust-branch-code", "/admin/business"],
  ["admin-business.upload-documents", "/admin/business"],
  ["admin-business.vat-no", "/admin/business"],
  ["admin-business.website", "/admin/business"],
  ["admin-commission.agent", "/admin/commission"],
  ["admin-commission.card-deductions", "/admin/commission"],
  ["admin-commission.card-deductions", "/crm/commission"],
  ["admin-commission.card-earned", "/admin/commission"],
  ["admin-commission.card-net-company", "/admin/commission"],
  ["admin-commission.card-net-company", "/crm/commission"],
  ["admin-commission.card-outstanding", "/admin/commission"],
  ["admin-commission.card-outstanding", "/crm/commission"],
  ["admin-commission.card-paid", "/admin/commission"],
  ["admin-commission.card-paid", "/crm/commission"],
  ["admin-commission.clear-filters", "/admin/commission"],
  ["admin-commission.cobroke-paid-via-us", "/admin/commission"],
  ["admin-commission.date-from", "/admin/commission"],
  ["admin-commission.date-to", "/admin/commission"],
  ["admin-commission.deal-card", "/admin/commission"],
  ["admin-commission.deal-card", "/crm/commission"],
  ["admin-commission.deal-row", "/admin/commission"],
  ["admin-commission.exclude-from-performance", "/admin/commission"],
  ["admin-commission.export", "/admin/commission"],
  ["admin-commission.export-excel", "/admin/commission"],
  ["admin-commission.export-pdf", "/admin/commission"],
  ["admin-commission.filters", "/admin/commission"],
  ["admin-commission.invoice-number", "/admin/commission"],
  ["admin-commission.invoice-paid-date", "/admin/commission"],
  ["admin-commission.open-deal", "/admin/commission"],
  ["admin-commission.open-deal", "/crm/commission"],
  ["admin-commission.pages", "/admin/commission"],
  ["admin-commission.payment-cancel", "/admin/commission"],
  ["admin-commission.payment-save", "/admin/commission"],
  ["admin-commission.payment-status", "/admin/commission"],
  ["admin-commission.received-date", "/admin/commission"],
  ["admin-commission.referral-bearer", "/admin/commission"],
  ["admin-commission.referral-company-share", "/admin/commission"],
  ["admin-commission.sales-basis", "/admin/commission"],
  ["admin-commission.split-role", "/admin/commission"],
  ["admin-commission.split-role", "/crm/commission"],
  ["admin-commission.statement-excel", "/admin/commission"],
  ["admin-commission.statement-excel", "/crm/commission"],
  ["admin-commission.statement-export", "/admin/commission"],
  ["admin-commission.statement-export", "/crm/commission"],
  ["admin-commission.statement-pdf", "/admin/commission"],
  ["admin-commission.statement-pdf", "/crm/commission"],
  ["admin-commission.statement-send", "/admin/commission"],
  ["admin-commission.statement-send", "/crm/commission"],
  ["admin-commission.statement-send-cancel", "/admin/commission"],
  ["admin-commission.statement-send-cancel", "/crm/commission"],
  ["admin-commission.statement-send-confirm", "/admin/commission"],
  ["admin-commission.statement-send-confirm", "/crm/commission"],
  ["admin-commission.update-payment", "/admin/commission"],
  ["admin-commission.update-payment", "/crm/commission"],
  ["admin-commission.update-payment-mobile", "/admin/commission"],
  ["admin-commission.update-payment-mobile", "/crm/commission"],
  ["admin-commission.year", "/admin/commission"],
  ["admin-contacts-dedup.keep", "/admin/contacts/dedup"],
  ["admin-contacts-dedup.merge-cancel", "/admin/contacts/dedup"],
  ["admin-contacts-dedup.merge-confirm", "/admin/contacts/dedup"],
  ["admin-contacts-dedup.preview", "/admin/contacts/dedup"],
  ["admin-contacts-dedup.signal", "/admin/contacts/dedup"],
  ["admin-dashboard.commission-tracking", "/admin/dashboard"],
  ["admin-dashboard.continue-setup", "/admin/dashboard"],
  ["admin-dashboard.deal-pipeline", "/admin/dashboard"],
  ["admin-dashboard.leaderboard", "/admin/dashboard"],
  ["admin-dashboard.market-share", "/admin/dashboard"],
  ["admin-dashboard.monthly-summary", "/admin/dashboard"],
  ["admin-dashboard.more-links", "/admin/dashboard"],
  ["admin-dashboard.open-paralegal", "/admin/dashboard"],
  ["admin-dashboard.outstanding-deal", "/admin/dashboard"],
  ["admin-dashboard.tile-authorizations", "/admin/dashboard"],
  ["admin-dashboard.tile-commission-outstanding", "/admin/dashboard"],
  ["admin-dashboard.tile-deals", "/admin/dashboard"],
  ["admin-dashboard.tile-feedback", "/admin/dashboard"],
  ["admin-dashboard.tile-fica", "/admin/dashboard"],
  ["admin-dashboard.tile-market-share", "/admin/dashboard"],
  ["admin-dashboard.tile-str", "/admin/dashboard"],
  ["admin-dashboard.tile-target", "/admin/dashboard"],
  ["admin-deals-dedup.merge", "/admin/deals/dedup"],
  ["admin-deals-dedup.merge-cancel", "/admin/deals/dedup"],
  ["admin-deals-dedup.merge-confirm", "/admin/deals/dedup"],
  ["admin-integrations.consent-notice-view-terms", "/admin/document-vault"],
  ["admin-integrations.consent-notice-view-terms", "/admin/integrations"],
  ["admin-integrations.consent-notice-view-terms", "/crm/canvassing"],
  ["admin-integrations.consent-notice-view-terms", "/crm/document-vault"],
  ["admin-integrations.consent-notice-view-terms", "/crm/property-lookup"],
  ["admin-integrations.identity-checks-api-key", "/admin/integrations"],
  ["admin-integrations.identity-checks-enable", "/admin/integrations"],
  ["admin-integrations.identity-checks-mode", "/admin/integrations"],
  ["admin-integrations.identity-checks-save", "/admin/integrations"],
  ["admin-integrations.identity-checks-test", "/admin/integrations"],
  ["admin-integrations.listings-feed-enable", "/admin/integrations"],
  ["admin-integrations.listings-feed-password", "/admin/integrations"],
  ["admin-integrations.listings-feed-save", "/admin/integrations"],
  ["admin-integrations.listings-feed-test", "/admin/integrations"],
  ["admin-integrations.listings-feed-username", "/admin/integrations"],
  ["admin-integrations.property-data-area-name", "/admin/integrations"],
  ["admin-integrations.property-data-area-polygon", "/admin/integrations"],
  ["admin-integrations.property-data-area-reports-toggle", "/admin/integrations"],
  ["admin-integrations.property-data-areas-refresh", "/admin/integrations"],
  ["admin-integrations.property-data-client-id", "/admin/integrations"],
  ["admin-integrations.property-data-client-identifier", "/admin/integrations"],
  ["admin-integrations.property-data-client-secret", "/admin/integrations"],
  ["admin-integrations.property-data-confirm-charge", "/admin/integrations"],
  ["admin-integrations.property-data-consent-ids", "/admin/integrations"],
  ["admin-integrations.property-data-contribute-toggle", "/admin/integrations"],
  ["admin-integrations.property-data-create-area", "/admin/integrations"],
  ["admin-integrations.property-data-download-report", "/admin/integrations"],
  ["admin-integrations.property-data-dry-run", "/admin/integrations"],
  ["admin-integrations.property-data-enable", "/admin/integrations"],
  ["admin-integrations.property-data-monthly-allowance", "/admin/integrations"],
  ["admin-integrations.property-data-recheck-balance", "/admin/integrations"],
  ["admin-integrations.property-data-request-report", "/admin/integrations"],
  ["admin-integrations.property-data-save", "/admin/integrations"],
  ["admin-integrations.property-data-save-allowance-policy", "/admin/integrations"],
  ["admin-integrations.property-data-test", "/admin/integrations"],
  ["admin-integrations.property-data-unreadable-price-charge", "/admin/integrations"],
  ["admin-integrations.property-data-user-email", "/admin/integrations"],
  ["admin-integrations.property-data-view-consent-terms", "/admin/integrations"],
  ["admin-integrations.property-data-view-report", "/admin/integrations"],
  ["admin-integrations.property-data-withdraw-cancel", "/admin/integrations"],
  ["admin-integrations.property-data-withdraw-confirm", "/admin/integrations"],
  ["admin-integrations.property-data-withdraw-consent", "/admin/integrations"],
  ["admin-integrations.whatsapp-leads-enable", "/admin/integrations"],
  ["admin-integrations.whatsapp-leads-save", "/admin/integrations"],
  ["admin-integrations.whatsapp-leads-test", "/admin/integrations"],
  ["admin-integrations.whatsapp-leads-token", "/admin/integrations"],
  ["admin-integrations.whatsapp-leads-work-day-end", "/admin/integrations"],
  ["admin-integrations.whatsapp-leads-work-day-start", "/admin/integrations"],
  ["admin-integrations.whatsapp-leads-working-days", "/admin/integrations"],
  ["admin-leaderboard.active-agents", "/admin/leaderboard"],
  ["admin-leaderboard.activity-vs-target", "/admin/leaderboard"],
  ["admin-leaderboard.agent-deals", "/admin/leaderboard"],
  ["admin-leaderboard.agent-deals", "/crm/leaderboard"],
  ["admin-leaderboard.date-from", "/admin/leaderboard"],
  ["admin-leaderboard.date-to", "/admin/leaderboard"],
  ["admin-leaderboard.filters", "/admin/leaderboard"],
  ["admin-leaderboard.kpi-tier", "/admin/leaderboard"],
  ["admin-leaderboard.reset-filters", "/admin/leaderboard"],
  ["admin-leaderboard.sales-targets", "/admin/leaderboard"],
  ["admin-leaderboard.total-deals", "/admin/leaderboard"],
  ["admin-leaderboard.total-turnover", "/admin/leaderboard"],
  ["admin-leads-ambiguous.cancel", "/admin/leads/ambiguous"],
  ["admin-leads-ambiguous.candidate", "/admin/leads/ambiguous"],
  ["admin-leads-ambiguous.confirm", "/admin/leads/ambiguous"],
  ["admin-leads-ambiguous.create-contact", "/admin/leads/ambiguous"],
  ["admin-leads-ambiguous.dismiss", "/admin/leads/ambiguous"],
  ["admin-leads-ambiguous.link", "/admin/leads/ambiguous"],
  ["admin-leads-ambiguous.pages", "/admin/leads/ambiguous"],
  ["admin-leads-ambiguous.status-filter", "/admin/leads/ambiguous"],
  ["admin-leads-unassigned.assign", "/admin/leads/unassigned"],
  ["admin-leads-unassigned.assign-card", "/admin/leads/unassigned"],
  ["admin-leads-unassigned.assign-lead", "/admin/leads/unassigned"],
  ["admin-leads-unassigned.assign-to", "/admin/leads/unassigned"],
  ["admin-leads-unassigned.cancel", "/admin/leads/unassigned"],
  ["admin-leads-unassigned.pages", "/admin/leads/unassigned"],
  ["admin-leads-unassigned.search", "/admin/leads/unassigned"],
  ["admin-leads-unassigned.search-button", "/admin/leads/unassigned"],
  ["admin-leads-unassigned.source-filter", "/admin/leads/unassigned"],
  ["admin-privileged-authorizations.approve", "/admin/privileged-authorizations"],
  ["admin-privileged-authorizations.refresh", "/admin/privileged-authorizations"],
  ["admin-privileged-authorizations.reject", "/admin/privileged-authorizations"],
  ["admin-privileged-authorizations.tab-all", "/admin/privileged-authorizations"],
  ["admin-privileged-authorizations.tab-approved", "/admin/privileged-authorizations"],
  ["admin-privileged-authorizations.tab-pending", "/admin/privileged-authorizations"],
  ["admin-privileged-authorizations.tab-rejected", "/admin/privileged-authorizations"],
  ["admin-sales-targets.agent", "/admin/sales-targets"],
  ["admin-sales-targets.area", "/admin/sales-targets"],
  ["admin-sales-targets.clear-filters", "/admin/sales-targets"],
  ["admin-sales-targets.date-from", "/admin/sales-targets"],
  ["admin-sales-targets.date-to", "/admin/sales-targets"],
  ["admin-sales-targets.delete-target", "/admin/sales-targets"],
  ["admin-sales-targets.edit-target", "/admin/sales-targets"],
  ["admin-sales-targets.financial-year", "/admin/sales-targets"],
  ["admin-sales-targets.form-add-area", "/admin/sales-targets"],
  ["admin-sales-targets.form-agent", "/admin/sales-targets"],
  ["admin-sales-targets.form-agent-target", "/admin/sales-targets"],
  ["admin-sales-targets.form-area", "/admin/sales-targets"],
  ["admin-sales-targets.form-area-split", "/admin/sales-targets"],
  ["admin-sales-targets.form-cancel", "/admin/sales-targets"],
  ["admin-sales-targets.form-catch-all", "/admin/sales-targets"],
  ["admin-sales-targets.form-company-target", "/admin/sales-targets"],
  ["admin-sales-targets.form-financial-year", "/admin/sales-targets"],
  ["admin-sales-targets.form-label", "/admin/sales-targets"],
  ["admin-sales-targets.form-minimum-pct", "/admin/sales-targets"],
  ["admin-sales-targets.form-remove-area", "/admin/sales-targets"],
  ["admin-sales-targets.form-save", "/admin/sales-targets"],
  ["admin-sales-targets.form-team", "/admin/sales-targets"],
  ["admin-sales-targets.new-target", "/admin/sales-targets"],
  ["admin-sales-targets.refresh", "/admin/sales-targets"],
  ["admin-sales-targets.set-targets", "/admin/sales-targets"],
  ["admin-str-queue.fic-reference", "/admin/str-queue"],
  ["admin-str-queue.generate-xml", "/admin/str-queue"],
  ["admin-str-queue.open-card", "/admin/str-queue"],
  ["admin-str-queue.open-row", "/admin/str-queue"],
  ["admin-str-queue.save", "/admin/str-queue"],
  ["admin-str-queue.status", "/admin/str-queue"],
  ["admin-str-queue.status-filter", "/admin/str-queue"],
  ["admin-str-queue.upload", "/admin/str-queue"],
  ["admin-support-insights.pages", "/admin/support-insights"],
  ["admin-support-insights.period", "/admin/support-insights"],
  ["agent-usage.agent", "/admin/agent-usage"],
  ["agent-usage.agent", "/crm/oversight/agent-usage"],
  ["agent-usage.agent-mobile", "/admin/agent-usage"],
  ["agent-usage.agent-mobile", "/crm/oversight/agent-usage"],
  ["agent-usage.date-from", "/admin/agent-usage"],
  ["agent-usage.date-from", "/crm/oversight/agent-usage"],
  ["agent-usage.date-to", "/admin/agent-usage"],
  ["agent-usage.date-to", "/crm/oversight/agent-usage"],
  ["agent-usage.include-archived", "/admin/agent-usage"],
  ["agent-usage.include-archived", "/crm/oversight/agent-usage"],
  ["areas.add-area", "/admin/areas"],
  ["areas.add-area", "/crm/oversight/areas"],
  ["areas.area-name", "/admin/areas"],
  ["areas.area-name", "/crm/oversight/areas"],
  ["areas.cancel", "/admin/areas"],
  ["areas.cancel", "/crm/oversight/areas"],
  ["areas.close", "/admin/areas"],
  ["areas.close", "/crm/oversight/areas"],
  ["areas.delete", "/admin/areas"],
  ["areas.delete", "/crm/oversight/areas"],
  ["areas.delete-cancel", "/admin/areas"],
  ["areas.delete-cancel", "/crm/oversight/areas"],
  ["areas.delete-confirm", "/admin/areas"],
  ["areas.delete-confirm", "/crm/oversight/areas"],
  ["areas.edit", "/admin/areas"],
  ["areas.edit", "/crm/oversight/areas"],
  ["areas.has-farm-book", "/admin/areas"],
  ["areas.has-farm-book", "/crm/oversight/areas"],
  ["areas.report-exempt", "/admin/areas"],
  ["areas.report-exempt", "/crm/oversight/areas"],
  ["areas.retired", "/admin/areas"],
  ["areas.retired", "/crm/oversight/areas"],
  ["areas.save", "/admin/areas"],
  ["areas.save", "/crm/oversight/areas"],
  ["areas.search", "/admin/areas"],
  ["areas.search", "/crm/oversight/areas"],
  ["attorney-pipeline.basis-cancellation", "/admin/attorney-pipeline"],
  ["attorney-pipeline.basis-cancellation", "/crm/oversight/attorney-pipeline"],
  ["attorney-pipeline.basis-registration", "/admin/attorney-pipeline"],
  ["attorney-pipeline.basis-registration", "/crm/oversight/attorney-pipeline"],
  ["attorney-pipeline.basis-sale", "/admin/attorney-pipeline"],
  ["attorney-pipeline.basis-sale", "/crm/oversight/attorney-pipeline"],
  ["attorney-pipeline.bond-source", "/admin/attorney-pipeline"],
  ["attorney-pipeline.bond-source", "/crm/oversight/attorney-pipeline"],
  ["attorney-pipeline.clear-filters", "/admin/attorney-pipeline"],
  ["attorney-pipeline.clear-filters", "/crm/oversight/attorney-pipeline"],
  ["attorney-pipeline.date-from", "/admin/attorney-pipeline"],
  ["attorney-pipeline.date-from", "/crm/oversight/attorney-pipeline"],
  ["attorney-pipeline.date-to", "/admin/attorney-pipeline"],
  ["attorney-pipeline.date-to", "/crm/oversight/attorney-pipeline"],
  ["attorney-pipeline.deal-type", "/admin/attorney-pipeline"],
  ["attorney-pipeline.deal-type", "/crm/oversight/attorney-pipeline"],
  ["attorney-pipeline.filters", "/admin/attorney-pipeline"],
  ["attorney-pipeline.filters", "/crm/oversight/attorney-pipeline"],
  ["attorney-pipeline.financial-year", "/admin/attorney-pipeline"],
  ["attorney-pipeline.financial-year", "/crm/oversight/attorney-pipeline"],
  ["attorney-pipeline.firm", "/admin/attorney-pipeline"],
  ["attorney-pipeline.firm", "/crm/oversight/attorney-pipeline"],
  ["attorney-pipeline.refresh", "/admin/attorney-pipeline"],
  ["attorney-pipeline.refresh", "/crm/oversight/attorney-pipeline"],
  ["attorney-pipeline.state-cancelled", "/admin/attorney-pipeline"],
  ["attorney-pipeline.state-cancelled", "/crm/oversight/attorney-pipeline"],
  ["attorney-pipeline.state-live", "/admin/attorney-pipeline"],
  ["attorney-pipeline.state-live", "/crm/oversight/attorney-pipeline"],
  ["attorney-pipeline.try-again", "/admin/attorney-pipeline"],
  ["attorney-pipeline.try-again", "/crm/oversight/attorney-pipeline"],
  ["behind-schedule.clear-milestone", "/behind-schedule"],
  ["behind-schedule.draw-extension", "/behind-schedule"],
  ["behind-schedule.milestone-filter", "/behind-schedule"],
  ["behind-schedule.open-deal", "/behind-schedule"],
  ["behind-schedule.show-on-track", "/behind-schedule"],
  ["bond-analytics.date-from", "/admin/bond-analytics"],
  ["bond-analytics.date-from", "/crm/bond-analytics"],
  ["bond-analytics.date-from", "/crm/oversight/bond-analytics"],
  ["bond-analytics.date-to", "/admin/bond-analytics"],
  ["bond-analytics.date-to", "/crm/bond-analytics"],
  ["bond-analytics.date-to", "/crm/oversight/bond-analytics"],
  ["bond-analytics.no-amount-deal", "/admin/bond-analytics"],
  ["bond-analytics.no-amount-deal", "/crm/bond-analytics"],
  ["bond-analytics.no-amount-deal", "/crm/oversight/bond-analytics"],
  ["bond-analytics.no-amount-deals", "/admin/bond-analytics"],
  ["bond-analytics.no-amount-deals", "/crm/bond-analytics"],
  ["bond-analytics.no-amount-deals", "/crm/oversight/bond-analytics"],
  ["bond-analytics.no-originator-deal", "/admin/bond-analytics"],
  ["bond-analytics.no-originator-deal", "/crm/bond-analytics"],
  ["bond-analytics.no-originator-deal", "/crm/oversight/bond-analytics"],
  ["bond-analytics.no-originator-deals", "/admin/bond-analytics"],
  ["bond-analytics.no-originator-deals", "/crm/bond-analytics"],
  ["bond-analytics.no-originator-deals", "/crm/oversight/bond-analytics"],
  ["bond-analytics.originator", "/admin/bond-analytics"],
  ["bond-analytics.originator", "/crm/bond-analytics"],
  ["bond-analytics.originator", "/crm/oversight/bond-analytics"],
  ["bond-analytics.period", "/admin/bond-analytics"],
  ["bond-analytics.period", "/crm/bond-analytics"],
  ["bond-analytics.period", "/crm/oversight/bond-analytics"],
  ["bond-analytics.year", "/admin/bond-analytics"],
  ["bond-analytics.year", "/crm/bond-analytics"],
  ["bond-analytics.year", "/crm/oversight/bond-analytics"],
  ["checklist-templates.active", "/admin/checklist-templates"],
  ["checklist-templates.active", "/crm/oversight/checklist-templates"],
  ["checklist-templates.add-item", "/admin/checklist-templates"],
  ["checklist-templates.add-item", "/crm/oversight/checklist-templates"],
  ["checklist-templates.cancel", "/admin/checklist-templates"],
  ["checklist-templates.cancel", "/crm/oversight/checklist-templates"],
  ["checklist-templates.delete", "/admin/checklist-templates"],
  ["checklist-templates.delete", "/crm/oversight/checklist-templates"],
  ["checklist-templates.edit", "/admin/checklist-templates"],
  ["checklist-templates.edit", "/crm/oversight/checklist-templates"],
  ["checklist-templates.key", "/admin/checklist-templates"],
  ["checklist-templates.key", "/crm/oversight/checklist-templates"],
  ["checklist-templates.label", "/admin/checklist-templates"],
  ["checklist-templates.label", "/crm/oversight/checklist-templates"],
  ["checklist-templates.per-party", "/admin/checklist-templates"],
  ["checklist-templates.per-party", "/crm/oversight/checklist-templates"],
  ["checklist-templates.required", "/admin/checklist-templates"],
  ["checklist-templates.required", "/crm/oversight/checklist-templates"],
  ["checklist-templates.save", "/admin/checklist-templates"],
  ["checklist-templates.save", "/crm/oversight/checklist-templates"],
  ["checklist-templates.section", "/admin/checklist-templates"],
  ["checklist-templates.section", "/crm/oversight/checklist-templates"],
  ["checklist-templates.sort-order", "/admin/checklist-templates"],
  ["checklist-templates.sort-order", "/crm/oversight/checklist-templates"],
  ["checklist-templates.toggle-active", "/admin/checklist-templates"],
  ["checklist-templates.toggle-active", "/crm/oversight/checklist-templates"],
  ["commission-authorizations.back", "/admin/commission-authorizations"],
  ["commission-authorizations.back", "/finance/authorizations"],
  ["commission-authorizations.confirm-reject", "/admin/commission-authorizations"],
  ["commission-authorizations.confirm-reject", "/finance/authorizations"],
  ["commission-authorizations.deal-clear", "/admin/commission-authorizations"],
  ["commission-authorizations.deal-clear", "/finance/authorizations"],
  ["commission-authorizations.deal-open", "/admin/commission-authorizations"],
  ["commission-authorizations.deal-open", "/finance/authorizations"],
  ["commission-authorizations.finance-approve", "/admin/commission-authorizations"],
  ["commission-authorizations.finance-approve", "/finance/authorizations"],
  ["commission-authorizations.month-clear", "/admin/commission-authorizations"],
  ["commission-authorizations.month-clear", "/finance/authorizations"],
  ["commission-authorizations.month-filter", "/admin/commission-authorizations"],
  ["commission-authorizations.month-filter", "/finance/authorizations"],
  ["commission-authorizations.open-deal", "/admin/commission-authorizations"],
  ["commission-authorizations.open-deal", "/finance/authorizations"],
  ["commission-authorizations.registered-deal", "/admin/commission-authorizations"],
  ["commission-authorizations.registered-deal", "/finance/authorizations"],
  ["commission-authorizations.registered-deal-mobile", "/admin/commission-authorizations"],
  ["commission-authorizations.registered-deal-mobile", "/finance/authorizations"],
  ["commission-authorizations.registered-pagination", "/admin/commission-authorizations"],
  ["commission-authorizations.registered-pagination", "/finance/authorizations"],
  ["commission-authorizations.reject", "/admin/commission-authorizations"],
  ["commission-authorizations.reject", "/finance/authorizations"],
  ["commission-authorizations.reject-cancel", "/admin/commission-authorizations"],
  ["commission-authorizations.reject-cancel", "/finance/authorizations"],
  ["commission-authorizations.reject-reason", "/admin/commission-authorizations"],
  ["commission-authorizations.reject-reason", "/finance/authorizations"],
  ["commission-authorizations.release", "/admin/commission-authorizations"],
  ["commission-authorizations.release", "/finance/authorizations"],
  ["commission-authorizations.scope-all", "/admin/commission-authorizations"],
  ["commission-authorizations.scope-all", "/finance/authorizations"],
  ["commission-authorizations.scope-current", "/admin/commission-authorizations"],
  ["commission-authorizations.scope-current", "/finance/authorizations"],
  ["commission-authorizations.sheets-pagination", "/admin/commission-authorizations"],
  ["commission-authorizations.sheets-pagination", "/finance/authorizations"],
  ["commission-authorizations.status-filter", "/admin/commission-authorizations"],
  ["commission-authorizations.status-filter", "/finance/authorizations"],
  ["commission-sheet.export", "/admin/commission-sheet"],
  ["commission-sheet.export", "/crm/commission-sheet"],
  ["commission-sheet.export-excel", "/admin/commission-sheet"],
  ["commission-sheet.export-excel", "/crm/commission-sheet"],
  ["commission-sheet.export-pdf", "/admin/commission-sheet"],
  ["commission-sheet.export-pdf", "/crm/commission-sheet"],
  ["commission-sheet.pages", "/admin/commission-sheet"],
  ["commission-sheet.pages", "/crm/commission-sheet"],
  ["commission-sheet.payrun-next", "/admin/commission-sheet"],
  ["commission-sheet.payrun-next", "/crm/commission-sheet"],
  ["commission-sheet.payrun-prev", "/admin/commission-sheet"],
  ["commission-sheet.payrun-prev", "/crm/commission-sheet"],
  ["commission-sheet.payrun-reason", "/admin/commission-sheet"],
  ["commission-sheet.payrun-reason", "/crm/commission-sheet"],
  ["commission-sheet.payrun-reset", "/admin/commission-sheet"],
  ["commission-sheet.payrun-reset", "/crm/commission-sheet"],
  ["commission-sheet.period-month", "/admin/commission-sheet"],
  ["commission-sheet.period-month", "/crm/commission-sheet"],
  ["commission-sheet.period-year", "/admin/commission-sheet"],
  ["commission-sheet.period-year", "/crm/commission-sheet"],
  ["commission-sheet.pull-forward-cancel", "/admin/commission-sheet"],
  ["commission-sheet.pull-forward-cancel", "/crm/commission-sheet"],
  ["commission-sheet.pull-forward-confirm", "/admin/commission-sheet"],
  ["commission-sheet.pull-forward-confirm", "/crm/commission-sheet"],
  ["commission-sheet.pull-forward-include", "/admin/commission-sheet"],
  ["commission-sheet.pull-forward-include", "/crm/commission-sheet"],
  ["commission-sheet.receipt-account", "/admin/commission-sheet"],
  ["commission-sheet.receipt-account", "/crm/commission-sheet"],
  ["commission-sheet.receipt-amount", "/admin/commission-sheet"],
  ["commission-sheet.receipt-amount", "/crm/commission-sheet"],
  ["commission-sheet.receipt-cancel-edit", "/admin/commission-sheet"],
  ["commission-sheet.receipt-cancel-edit", "/crm/commission-sheet"],
  ["commission-sheet.receipt-date", "/admin/commission-sheet"],
  ["commission-sheet.receipt-date", "/crm/commission-sheet"],
  ["commission-sheet.receipt-edit", "/admin/commission-sheet"],
  ["commission-sheet.receipt-edit", "/crm/commission-sheet"],
  ["commission-sheet.receipt-invoice-ref", "/admin/commission-sheet"],
  ["commission-sheet.receipt-invoice-ref", "/crm/commission-sheet"],
  ["commission-sheet.receipt-note", "/admin/commission-sheet"],
  ["commission-sheet.receipt-note", "/crm/commission-sheet"],
  ["commission-sheet.receipt-remove", "/admin/commission-sheet"],
  ["commission-sheet.receipt-remove", "/crm/commission-sheet"],
  ["commission-sheet.receipt-remove-confirm", "/admin/commission-sheet"],
  ["commission-sheet.receipt-remove-confirm", "/crm/commission-sheet"],
  ["commission-sheet.receipt-remove-keep", "/admin/commission-sheet"],
  ["commission-sheet.receipt-remove-keep", "/crm/commission-sheet"],
  ["commission-sheet.receipt-save", "/admin/commission-sheet"],
  ["commission-sheet.receipt-save", "/crm/commission-sheet"],
  ["commission-sheet.receipts-close", "/admin/commission-sheet"],
  ["commission-sheet.receipts-close", "/crm/commission-sheet"],
  ["commission-sheet.record-receipt", "/admin/commission-sheet"],
  ["commission-sheet.record-receipt", "/crm/commission-sheet"],
  ["communications.clear-all", "/admin/communications"],
  ["communications.clear-all", "/crm/oversight/communications"],
  ["communications.clear-dates", "/admin/communications"],
  ["communications.clear-dates", "/crm/oversight/communications"],
  ["communications.failed-messages", "/admin/communications"],
  ["communications.failed-messages", "/crm/oversight/communications"],
  ["communications.filter-agent", "/admin/communications"],
  ["communications.filter-agent", "/crm/oversight/communications"],
  ["communications.filter-channel", "/admin/communications"],
  ["communications.filter-channel", "/crm/oversight/communications"],
  ["communications.filter-direction", "/admin/communications"],
  ["communications.filter-direction", "/crm/oversight/communications"],
  ["communications.filter-status", "/admin/communications"],
  ["communications.filter-status", "/crm/oversight/communications"],
  ["communications.filters", "/admin/communications"],
  ["communications.filters", "/crm/oversight/communications"],
  ["communications.from-date", "/admin/communications"],
  ["communications.from-date", "/crm/oversight/communications"],
  ["communications.health-from-date", "/admin/communications"],
  ["communications.health-from-date", "/crm/oversight/communications"],
  ["communications.health-to-date", "/admin/communications"],
  ["communications.health-to-date", "/crm/oversight/communications"],
  ["communications.pages", "/admin/communications"],
  ["communications.pages", "/crm/oversight/communications"],
  ["communications.refresh", "/admin/communications"],
  ["communications.refresh", "/crm/oversight/communications"],
  ["communications.tab-health", "/admin/communications"],
  ["communications.tab-health", "/crm/oversight/communications"],
  ["communications.tab-history", "/admin/communications"],
  ["communications.tab-history", "/crm/oversight/communications"],
  ["communications.this-month", "/admin/communications"],
  ["communications.this-month", "/crm/oversight/communications"],
  ["communications.to-date", "/admin/communications"],
  ["communications.to-date", "/crm/oversight/communications"],
  ["compliance-agents.agent-row", "/admin/compliance/agents"],
  ["compliance-agents.agent-row", "/crm/compliance/agents"],
  ["compliance-agents.agent-row", "/crm/my-documents"],
  ["compliance-agents.attach", "/admin/compliance/agents"],
  ["compliance-agents.attach", "/crm/compliance/agents"],
  ["compliance-agents.attach", "/crm/my-documents"],
  ["compliance-agents.attach-file", "/admin/compliance/agents"],
  ["compliance-agents.attach-file", "/crm/compliance/agents"],
  ["compliance-agents.attach-file", "/crm/my-documents"],
  ["compliance-agents.doc-close", "/admin/compliance/agents"],
  ["compliance-agents.doc-close", "/crm/compliance/agents"],
  ["compliance-agents.doc-close", "/crm/my-documents"],
  ["compliance-agents.doc-expiry-date", "/admin/compliance/agents"],
  ["compliance-agents.doc-expiry-date", "/crm/compliance/agents"],
  ["compliance-agents.doc-expiry-date", "/crm/my-documents"],
  ["compliance-agents.doc-file", "/admin/compliance/agents"],
  ["compliance-agents.doc-file", "/crm/compliance/agents"],
  ["compliance-agents.doc-file", "/crm/my-documents"],
  ["compliance-agents.doc-issue-date", "/admin/compliance/agents"],
  ["compliance-agents.doc-issue-date", "/crm/compliance/agents"],
  ["compliance-agents.doc-issue-date", "/crm/my-documents"],
  ["compliance-agents.doc-notes", "/admin/compliance/agents"],
  ["compliance-agents.doc-notes", "/crm/compliance/agents"],
  ["compliance-agents.doc-notes", "/crm/my-documents"],
  ["compliance-agents.doc-number", "/admin/compliance/agents"],
  ["compliance-agents.doc-number", "/crm/compliance/agents"],
  ["compliance-agents.doc-number", "/crm/my-documents"],
  ["compliance-agents.doc-remove", "/admin/compliance/agents"],
  ["compliance-agents.doc-remove", "/crm/compliance/agents"],
  ["compliance-agents.doc-remove", "/crm/my-documents"],
  ["compliance-agents.doc-save", "/admin/compliance/agents"],
  ["compliance-agents.doc-save", "/crm/compliance/agents"],
  ["compliance-agents.doc-save", "/crm/my-documents"],
  ["compliance-agents.download-file", "/admin/compliance"],
  ["compliance-agents.download-file", "/admin/compliance/agents"],
  ["compliance-agents.download-file", "/admin/document-vault"],
  ["compliance-agents.download-file", "/admin/hr-templates"],
  ["compliance-agents.download-file", "/crm/compliance/agents"],
  ["compliance-agents.download-file", "/crm/document-vault"],
  ["compliance-agents.download-file", "/crm/documents"],
  ["compliance-agents.download-file", "/crm/hr-templates"],
  ["compliance-agents.download-file", "/crm/my-documents"],
  ["compliance-agents.download-file", "/crm/oversight/compliance"],
  ["compliance-agents.download-file", "/management"],
  ["compliance-agents.drawer-close", "/admin/compliance/agents"],
  ["compliance-agents.drawer-close", "/crm/compliance/agents"],
  ["compliance-agents.drawer-close", "/crm/my-documents"],
  ["compliance-agents.export-csv", "/admin/compliance/agents"],
  ["compliance-agents.export-csv", "/crm/compliance/agents"],
  ["compliance-agents.export-csv", "/crm/my-documents"],
  ["compliance-agents.file-label", "/admin/compliance/agents"],
  ["compliance-agents.file-label", "/crm/compliance/agents"],
  ["compliance-agents.file-label", "/crm/my-documents"],
  ["compliance-agents.file-remove", "/admin/compliance/agents"],
  ["compliance-agents.file-remove", "/crm/compliance/agents"],
  ["compliance-agents.file-remove", "/crm/my-documents"],
  ["compliance-agents.not-on-file-filter", "/admin/compliance/agents"],
  ["compliance-agents.not-on-file-filter", "/crm/compliance/agents"],
  ["compliance-agents.not-on-file-filter", "/crm/my-documents"],
  ["compliance-agents.preview-close", "/admin/compliance/agents"],
  ["compliance-agents.preview-close", "/admin/document-vault"],
  ["compliance-agents.preview-close", "/admin/hr-templates"],
  ["compliance-agents.preview-close", "/crm/compliance/agents"],
  ["compliance-agents.preview-close", "/crm/document-vault"],
  ["compliance-agents.preview-close", "/crm/hr-templates"],
  ["compliance-agents.preview-close", "/crm/my-documents"],
  ["compliance-agents.preview-close", "/management"],
  ["compliance-agents.preview-download", "/admin/compliance/agents"],
  ["compliance-agents.preview-download", "/admin/document-vault"],
  ["compliance-agents.preview-download", "/admin/hr-templates"],
  ["compliance-agents.preview-download", "/crm/compliance/agents"],
  ["compliance-agents.preview-download", "/crm/document-vault"],
  ["compliance-agents.preview-download", "/crm/hr-templates"],
  ["compliance-agents.preview-download", "/crm/my-documents"],
  ["compliance-agents.preview-download", "/management"],
  ["compliance-agents.preview-open-tab", "/admin/compliance/agents"],
  ["compliance-agents.preview-open-tab", "/admin/document-vault"],
  ["compliance-agents.preview-open-tab", "/admin/hr-templates"],
  ["compliance-agents.preview-open-tab", "/crm/compliance/agents"],
  ["compliance-agents.preview-open-tab", "/crm/document-vault"],
  ["compliance-agents.preview-open-tab", "/crm/hr-templates"],
  ["compliance-agents.preview-open-tab", "/crm/my-documents"],
  ["compliance-agents.preview-open-tab", "/management"],
  ["compliance-agents.reason", "/admin/compliance/agents"],
  ["compliance-agents.reason", "/crm/compliance/agents"],
  ["compliance-agents.reason", "/crm/my-documents"],
  ["compliance-agents.reason-cancel", "/admin/compliance/agents"],
  ["compliance-agents.reason-cancel", "/crm/compliance/agents"],
  ["compliance-agents.reason-cancel", "/crm/my-documents"],
  ["compliance-agents.reason-clear", "/admin/compliance/agents"],
  ["compliance-agents.reason-clear", "/crm/compliance/agents"],
  ["compliance-agents.reason-clear", "/crm/my-documents"],
  ["compliance-agents.reason-edit", "/admin/compliance/agents"],
  ["compliance-agents.reason-edit", "/crm/compliance/agents"],
  ["compliance-agents.reason-edit", "/crm/my-documents"],
  ["compliance-agents.reason-notes", "/admin/compliance/agents"],
  ["compliance-agents.reason-notes", "/crm/compliance/agents"],
  ["compliance-agents.reason-notes", "/crm/my-documents"],
  ["compliance-agents.reason-save", "/admin/compliance/agents"],
  ["compliance-agents.reason-save", "/crm/compliance/agents"],
  ["compliance-agents.reason-save", "/crm/my-documents"],
  ["compliance-agents.record-document", "/admin/compliance/agents"],
  ["compliance-agents.record-document", "/crm/compliance/agents"],
  ["compliance-agents.record-document", "/crm/my-documents"],
  ["compliance-agents.removed-toggle", "/admin/compliance/agents"],
  ["compliance-agents.removed-toggle", "/crm/compliance/agents"],
  ["compliance-agents.removed-toggle", "/crm/my-documents"],
  ["compliance-agents.roster-exclusion", "/admin/compliance/agents"],
  ["compliance-agents.roster-exclusion", "/crm/compliance/agents"],
  ["compliance-agents.roster-exclusion", "/crm/my-documents"],
  ["compliance-agents.roster-exclusion-cancel", "/admin/compliance/agents"],
  ["compliance-agents.roster-exclusion-cancel", "/crm/compliance/agents"],
  ["compliance-agents.roster-exclusion-cancel", "/crm/my-documents"],
  ["compliance-agents.roster-exclusion-reason", "/admin/compliance/agents"],
  ["compliance-agents.roster-exclusion-reason", "/crm/compliance/agents"],
  ["compliance-agents.roster-exclusion-reason", "/crm/my-documents"],
  ["compliance-agents.roster-exclusion-save", "/admin/compliance/agents"],
  ["compliance-agents.roster-exclusion-save", "/crm/compliance/agents"],
  ["compliance-agents.roster-exclusion-save", "/crm/my-documents"],
  ["compliance-agents.roster-exclusion-start", "/admin/compliance/agents"],
  ["compliance-agents.roster-exclusion-start", "/crm/compliance/agents"],
  ["compliance-agents.roster-exclusion-start", "/crm/my-documents"],
  ["compliance-agents.roster-restore", "/admin/compliance/agents"],
  ["compliance-agents.roster-restore", "/crm/compliance/agents"],
  ["compliance-agents.roster-restore", "/crm/my-documents"],
  ["compliance-agents.search", "/admin/compliance/agents"],
  ["compliance-agents.search", "/crm/compliance/agents"],
  ["compliance-agents.search", "/crm/my-documents"],
  ["compliance-agents.sort", "/admin/compliance/agents"],
  ["compliance-agents.sort", "/crm/compliance/agents"],
  ["compliance-agents.sort", "/crm/my-documents"],
  ["compliance-agents.status-filter", "/admin/compliance/agents"],
  ["compliance-agents.status-filter", "/crm/compliance/agents"],
  ["compliance-agents.status-filter", "/crm/my-documents"],
  ["compliance-agents.view-file", "/admin/compliance/agents"],
  ["compliance-agents.view-file", "/crm/compliance/agents"],
  ["compliance-agents.view-file", "/crm/my-documents"],
  ["compliance.audit-action-type", "/admin/compliance"],
  ["compliance.audit-action-type", "/crm/oversight/compliance"],
  ["compliance.audit-clear-filters", "/admin/compliance"],
  ["compliance.audit-clear-filters", "/crm/oversight/compliance"],
  ["compliance.audit-export-csv", "/admin/compliance"],
  ["compliance.audit-export-csv", "/crm/oversight/compliance"],
  ["compliance.audit-from", "/admin/compliance"],
  ["compliance.audit-from", "/crm/oversight/compliance"],
  ["compliance.audit-next", "/admin/compliance"],
  ["compliance.audit-next", "/crm/oversight/compliance"],
  ["compliance.audit-previous", "/admin/compliance"],
  ["compliance.audit-previous", "/crm/oversight/compliance"],
  ["compliance.audit-to", "/admin/compliance"],
  ["compliance.audit-to", "/crm/oversight/compliance"],
  ["compliance.cases-clear-filters", "/admin/compliance"],
  ["compliance.cases-clear-filters", "/crm/oversight/compliance"],
  ["compliance.cases-filters", "/admin/compliance"],
  ["compliance.cases-filters", "/crm/oversight/compliance"],
  ["compliance.cases-risk", "/admin/compliance"],
  ["compliance.cases-risk", "/crm/oversight/compliance"],
  ["compliance.cases-search", "/admin/compliance"],
  ["compliance.cases-search", "/crm/oversight/compliance"],
  ["compliance.cases-status", "/admin/compliance"],
  ["compliance.cases-status", "/crm/oversight/compliance"],
  ["compliance.cases-view-deal", "/admin/compliance"],
  ["compliance.cases-view-deal", "/crm/oversight/compliance"],
  ["compliance.costs-check-type", "/admin/compliance"],
  ["compliance.costs-check-type", "/crm/oversight/compliance"],
  ["compliance.costs-clear-filters", "/admin/compliance"],
  ["compliance.costs-clear-filters", "/crm/oversight/compliance"],
  ["compliance.costs-dismiss-error", "/admin/compliance"],
  ["compliance.costs-dismiss-error", "/crm/oversight/compliance"],
  ["compliance.costs-export-excel", "/admin/compliance"],
  ["compliance.costs-export-excel", "/crm/oversight/compliance"],
  ["compliance.costs-from", "/admin/compliance"],
  ["compliance.costs-from", "/crm/oversight/compliance"],
  ["compliance.costs-to", "/admin/compliance"],
  ["compliance.costs-to", "/crm/oversight/compliance"],
  ["compliance.dismiss-error", "/admin/compliance"],
  ["compliance.dismiss-error", "/crm/oversight/compliance"],
  ["compliance.go-to-deals", "/admin/compliance"],
  ["compliance.go-to-deals", "/crm/oversight/compliance"],
  ["compliance.high-risk-approve", "/admin/compliance"],
  ["compliance.high-risk-approve", "/crm/oversight/compliance"],
  ["compliance.high-risk-view", "/admin/compliance"],
  ["compliance.high-risk-view", "/crm/oversight/compliance"],
  ["compliance.monthly-agent", "/admin/compliance"],
  ["compliance.monthly-agent", "/crm/oversight/compliance"],
  ["compliance.monthly-clear-filters", "/admin/compliance"],
  ["compliance.monthly-clear-filters", "/crm/oversight/compliance"],
  ["compliance.monthly-dismiss-error", "/admin/compliance"],
  ["compliance.monthly-dismiss-error", "/crm/oversight/compliance"],
  ["compliance.monthly-download-pdf", "/admin/compliance"],
  ["compliance.monthly-download-pdf", "/crm/oversight/compliance"],
  ["compliance.monthly-month", "/admin/compliance"],
  ["compliance.monthly-month", "/crm/oversight/compliance"],
  ["compliance.monthly-row-pdf", "/admin/compliance"],
  ["compliance.monthly-row-pdf", "/crm/oversight/compliance"],
  ["compliance.rcr-export-excel", "/admin/compliance"],
  ["compliance.rcr-export-excel", "/crm/oversight/compliance"],
  ["compliance.rcr-export-json", "/admin/compliance"],
  ["compliance.rcr-export-json", "/crm/oversight/compliance"],
  ["compliance.rcr-from", "/admin/compliance"],
  ["compliance.rcr-from", "/crm/oversight/compliance"],
  ["compliance.rcr-period", "/admin/compliance"],
  ["compliance.rcr-period", "/crm/oversight/compliance"],
  ["compliance.rcr-submit-link", "/admin/compliance"],
  ["compliance.rcr-submit-link", "/crm/oversight/compliance"],
  ["compliance.rcr-to", "/admin/compliance"],
  ["compliance.rcr-to", "/crm/oversight/compliance"],
  ["compliance.refresh", "/admin/compliance"],
  ["compliance.refresh", "/crm/oversight/compliance"],
  ["compliance.rmcp-approve", "/admin/compliance"],
  ["compliance.rmcp-approve", "/crm/oversight/compliance"],
  ["compliance.rmcp-cancel-edit", "/admin/compliance"],
  ["compliance.rmcp-cancel-edit", "/crm/oversight/compliance"],
  ["compliance.rmcp-delete", "/admin/compliance"],
  ["compliance.rmcp-delete", "/crm/oversight/compliance"],
  ["compliance.rmcp-dismiss-error", "/admin/compliance"],
  ["compliance.rmcp-dismiss-error", "/crm/oversight/compliance"],
  ["compliance.rmcp-edit-section", "/admin/compliance"],
  ["compliance.rmcp-edit-section", "/crm/oversight/compliance"],
  ["compliance.rmcp-export", "/admin/compliance"],
  ["compliance.rmcp-export", "/crm/oversight/compliance"],
  ["compliance.rmcp-export-pdf", "/admin/compliance"],
  ["compliance.rmcp-export-pdf", "/crm/oversight/compliance"],
  ["compliance.rmcp-new-version", "/admin/compliance"],
  ["compliance.rmcp-new-version", "/crm/oversight/compliance"],
  ["compliance.rmcp-review", "/admin/compliance"],
  ["compliance.rmcp-review", "/crm/oversight/compliance"],
  ["compliance.rmcp-save-section", "/admin/compliance"],
  ["compliance.rmcp-save-section", "/crm/oversight/compliance"],
  ["compliance.rmcp-section-text", "/admin/compliance"],
  ["compliance.rmcp-section-text", "/crm/oversight/compliance"],
  ["compliance.scorecard-clear-dates", "/admin/compliance"],
  ["compliance.scorecard-clear-dates", "/crm/oversight/compliance"],
  ["compliance.scorecard-export-csv", "/admin/compliance"],
  ["compliance.scorecard-export-csv", "/crm/oversight/compliance"],
  ["compliance.scorecard-from", "/admin/compliance"],
  ["compliance.scorecard-from", "/crm/oversight/compliance"],
  ["compliance.scorecard-to", "/admin/compliance"],
  ["compliance.scorecard-to", "/crm/oversight/compliance"],
  ["compliance.tab-audit-log", "/admin/compliance"],
  ["compliance.tab-audit-log", "/crm/oversight/compliance"],
  ["compliance.tab-cases", "/admin/compliance"],
  ["compliance.tab-cases", "/crm/oversight/compliance"],
  ["compliance.tab-costs", "/admin/compliance"],
  ["compliance.tab-costs", "/crm/oversight/compliance"],
  ["compliance.tab-high-risk", "/admin/compliance"],
  ["compliance.tab-high-risk", "/crm/oversight/compliance"],
  ["compliance.tab-monitoring", "/admin/compliance"],
  ["compliance.tab-monitoring", "/crm/oversight/compliance"],
  ["compliance.tab-monthly-report", "/admin/compliance"],
  ["compliance.tab-monthly-report", "/crm/oversight/compliance"],
  ["compliance.tab-providers", "/admin/compliance"],
  ["compliance.tab-providers", "/crm/oversight/compliance"],
  ["compliance.tab-rcr", "/admin/compliance"],
  ["compliance.tab-rcr", "/crm/oversight/compliance"],
  ["compliance.tab-rmcp", "/admin/compliance"],
  ["compliance.tab-rmcp", "/crm/oversight/compliance"],
  ["compliance.tab-scorecard", "/admin/compliance"],
  ["compliance.tab-scorecard", "/crm/oversight/compliance"],
  ["compliance.tab-training", "/admin/compliance"],
  ["compliance.tab-training", "/crm/oversight/compliance"],
  ["compliance.training-add-record", "/admin/compliance"],
  ["compliance.training-add-record", "/crm/oversight/compliance"],
  ["compliance.training-agent-id", "/admin/compliance"],
  ["compliance.training-agent-id", "/crm/oversight/compliance"],
  ["compliance.training-cancel", "/admin/compliance"],
  ["compliance.training-cancel", "/crm/oversight/compliance"],
  ["compliance.training-certificate", "/admin/compliance"],
  ["compliance.training-certificate", "/crm/oversight/compliance"],
  ["compliance.training-completion-date", "/admin/compliance"],
  ["compliance.training-completion-date", "/crm/oversight/compliance"],
  ["compliance.training-delete", "/admin/compliance"],
  ["compliance.training-delete", "/crm/oversight/compliance"],
  ["compliance.training-dismiss-error", "/admin/compliance"],
  ["compliance.training-dismiss-error", "/crm/oversight/compliance"],
  ["compliance.training-expiry-date", "/admin/compliance"],
  ["compliance.training-expiry-date", "/crm/oversight/compliance"],
  ["compliance.training-notes", "/admin/compliance"],
  ["compliance.training-notes", "/crm/oversight/compliance"],
  ["compliance.training-save", "/admin/compliance"],
  ["compliance.training-save", "/crm/oversight/compliance"],
  ["compliance.training-type", "/admin/compliance"],
  ["compliance.training-type", "/crm/oversight/compliance"],
  ["connect.advanced", "/admin/connect"],
  ["connect.advanced", "/crm/connect"],
  ["connect.check-connection", "/admin/connect"],
  ["connect.check-connection", "/crm/connect"],
  ["connect.copy-address", "/admin/connect"],
  ["connect.copy-address", "/crm/connect"],
  ["connect.copy-config", "/admin/connect"],
  ["connect.copy-config", "/crm/connect"],
  ["connect.copy-key", "/admin/connect"],
  ["connect.copy-key", "/crm/connect"],
  ["connect.data-account-cancel", "/admin/connect"],
  ["connect.data-account-cancel", "/crm/connect"],
  ["connect.data-account-client-id", "/admin/connect"],
  ["connect.data-account-client-id", "/crm/connect"],
  ["connect.data-account-client-secret", "/admin/connect"],
  ["connect.data-account-client-secret", "/crm/connect"],
  ["connect.data-account-disconnect", "/admin/connect"],
  ["connect.data-account-disconnect", "/crm/connect"],
  ["connect.data-account-link", "/admin/connect"],
  ["connect.data-account-link", "/crm/connect"],
  ["connect.data-account-start", "/admin/connect"],
  ["connect.data-account-start", "/crm/connect"],
  ["connect.disconnect", "/admin/connect"],
  ["connect.disconnect", "/crm/connect"],
  ["connect.generate", "/admin/connect"],
  ["connect.generate", "/crm/connect"],
  ["connect.permission-level", "/admin/connect"],
  ["connect.permission-level", "/crm/connect"],
  ["connect.refresh", "/admin/connect"],
  ["connect.refresh", "/crm/connect"],
  ["connect.setup-card", "/admin/connect"],
  ["connect.setup-card", "/crm/connect"],
  ["connect.show-key", "/admin/connect"],
  ["connect.show-key", "/crm/connect"],
  ["crm-appointments.attendees", "/crm/appointments"],
  ["crm-appointments.cancel", "/crm/appointments"],
  ["crm-appointments.end", "/crm/appointments"],
  ["crm-appointments.enter-buyer", "/crm/appointments"],
  ["crm-appointments.entry", "/crm/appointments"],
  ["crm-appointments.link-add", "/crm/appointments"],
  ["crm-appointments.link-remove", "/crm/appointments"],
  ["crm-appointments.link-result", "/crm/appointments"],
  ["crm-appointments.link-search", "/crm/appointments"],
  ["crm-appointments.location", "/crm/appointments"],
  ["crm-appointments.month-entry", "/crm/appointments"],
  ["crm-appointments.month-more", "/crm/appointments"],
  ["crm-appointments.new-appointment", "/crm/appointments"],
  ["crm-appointments.next", "/crm/appointments"],
  ["crm-appointments.notes", "/crm/appointments"],
  ["crm-appointments.open-in-maps", "/crm/appointments"],
  ["crm-appointments.previous", "/crm/appointments"],
  ["crm-appointments.quick-buyer-back", "/crm/appointments"],
  ["crm-appointments.quick-buyer-cancel", "/crm/appointments"],
  ["crm-appointments.quick-buyer-cell", "/crm/appointments"],
  ["crm-appointments.quick-buyer-create-anyway", "/crm/appointments"],
  ["crm-appointments.quick-buyer-email", "/crm/appointments"],
  ["crm-appointments.quick-buyer-first-name", "/crm/appointments"],
  ["crm-appointments.quick-buyer-save", "/crm/appointments"],
  ["crm-appointments.quick-buyer-surname", "/crm/appointments"],
  ["crm-appointments.quick-buyer-use-contact", "/crm/appointments"],
  ["crm-appointments.quick-buyer-use-lead", "/crm/appointments"],
  ["crm-appointments.save", "/crm/appointments"],
  ["crm-appointments.start", "/crm/appointments"],
  ["crm-appointments.status", "/crm/appointments"],
  ["crm-appointments.title", "/crm/appointments"],
  ["crm-appointments.today", "/crm/appointments"],
  ["crm-appointments.type", "/crm/appointments"],
  ["crm-appointments.view", "/crm/appointments"],
  ["crm-buyers.archived", "/crm/buyers"],
  ["crm-buyers.bulk-actions", "/crm/buyers"],
  ["crm-buyers.clear-filters", "/crm/buyers"],
  ["crm-buyers.clear-search", "/crm/buyers"],
  ["crm-buyers.date-filter", "/crm/buyers"],
  ["crm-buyers.dismiss-notice", "/crm/buyers"],
  ["crm-buyers.empty-new-buyer", "/crm/buyers"],
  ["crm-buyers.form-cancel", "/crm/buyers"],
  ["crm-buyers.form-contact-clear", "/crm/buyers"],
  ["crm-buyers.form-contact-result", "/crm/buyers"],
  ["crm-buyers.form-contact-search", "/crm/buyers"],
  ["crm-buyers.form-details", "/crm/buyers"],
  ["crm-buyers.form-lifestyle", "/crm/buyers"],
  ["crm-buyers.form-looking-for", "/crm/buyers"],
  ["crm-buyers.form-must-sell-first", "/crm/buyers"],
  ["crm-buyers.form-notes", "/crm/buyers"],
  ["crm-buyers.form-save", "/crm/buyers"],
  ["crm-buyers.form-selling-status", "/crm/buyers"],
  ["crm-buyers.form-status", "/crm/buyers"],
  ["crm-buyers.funnel-filter", "/crm/buyers"],
  ["crm-buyers.group-card", "/crm/buyers"],
  ["crm-buyers.group-property", "/crm/buyers"],
  ["crm-buyers.group-row", "/crm/buyers"],
  ["crm-buyers.interest-filter", "/crm/buyers"],
  ["crm-buyers.new-buyer", "/crm/buyers"],
  ["crm-buyers.pages", "/crm/buyers"],
  ["crm-buyers.reassign-agent", "/admin/deals"],
  ["crm-buyers.reassign-agent", "/crm/buyers"],
  ["crm-buyers.reassign-agent", "/crm/deals"],
  ["crm-buyers.reassign-agent", "/crm/listings"],
  ["crm-buyers.reassign-cancel", "/admin/deals"],
  ["crm-buyers.reassign-cancel", "/crm/buyers"],
  ["crm-buyers.reassign-cancel", "/crm/deals"],
  ["crm-buyers.reassign-cancel", "/crm/listings"],
  ["crm-buyers.reassign-confirm", "/admin/deals"],
  ["crm-buyers.reassign-confirm", "/crm/buyers"],
  ["crm-buyers.reassign-confirm", "/crm/deals"],
  ["crm-buyers.reassign-confirm", "/crm/listings"],
  ["crm-buyers.row", "/crm/buyers"],
  ["crm-buyers.search", "/crm/buyers"],
  ["crm-buyers.select-page", "/crm/buyers"],
  ["crm-buyers.select-row", "/crm/buyers"],
  ["crm-buyers.status-filter", "/crm/buyers"],
  ["crm-buyers.type-filter", "/crm/buyers"],
  ["crm-buyers.view-by-buyer", "/crm/buyers"],
  ["crm-buyers.view-by-enquiry", "/crm/buyers"],
  ["crm-canvassing.age-any", "/crm/canvassing"],
  ["crm-canvassing.age-band", "/crm/canvassing"],
  ["crm-canvassing.area", "/crm/canvassing"],
  ["crm-canvassing.canvass-by", "/crm/canvassing"],
  ["crm-canvassing.cell-numbers", "/crm/canvassing"],
  ["crm-canvassing.confirm", "/crm/canvassing"],
  ["crm-canvassing.emails", "/crm/canvassing"],
  ["crm-canvassing.export", "/crm/canvassing"],
  ["crm-canvassing.full-title", "/crm/canvassing"],
  ["crm-canvassing.get-price", "/crm/canvassing"],
  ["crm-canvassing.max-owners", "/crm/canvassing"],
  ["crm-canvassing.order", "/crm/canvassing"],
  ["crm-canvassing.pages", "/crm/canvassing"],
  ["crm-canvassing.property-lookup", "/crm/canvassing"],
  ["crm-canvassing.run", "/crm/canvassing"],
  ["crm-canvassing.run-name", "/crm/canvassing"],
  ["crm-canvassing.save-owner", "/crm/canvassing"],
  ["crm-canvassing.sectional-title", "/crm/canvassing"],
  ["crm-canvassing.sold-any", "/crm/canvassing"],
  ["crm-canvassing.sold-band", "/crm/canvassing"],
  ["crm-commission.clear-filters", "/crm/commission"],
  ["crm-commission.date-from", "/crm/commission"],
  ["crm-commission.date-to", "/crm/commission"],
  ["crm-commission.deal-stage", "/crm/commission"],
  ["crm-commission.deal-status", "/crm/commission"],
  ["crm-commission.filters", "/crm/commission"],
  ["crm-commission.financial-year", "/crm/commission"],
  ["crm-commission.pages", "/crm/commission"],
  ["crm-commission.payment-status", "/crm/commission"],
  ["crm-commission.referral-pagination", "/crm/commission"],
  ["crm-commission.sales-basis", "/crm/commission"],
  ["crm-contacts.archived", "/crm/contacts"],
  ["crm-contacts.clear-filters", "/crm/contacts"],
  ["crm-contacts.clear-search", "/crm/contacts"],
  ["crm-contacts.clear-selection", "/crm/contacts"],
  ["crm-contacts.delete", "/crm/contacts"],
  ["crm-contacts.delete-archive", "/crm/contacts"],
  ["crm-contacts.delete-back-to-archive", "/crm/contacts"],
  ["crm-contacts.delete-cancel", "/crm/contacts"],
  ["crm-contacts.delete-permanent", "/crm/contacts"],
  ["crm-contacts.delete-permanent-confirm", "/crm/contacts"],
  ["crm-contacts.dismiss-notice", "/crm/contacts"],
  ["crm-contacts.empty-new-contact", "/crm/contacts"],
  ["crm-contacts.export", "/admin/agent-usage"],
  ["crm-contacts.export", "/admin/bond-analytics"],
  ["crm-contacts.export", "/admin/pipeline-cashflow"],
  ["crm-contacts.export", "/crm/bond-analytics"],
  ["crm-contacts.export", "/crm/contacts"],
  ["crm-contacts.export", "/crm/listings"],
  ["crm-contacts.export", "/crm/oversight/agent-usage"],
  ["crm-contacts.export", "/crm/oversight/bond-analytics"],
  ["crm-contacts.export", "/crm/oversight/pipeline-cashflow"],
  ["crm-contacts.export-dismiss-error", "/admin/agent-usage"],
  ["crm-contacts.export-dismiss-error", "/admin/bond-analytics"],
  ["crm-contacts.export-dismiss-error", "/admin/pipeline-cashflow"],
  ["crm-contacts.export-dismiss-error", "/crm/bond-analytics"],
  ["crm-contacts.export-dismiss-error", "/crm/contacts"],
  ["crm-contacts.export-dismiss-error", "/crm/listings"],
  ["crm-contacts.export-dismiss-error", "/crm/oversight/agent-usage"],
  ["crm-contacts.export-dismiss-error", "/crm/oversight/bond-analytics"],
  ["crm-contacts.export-dismiss-error", "/crm/oversight/pipeline-cashflow"],
  ["crm-contacts.form-cancel", "/crm/contacts"],
  ["crm-contacts.form-details", "/crm/contacts"],
  ["crm-contacts.form-gender", "/crm/contacts"],
  ["crm-contacts.form-notes", "/crm/contacts"],
  ["crm-contacts.form-opt-in", "/crm/contacts"],
  ["crm-contacts.form-roles", "/crm/contacts"],
  ["crm-contacts.form-save", "/crm/contacts"],
  ["crm-contacts.form-spouse-title", "/crm/contacts"],
  ["crm-contacts.form-title", "/crm/contacts"],
  ["crm-contacts.new-contact", "/crm/contacts"],
  ["crm-contacts.pages", "/crm/contacts"],
  ["crm-contacts.restore", "/crm/contacts"],
  ["crm-contacts.role-filter", "/crm/contacts"],
  ["crm-contacts.row", "/crm/contacts"],
  ["crm-contacts.search", "/crm/contacts"],
  ["crm-contacts.select-all-matching", "/crm/contacts"],
  ["crm-contacts.select-page", "/crm/contacts"],
  ["crm-contacts.select-row", "/crm/contacts"],
  ["crm-contacts.show-inactive", "/crm/contacts"],
  ["crm-contacts.sort-email", "/crm/contacts"],
  ["crm-contacts.sort-name", "/crm/contacts"],
  ["crm-conveyancers.add-contact", "/crm/conveyancers"],
  ["crm-conveyancers.add-conveyancer", "/crm/conveyancers"],
  ["crm-conveyancers.contact-cancel", "/crm/conveyancers"],
  ["crm-conveyancers.contact-cell", "/crm/conveyancers"],
  ["crm-conveyancers.contact-email", "/crm/conveyancers"],
  ["crm-conveyancers.contact-name", "/crm/conveyancers"],
  ["crm-conveyancers.contact-save", "/crm/conveyancers"],
  ["crm-conveyancers.contact-tel", "/crm/conveyancers"],
  ["crm-conveyancers.delete-contact", "/crm/conveyancers"],
  ["crm-conveyancers.delete-firm", "/crm/conveyancers"],
  ["crm-conveyancers.edit-contact", "/crm/conveyancers"],
  ["crm-conveyancers.edit-firm", "/crm/conveyancers"],
  ["crm-conveyancers.firm-address", "/crm/conveyancers"],
  ["crm-conveyancers.firm-cancel", "/crm/conveyancers"],
  ["crm-conveyancers.firm-company-name", "/crm/conveyancers"],
  ["crm-conveyancers.firm-reg-no", "/crm/conveyancers"],
  ["crm-conveyancers.firm-row", "/crm/conveyancers"],
  ["crm-conveyancers.firm-save", "/crm/conveyancers"],
  ["crm-conveyancers.firm-tel", "/crm/conveyancers"],
  ["crm-conveyancers.firm-vat-no", "/crm/conveyancers"],
  ["crm-conveyancers.pages", "/crm/conveyancers"],
  ["crm-conveyancers.search", "/crm/conveyancers"],
  ["crm-dashboard.call-tracker-kpis", "/admin/activity"],
  ["crm-dashboard.call-tracker-kpis", "/crm/dashboard"],
  ["crm-dashboard.call-tracker-kpis", "/crm/farm"],
  ["crm-dashboard.call-tracker-kpis", "/crm/oversight/activity"],
  ["crm-dashboard.canvasser-choose", "/crm/dashboard"],
  ["crm-dashboard.canvasser-grant", "/crm/dashboard"],
  ["crm-dashboard.canvasser-month", "/crm/dashboard"],
  ["crm-dashboard.canvasser-month", "/crm/farm"],
  ["crm-dashboard.canvasser-revoke", "/crm/dashboard"],
  ["crm-dashboard.canvasser-today", "/crm/dashboard"],
  ["crm-dashboard.canvasser-today", "/crm/farm"],
  ["crm-dashboard.canvasser-week", "/crm/dashboard"],
  ["crm-dashboard.canvasser-week", "/crm/farm"],
  ["crm-dashboard.date-from", "/crm/dashboard"],
  ["crm-dashboard.date-range", "/crm/dashboard"],
  ["crm-dashboard.date-to", "/crm/dashboard"],
  ["crm-dashboard.open-calendar", "/crm/dashboard"],
  ["crm-dashboard.reset-range", "/crm/dashboard"],
  ["crm-dashboard.summary-tile", "/crm/dashboard"],
  ["crm-dashboard.target-progress", "/crm/dashboard"],
  ["crm-dashboard.tasks-due", "/crm/dashboard"],
  ["crm-dashboard.view-calendar", "/crm/dashboard"],
  ["crm-deals.add-lease", "/admin/deals"],
  ["crm-deals.add-lease", "/crm/deals"],
  ["crm-deals.add-sale", "/admin/deals"],
  ["crm-deals.add-sale", "/crm/deals"],
  ["crm-deals.archived", "/admin/deals"],
  ["crm-deals.archived", "/crm/deals"],
  ["crm-deals.awaiting-signoff", "/admin/deals"],
  ["crm-deals.awaiting-signoff", "/crm/deals"],
  ["crm-deals.bulk-actions", "/admin/deals"],
  ["crm-deals.bulk-actions", "/crm/deals"],
  ["crm-deals.clear-dates", "/admin/deals"],
  ["crm-deals.clear-dates", "/crm/deals"],
  ["crm-deals.clear-filters", "/admin/deals"],
  ["crm-deals.clear-filters", "/crm/deals"],
  ["crm-deals.clear-search", "/admin/deals"],
  ["crm-deals.clear-search", "/crm/deals"],
  ["crm-deals.date-from", "/admin/deals"],
  ["crm-deals.date-from", "/crm/deals"],
  ["crm-deals.date-to", "/admin/deals"],
  ["crm-deals.date-to", "/crm/deals"],
  ["crm-deals.deal-row", "/admin/deals"],
  ["crm-deals.deal-row", "/crm/deals"],
  ["crm-deals.dismiss-notice", "/admin/deals"],
  ["crm-deals.dismiss-notice", "/crm/deals"],
  ["crm-deals.pages", "/admin/deals"],
  ["crm-deals.pages", "/crm/deals"],
  ["crm-deals.search", "/admin/deals"],
  ["crm-deals.search", "/crm/deals"],
  ["crm-deals.select-deal", "/admin/deals"],
  ["crm-deals.select-deal", "/crm/deals"],
  ["crm-deals.select-page", "/admin/deals"],
  ["crm-deals.select-page", "/crm/deals"],
  ["crm-deals.sort-file-no", "/admin/deals"],
  ["crm-deals.sort-file-no", "/crm/deals"],
  ["crm-deals.status", "/admin/deals"],
  ["crm-deals.status", "/crm/deals"],
  ["crm-deals.working-view", "/admin/deals"],
  ["crm-deals.working-view", "/crm/deals"],
  ["crm-documents.action-delete", "/crm/documents"],
  ["crm-documents.action-edit", "/crm/documents"],
  ["crm-documents.action-generate", "/crm/documents"],
  ["crm-documents.action-preview", "/crm/documents"],
  ["crm-documents.category", "/crm/documents"],
  ["crm-documents.clear-search", "/crm/documents"],
  ["crm-documents.contact-clear", "/crm/documents"],
  ["crm-documents.contact-option", "/crm/documents"],
  ["crm-documents.contact-search", "/crm/documents"],
  ["crm-documents.copy", "/crm/documents"],
  ["crm-documents.delete-cancel", "/crm/documents"],
  ["crm-documents.delete-confirm", "/crm/documents"],
  ["crm-documents.email-template-row", "/crm/documents"],
  ["crm-documents.export-pdf", "/crm/documents"],
  ["crm-documents.export-word", "/crm/documents"],
  ["crm-documents.generate-close", "/crm/documents"],
  ["crm-documents.generate-preview", "/crm/documents"],
  ["crm-documents.generated-vault-link", "/crm/documents"],
  ["crm-documents.new-template", "/crm/documents"],
  ["crm-documents.pages", "/crm/documents"],
  ["crm-documents.prefill-apply", "/crm/documents"],
  ["crm-documents.prefill-close", "/crm/documents"],
  ["crm-documents.prefill-field", "/crm/documents"],
  ["crm-documents.prefill-generate-pdf", "/crm/documents"],
  ["crm-documents.prefill-generate-word", "/crm/documents"],
  ["crm-documents.prefill-open", "/crm/documents"],
  ["crm-documents.prefill-save-to-record", "/crm/documents"],
  ["crm-documents.prefill-template", "/crm/documents"],
  ["crm-documents.preview-close", "/crm/documents"],
  ["crm-documents.preview-close-footer", "/crm/documents"],
  ["crm-documents.property-clear", "/crm/documents"],
  ["crm-documents.property-option", "/crm/documents"],
  ["crm-documents.property-search", "/crm/documents"],
  ["crm-documents.search", "/crm/documents"],
  ["crm-documents.tab-emails", "/crm/documents"],
  ["crm-documents.tab-letters", "/crm/documents"],
  ["crm-documents.template-row", "/crm/documents"],
  ["crm-documents.vault-link", "/crm/documents"],
  ["crm-farm.area", "/crm/farm"],
  ["crm-farm.call-tracker-last-month", "/admin/activity"],
  ["crm-farm.call-tracker-last-month", "/crm/dashboard"],
  ["crm-farm.call-tracker-last-month", "/crm/farm"],
  ["crm-farm.call-tracker-last-month", "/crm/oversight/activity"],
  ["crm-farm.call-tracker-month", "/admin/activity"],
  ["crm-farm.call-tracker-month", "/crm/dashboard"],
  ["crm-farm.call-tracker-month", "/crm/farm"],
  ["crm-farm.call-tracker-month", "/crm/oversight/activity"],
  ["crm-farm.call-tracker-week", "/admin/activity"],
  ["crm-farm.call-tracker-week", "/crm/dashboard"],
  ["crm-farm.call-tracker-week", "/crm/farm"],
  ["crm-farm.call-tracker-week", "/crm/oversight/activity"],
  ["crm-farm.changed-hands", "/crm/farm"],
  ["crm-farm.clear-advanced", "/crm/farm"],
  ["crm-farm.clear-filters", "/crm/farm"],
  ["crm-farm.clear-search", "/crm/farm"],
  ["crm-farm.clear-tags", "/crm/farm"],
  ["crm-farm.contact-number", "/crm/farm"],
  ["crm-farm.erf-max", "/crm/farm"],
  ["crm-farm.erf-min", "/crm/farm"],
  ["crm-farm.filters", "/crm/farm"],
  ["crm-farm.last-contacted", "/crm/farm"],
  ["crm-farm.owner-name", "/crm/farm"],
  ["crm-farm.pages", "/crm/farm"],
  ["crm-farm.price-max", "/crm/farm"],
  ["crm-farm.price-min", "/crm/farm"],
  ["crm-farm.record", "/crm/farm"],
  ["crm-farm.record-row", "/crm/farm"],
  ["crm-farm.registered-after", "/crm/farm"],
  ["crm-farm.registered-before", "/crm/farm"],
  ["crm-farm.search", "/crm/farm"],
  ["crm-farm.show-all", "/crm/farm"],
  ["crm-farm.size-max", "/crm/farm"],
  ["crm-farm.size-min", "/crm/farm"],
  ["crm-farm.sold-by-agency", "/crm/farm"],
  ["crm-farm.sort", "/crm/farm"],
  ["crm-farm.sort-column", "/crm/farm"],
  ["crm-farm.status", "/crm/farm"],
  ["crm-farm.tag", "/crm/farm"],
  ["crm-fica-matrix.open-deal", "/crm/fica-matrix"],
  ["crm-fica-matrix.show-completed", "/crm/fica-matrix"],
  ["crm-finance-deals-lodged.awaiting", "/crm/finance/deals-lodged"],
  ["crm-finance-deals-lodged.open-deal", "/crm/finance/deals-lodged"],
  ["crm-finance-deals-lodged.pagination", "/crm/finance/deals-lodged"],
  ["crm-finance-deals-lodged.registered-history", "/crm/finance/deals-lodged"],
  ["crm-finance-deals-lodged.stage-all", "/crm/finance/deals-lodged"],
  ["crm-finance-deals-lodged.stage-in-prep", "/crm/finance/deals-lodged"],
  ["crm-finance-deals-lodged.stage-lodged", "/crm/finance/deals-lodged"],
  ["crm-finance-fica-outstanding.open-deal", "/crm/finance/fica-outstanding"],
  ["crm-finance-fica-outstanding.open-deal", "/crm/oversight/fica-outstanding"],
  ["crm-kpi-confirm.confirm", "/crm/kpi-confirm"],
  ["crm-kpi-confirm.note", "/crm/kpi-confirm"],
  ["crm-kpi-confirm.reporting-month", "/crm/kpi-confirm"],
  ["crm-kpi-confirm.request-correction", "/crm/kpi-confirm"],
  ["crm-kpis.activity-date", "/crm/kpis"],
  ["crm-kpis.activity-type", "/crm/kpis"],
  ["crm-kpis.count", "/crm/kpis"],
  ["crm-kpis.log-activity", "/crm/kpis"],
  ["crm-kpis.next-month", "/crm/kpis"],
  ["crm-kpis.notes", "/crm/kpis"],
  ["crm-kpis.previous-month", "/crm/kpis"],
  ["crm-kpis.tab-dashboard", "/crm/kpis"],
  ["crm-kpis.tab-log-activity", "/crm/kpis"],
  ["crm-leaderboard.agent-deals", "/crm/leaderboard"],
  ["crm-leaderboard.date-from", "/crm/leaderboard"],
  ["crm-leaderboard.date-range", "/crm/leaderboard"],
  ["crm-leaderboard.date-to", "/crm/leaderboard"],
  ["crm-leaderboard.deals-pager", "/admin/leaderboard"],
  ["crm-leaderboard.deals-pager", "/crm/leaderboard"],
  ["crm-leaderboard.open-deal", "/admin/leaderboard"],
  ["crm-leaderboard.open-deal", "/crm/leaderboard"],
  ["crm-leaderboard.reset-range", "/crm/leaderboard"],
  ["crm-listings-farm-link-suggestions.candidate", "/crm/listings/farm-link-suggestions"],
  ["crm-listings-farm-link-suggestions.confirm", "/crm/listings/farm-link-suggestions"],
  ["crm-listings-farm-link-suggestions.dismiss", "/crm/listings/farm-link-suggestions"],
  ["crm-listings.add-mandate", "/crm/listings"],
  ["crm-listings.agent-filter", "/crm/listings"],
  ["crm-listings.archived", "/crm/listings"],
  ["crm-listings.area-filter", "/crm/listings"],
  ["crm-listings.bulk-actions", "/crm/listings"],
  ["crm-listings.clear-filters", "/crm/listings"],
  ["crm-listings.clear-search", "/crm/listings"],
  ["crm-listings.deal-properties", "/crm/listings"],
  ["crm-listings.dismiss-notice", "/crm/listings"],
  ["crm-listings.empty-new-listing", "/crm/listings"],
  ["crm-listings.form-brochure", "/crm/listings"],
  ["crm-listings.form-cancel", "/crm/listings"],
  ["crm-listings.form-capturing-for", "/crm/listings"],
  ["crm-listings.form-classification", "/crm/listings"],
  ["crm-listings.form-co-agent-add", "/crm/listings"],
  ["crm-listings.form-co-agent-remove", "/crm/listings"],
  ["crm-listings.form-description", "/crm/listings"],
  ["crm-listings.form-details", "/crm/listings"],
  ["crm-listings.form-ensuite", "/crm/listings"],
  ["crm-listings.form-features", "/crm/listings"],
  ["crm-listings.form-garages", "/crm/listings"],
  ["crm-listings.form-notes", "/crm/listings"],
  ["crm-listings.form-pick-property", "/crm/listings"],
  ["crm-listings.form-save", "/crm/listings"],
  ["crm-listings.form-stage-draft", "/crm/listings"],
  ["crm-listings.form-stage-submit", "/crm/listings"],
  ["crm-listings.form-title-deed", "/crm/listings"],
  ["crm-listings.mandate-filter", "/crm/listings"],
  ["crm-listings.mandate-row", "/crm/listings"],
  ["crm-listings.mandate-save", "/crm/listings"],
  ["crm-listings.mandate-set", "/crm/listings"],
  ["crm-listings.mandate-signed-missing", "/crm/listings"],
  ["crm-listings.mandate-sort", "/crm/listings"],
  ["crm-listings.new-listing", "/crm/listings"],
  ["crm-listings.pages", "/crm/listings"],
  ["crm-listings.row", "/crm/listings"],
  ["crm-listings.search", "/crm/listings"],
  ["crm-listings.select-page", "/crm/listings"],
  ["crm-listings.select-row", "/crm/listings"],
  ["crm-listings.sort-address", "/crm/listings"],
  ["crm-listings.sort-price", "/crm/listings"],
  ["crm-listings.sort-status", "/crm/listings"],
  ["crm-listings.source-farm-result", "/crm/listings"],
  ["crm-listings.source-farm-search", "/crm/listings"],
  ["crm-listings.source-loom-list", "/crm/listings"],
  ["crm-listings.source-loom-search", "/crm/listings"],
  ["crm-listings.source-loom-search-button", "/crm/listings"],
  ["crm-listings.source-loom-units", "/crm/listings"],
  ["crm-listings.source-manual-address", "/crm/listings"],
  ["crm-listings.status-filter", "/crm/listings"],
  ["crm-listings.status-tabs", "/crm/listings"],
  ["crm-listings.tab-all-listings", "/crm/listings"],
  ["crm-listings.tab-area-approvals", "/crm/listings"],
  ["crm-listings.tab-missing-mandate", "/crm/listings"],
  ["crm-listings.tab-to-complete", "/crm/listings"],
  ["crm-listings.type-filter", "/crm/listings"],
  ["crm-messaging.cancel", "/crm/messaging"],
  ["crm-messaging.cc", "/crm/messaging"],
  ["crm-messaging.channel-business", "/crm/messaging"],
  ["crm-messaging.channel-email", "/crm/messaging"],
  ["crm-messaging.channel-personal", "/crm/messaging"],
  ["crm-messaging.compose", "/crm/messaging"],
  ["crm-messaging.filter-channel", "/crm/messaging"],
  ["crm-messaging.filter-direction", "/crm/messaging"],
  ["crm-messaging.filter-status", "/crm/messaging"],
  ["crm-messaging.message", "/crm/messaging"],
  ["crm-messaging.pages", "/crm/messaging"],
  ["crm-messaging.recipient", "/crm/messaging"],
  ["crm-messaging.recipient-result", "/crm/messaging"],
  ["crm-messaging.send", "/crm/messaging"],
  ["crm-messaging.subject", "/crm/messaging"],
  ["crm-messaging.template", "/crm/messaging"],
  ["crm-my-documents.close", "/crm/my-documents"],
  ["crm-my-documents.document-number", "/crm/my-documents"],
  ["crm-my-documents.expiry-date", "/crm/my-documents"],
  ["crm-my-documents.file", "/crm/my-documents"],
  ["crm-my-documents.issue-date", "/crm/my-documents"],
  ["crm-my-documents.notes", "/crm/my-documents"],
  ["crm-my-documents.remove", "/crm/my-documents"],
  ["crm-my-documents.save", "/crm/my-documents"],
  ["crm-my-documents.upload", "/crm/my-documents"],
  ["crm-oversight-deal-queue.agent", "/crm/oversight/deal-queue"],
  ["crm-oversight-deal-queue.all-outstanding", "/crm/oversight/deal-queue"],
  ["crm-oversight-deal-queue.area", "/crm/oversight/deal-queue"],
  ["crm-oversight-deal-queue.category", "/crm/oversight/deal-queue"],
  ["crm-oversight-deal-queue.clear-filters", "/crm/oversight/deal-queue"],
  ["crm-oversight-deal-queue.open-file", "/crm/oversight/deal-queue"],
  ["crm-oversight-deal-queue.pages", "/crm/oversight/deal-queue"],
  ["crm-oversight-deal-queue.search-address", "/crm/oversight/deal-queue"],
  ["crm-oversight-deal-queue.sold-from", "/crm/oversight/deal-queue"],
  ["crm-oversight-deal-queue.sold-to", "/crm/oversight/deal-queue"],
  ["crm-oversight-deal-queue.sort", "/crm/oversight/deal-queue"],
  ["crm-property-lookup.address", "/crm/property-lookup"],
  ["crm-property-lookup.area-property", "/crm/property-lookup"],
  ["crm-property-lookup.area-result", "/crm/property-lookup"],
  ["crm-property-lookup.cell-numbers", "/crm/property-lookup"],
  ["crm-property-lookup.confirm-contacts", "/crm/property-lookup"],
  ["crm-property-lookup.confirm-report", "/crm/property-lookup"],
  ["crm-property-lookup.emails", "/crm/property-lookup"],
  ["crm-property-lookup.find-number", "/crm/property-lookup"],
  ["crm-property-lookup.generate-report", "/crm/property-lookup"],
  ["crm-property-lookup.list-this-property", "/crm/property-lookup"],
  ["crm-property-lookup.look-up-contacts", "/crm/property-lookup"],
  ["crm-property-lookup.narrow-number", "/crm/property-lookup"],
  ["crm-property-lookup.report-owners", "/crm/property-lookup"],
  ["crm-property-lookup.result", "/crm/property-lookup"],
  ["crm-property-lookup.saved-report", "/crm/property-lookup"],
  ["crm-property-lookup.search", "/crm/property-lookup"],
  ["crm-property-lookup.show-all-again", "/crm/property-lookup"],
  ["crm-property-lookup.show-more", "/crm/property-lookup"],
  ["crm-property-lookup.show-owner", "/crm/property-lookup"],
  ["crm-referrals.accept", "/crm/referrals"],
  ["crm-referrals.add-new-buyer", "/crm/referrals"],
  ["crm-referrals.add-to-my-buyers", "/crm/referrals"],
  ["crm-referrals.agency-ffc", "/crm/referrals"],
  ["crm-referrals.agency-name", "/crm/referrals"],
  ["crm-referrals.agent", "/crm/referrals"],
  ["crm-referrals.agent-ffc", "/crm/referrals"],
  ["crm-referrals.agent-name", "/crm/referrals"],
  ["crm-referrals.amount", "/crm/referrals"],
  ["crm-referrals.authorise", "/crm/referrals"],
  ["crm-referrals.buyer-import-cancel", "/crm/referrals"],
  ["crm-referrals.buyer-import-choice", "/crm/referrals"],
  ["crm-referrals.buyer-import-confirm", "/crm/referrals"],
  ["crm-referrals.buyer-import-open", "/crm/referrals"],
  ["crm-referrals.cancel", "/crm/referrals"],
  ["crm-referrals.commission-due-only", "/crm/referrals"],
  ["crm-referrals.decline", "/crm/referrals"],
  ["crm-referrals.decline-cancel", "/crm/referrals"],
  ["crm-referrals.decline-confirm", "/crm/referrals"],
  ["crm-referrals.decline-reason", "/crm/referrals"],
  ["crm-referrals.external", "/crm/referrals"],
  ["crm-referrals.invoice-number", "/crm/referrals"],
  ["crm-referrals.mark-paid", "/crm/referrals"],
  ["crm-referrals.my-referral-commissions", "/crm/referrals"],
  ["crm-referrals.new-referral", "/crm/referrals"],
  ["crm-referrals.note", "/crm/referrals"],
  ["crm-referrals.owner-contact", "/crm/referrals"],
  ["crm-referrals.owner-name", "/crm/referrals"],
  ["crm-referrals.paid-to", "/crm/referrals"],
  ["crm-referrals.property-address", "/crm/referrals"],
  ["crm-referrals.send", "/crm/referrals"],
  ["crm-referrals.type", "/crm/referrals"],
  ["crm-referrals.view-buyer", "/crm/referrals"],
  ["crm-settings.anniversary-reminders", "/crm/settings"],
  ["crm-settings.client-birthday-reminders", "/crm/settings"],
  ["crm-settings.confirm-password", "/crm/settings"],
  ["crm-settings.contact-email", "/crm/settings"],
  ["crm-settings.current-password", "/crm/settings"],
  ["crm-settings.email-confirm-password", "/crm/settings"],
  ["crm-settings.first-name", "/crm/settings"],
  ["crm-settings.last-name", "/crm/settings"],
  ["crm-settings.new-deal-alerts", "/crm/settings"],
  ["crm-settings.new-deal-alerts-default", "/crm/settings"],
  ["crm-settings.new-password", "/crm/settings"],
  ["crm-settings.phone", "/crm/settings"],
  ["crm-settings.save-details", "/crm/settings"],
  ["crm-settings.staff-birthday-alerts", "/crm/settings"],
  ["crm-settings.update-password", "/crm/settings"],
  ["crm-targets.financial-year", "/crm/targets"],
  ["crm-targets.refresh", "/crm/targets"],
  ["crm-tasks.cancel", "/crm/tasks"],
  ["crm-tasks.category-deal", "/crm/tasks"],
  ["crm-tasks.celebrations-week", "/crm/tasks"],
  ["crm-tasks.clear-filters", "/crm/tasks"],
  ["crm-tasks.clear-search", "/crm/tasks"],
  ["crm-tasks.description", "/crm/tasks"],
  ["crm-tasks.detail", "/crm/tasks"],
  ["crm-tasks.due-date", "/crm/tasks"],
  ["crm-tasks.due-time", "/crm/tasks"],
  ["crm-tasks.due-today", "/crm/tasks"],
  ["crm-tasks.empty-new-task", "/crm/tasks"],
  ["crm-tasks.empty-show-upcoming", "/crm/tasks"],
  ["crm-tasks.farmbook-follow-ups", "/crm/tasks"],
  ["crm-tasks.form-reminder-type", "/crm/tasks"],
  ["crm-tasks.link-result", "/crm/tasks"],
  ["crm-tasks.link-search", "/crm/tasks"],
  ["crm-tasks.link-type", "/crm/tasks"],
  ["crm-tasks.new-task", "/crm/tasks"],
  ["crm-tasks.overdue", "/crm/tasks"],
  ["crm-tasks.pages", "/crm/tasks"],
  ["crm-tasks.reminder-scope", "/crm/tasks"],
  ["crm-tasks.reminder-settings", "/crm/tasks"],
  ["crm-tasks.reminder-type", "/crm/tasks"],
  ["crm-tasks.remove-link", "/crm/tasks"],
  ["crm-tasks.save", "/crm/tasks"],
  ["crm-tasks.scope", "/crm/tasks"],
  ["crm-tasks.search", "/crm/tasks"],
  ["crm-tasks.show-upcoming", "/crm/tasks"],
  ["crm-tasks.sort-order", "/crm/tasks"],
  ["crm-tasks.status", "/crm/tasks"],
  ["crm-tasks.status-filter", "/crm/tasks"],
  ["crm-tasks.task-row", "/crm/tasks"],
  ["crm-tasks.task-type", "/crm/tasks"],
  ["crm-tasks.team", "/crm/tasks"],
  ["crm-tasks.type", "/crm/tasks"],
  ["crm-tasks.work-category", "/crm/tasks"],
  ["deal-pipeline.agent", "/admin/deal-pipeline"],
  ["deal-pipeline.agent", "/crm/oversight/deal-pipeline"],
  ["deal-pipeline.area", "/admin/deal-pipeline"],
  ["deal-pipeline.area", "/crm/oversight/deal-pipeline"],
  ["deal-pipeline.attorney", "/admin/deal-pipeline"],
  ["deal-pipeline.attorney", "/crm/oversight/deal-pipeline"],
  ["deal-pipeline.card-stage", "/admin/deal-pipeline"],
  ["deal-pipeline.card-stage", "/crm/oversight/deal-pipeline"],
  ["deal-pipeline.card-total", "/admin/deal-pipeline"],
  ["deal-pipeline.card-total", "/crm/oversight/deal-pipeline"],
  ["deal-pipeline.card-value", "/admin/deal-pipeline"],
  ["deal-pipeline.card-value", "/crm/oversight/deal-pipeline"],
  ["deal-pipeline.clear-filters", "/admin/deal-pipeline"],
  ["deal-pipeline.clear-filters", "/crm/oversight/deal-pipeline"],
  ["deal-pipeline.clear-search", "/admin/deal-pipeline"],
  ["deal-pipeline.clear-search", "/crm/oversight/deal-pipeline"],
  ["deal-pipeline.date-from", "/admin/deal-pipeline"],
  ["deal-pipeline.date-from", "/crm/oversight/deal-pipeline"],
  ["deal-pipeline.date-to", "/admin/deal-pipeline"],
  ["deal-pipeline.date-to", "/crm/oversight/deal-pipeline"],
  ["deal-pipeline.deal-card", "/admin/deal-pipeline"],
  ["deal-pipeline.deal-card", "/crm/oversight/deal-pipeline"],
  ["deal-pipeline.deal-row", "/admin/deal-pipeline"],
  ["deal-pipeline.deal-row", "/crm/oversight/deal-pipeline"],
  ["deal-pipeline.pages", "/admin/deal-pipeline"],
  ["deal-pipeline.pages", "/crm/oversight/deal-pipeline"],
  ["deal-pipeline.search", "/admin/deal-pipeline"],
  ["deal-pipeline.search", "/crm/oversight/deal-pipeline"],
  ["deal-pipeline.sort-agent", "/admin/deal-pipeline"],
  ["deal-pipeline.sort-agent", "/crm/oversight/deal-pipeline"],
  ["deal-pipeline.sort-date", "/admin/deal-pipeline"],
  ["deal-pipeline.sort-date", "/crm/oversight/deal-pipeline"],
  ["deal-pipeline.sort-price", "/admin/deal-pipeline"],
  ["deal-pipeline.sort-price", "/crm/oversight/deal-pipeline"],
  ["deal-pipeline.sort-status", "/admin/deal-pipeline"],
  ["deal-pipeline.sort-status", "/crm/oversight/deal-pipeline"],
  ["deals-id.status-legend", "/admin/deal-pipeline"],
  ["deals-id.status-legend", "/admin/pipeline-cashflow"],
  ["deals-id.status-legend", "/crm/oversight/deal-pipeline"],
  ["deals-id.status-legend", "/crm/oversight/pipeline-cashflow"],
  ["deals-id.status-legend", "/legal"],
  ["deals-id.status-legend", "/paralegal"],
  ["document-vault.address", "/admin/document-vault"],
  ["document-vault.address", "/crm/document-vault"],
  ["document-vault.clear-filters", "/admin/document-vault"],
  ["document-vault.clear-filters", "/crm/document-vault"],
  ["document-vault.date-from", "/admin/document-vault"],
  ["document-vault.date-from", "/crm/document-vault"],
  ["document-vault.date-to", "/admin/document-vault"],
  ["document-vault.date-to", "/crm/document-vault"],
  ["document-vault.dismiss-notice", "/admin/document-vault"],
  ["document-vault.dismiss-notice", "/crm/document-vault"],
  ["document-vault.document-card", "/admin/document-vault"],
  ["document-vault.document-card", "/crm/document-vault"],
  ["document-vault.document-row", "/admin/document-vault"],
  ["document-vault.document-row", "/crm/document-vault"],
  ["document-vault.filter-agent", "/admin/document-vault"],
  ["document-vault.filter-agent", "/crm/document-vault"],
  ["document-vault.filter-file", "/admin/document-vault"],
  ["document-vault.filter-file", "/crm/document-vault"],
  ["document-vault.filter-source", "/admin/document-vault"],
  ["document-vault.filter-source", "/crm/document-vault"],
  ["document-vault.filter-type", "/admin/document-vault"],
  ["document-vault.filter-type", "/crm/document-vault"],
  ["document-vault.folder", "/admin/document-vault"],
  ["document-vault.folder", "/crm/document-vault"],
  ["document-vault.folder-upload", "/admin/document-vault"],
  ["document-vault.folder-upload", "/crm/document-vault"],
  ["document-vault.folder-upload-drop", "/admin/document-vault"],
  ["document-vault.folder-upload-drop", "/crm/document-vault"],
  ["document-vault.folders-clear", "/admin/document-vault"],
  ["document-vault.folders-clear", "/crm/document-vault"],
  ["document-vault.folders-filter", "/admin/document-vault"],
  ["document-vault.folders-filter", "/crm/document-vault"],
  ["document-vault.folders-pages", "/admin/document-vault"],
  ["document-vault.folders-pages", "/crm/document-vault"],
  ["document-vault.folders-search", "/admin/document-vault"],
  ["document-vault.folders-search", "/crm/document-vault"],
  ["document-vault.heal-close", "/admin/document-vault"],
  ["document-vault.heal-close", "/crm/document-vault"],
  ["document-vault.heal-upload", "/admin/document-vault"],
  ["document-vault.heal-upload", "/crm/document-vault"],
  ["document-vault.heal-upload-drop", "/admin/document-vault"],
  ["document-vault.heal-upload-drop", "/crm/document-vault"],
  ["document-vault.move-cancel", "/admin/document-vault"],
  ["document-vault.move-cancel", "/crm/document-vault"],
  ["document-vault.move-document", "/admin/document-vault"],
  ["document-vault.move-document", "/crm/document-vault"],
  ["document-vault.move-submit", "/admin/document-vault"],
  ["document-vault.move-submit", "/crm/document-vault"],
  ["document-vault.move-target", "/admin/document-vault"],
  ["document-vault.move-target", "/crm/document-vault"],
  ["document-vault.pages", "/admin/document-vault"],
  ["document-vault.pages", "/crm/document-vault"],
  ["document-vault.remove-document", "/admin/document-vault"],
  ["document-vault.remove-document", "/crm/document-vault"],
  ["document-vault.search", "/admin/document-vault"],
  ["document-vault.search", "/crm/document-vault"],
  ["document-vault.status-group", "/admin/document-vault"],
  ["document-vault.status-group", "/crm/document-vault"],
  ["document-vault.status-group-section", "/admin/document-vault"],
  ["document-vault.status-group-section", "/crm/document-vault"],
  ["document-vault.tab-property-folders", "/admin/document-vault"],
  ["document-vault.tab-property-folders", "/crm/document-vault"],
  ["document-vault.tab-template-library", "/admin/document-vault"],
  ["document-vault.tab-template-library", "/crm/document-vault"],
  ["document-vault.upload", "/admin/document-vault"],
  ["document-vault.upload", "/crm/document-vault"],
  ["document-vault.upload-cancel", "/admin/document-vault"],
  ["document-vault.upload-cancel", "/crm/document-vault"],
  ["document-vault.upload-change-record", "/admin/document-vault"],
  ["document-vault.upload-change-record", "/crm/document-vault"],
  ["document-vault.upload-description", "/admin/document-vault"],
  ["document-vault.upload-description", "/crm/document-vault"],
  ["document-vault.upload-destination", "/admin/document-vault"],
  ["document-vault.upload-destination", "/crm/document-vault"],
  ["document-vault.upload-document-type", "/admin/document-vault"],
  ["document-vault.upload-document-type", "/crm/document-vault"],
  ["document-vault.upload-file", "/admin/document-vault"],
  ["document-vault.upload-file", "/crm/document-vault"],
  ["document-vault.upload-record-option", "/admin/document-vault"],
  ["document-vault.upload-record-option", "/crm/document-vault"],
  ["document-vault.upload-record-search", "/admin/document-vault"],
  ["document-vault.upload-record-search", "/crm/document-vault"],
  ["document-vault.upload-submit", "/admin/document-vault"],
  ["document-vault.upload-submit", "/crm/document-vault"],
  ["farm-book-import.allocate", "/admin/farm-book-import"],
  ["farm-book-import.allocate", "/crm/farm-book-import"],
  ["farm-book-import.allocate-agent", "/admin/farm-book-import"],
  ["farm-book-import.allocate-agent", "/crm/farm-book-import"],
  ["farm-book-import.area", "/admin/farm-book-import"],
  ["farm-book-import.area", "/crm/farm-book-import"],
  ["farm-book-import.cancel", "/admin/farm-book-import"],
  ["farm-book-import.cancel", "/crm/farm-book-import"],
  ["farm-book-import.choose-file", "/admin/farm-book-import"],
  ["farm-book-import.choose-file", "/crm/farm-book-import"],
  ["farm-book-import.file", "/admin/farm-book-import"],
  ["farm-book-import.file", "/crm/farm-book-import"],
  ["farm-book-import.history-pages", "/admin/farm-book-import"],
  ["farm-book-import.history-pages", "/crm/farm-book-import"],
  ["farm-book-import.import", "/admin/farm-book-import"],
  ["farm-book-import.import", "/crm/farm-book-import"],
  ["farm-book-import.preview", "/admin/farm-book-import"],
  ["farm-book-import.preview", "/crm/farm-book-import"],
  ["farm-book-import.remove-file", "/admin/farm-book-import"],
  ["farm-book-import.remove-file", "/crm/farm-book-import"],
  ["farm-book-import.reupload-confirm", "/admin/farm-book-import"],
  ["farm-book-import.reupload-confirm", "/crm/farm-book-import"],
  ["farm-book-import.show-all-areas", "/admin/farm-book-import"],
  ["farm-book-import.show-all-areas", "/crm/farm-book-import"],
  ["feedback-reports.approve", "/admin/feedback/reports"],
  ["feedback-reports.attachment", "/admin/feedback/reports"],
  ["feedback-reports.awaiting-approval-filter", "/admin/feedback/reports"],
  ["feedback-reports.cause-filter", "/admin/feedback/reports"],
  ["feedback-reports.clear-filters", "/admin/feedback/reports"],
  ["feedback-reports.clear-number-search", "/admin/feedback/reports"],
  ["feedback-reports.closeout-cancel", "/admin/feedback/reports"],
  ["feedback-reports.closeout-save", "/admin/feedback/reports"],
  ["feedback-reports.closeout-summary", "/admin/feedback/reports"],
  ["feedback-reports.closeout-verify-link", "/admin/feedback/reports"],
  ["feedback-reports.daily-curation", "/admin/feedback/reports"],
  ["feedback-reports.decision-comment", "/admin/feedback/reports"],
  ["feedback-reports.decline", "/admin/feedback/reports"],
  ["feedback-reports.edit-closeout", "/admin/feedback/reports"],
  ["feedback-reports.fixed-page", "/admin/feedback/reports"],
  ["feedback-reports.issue-link", "/admin/feedback/reports"],
  ["feedback-reports.morning-briefs", "/admin/feedback/reports"],
  ["feedback-reports.number-search", "/admin/feedback/reports"],
  ["feedback-reports.open-issue", "/admin/feedback/reports"],
  ["feedback-reports.pages", "/admin/feedback/reports"],
  ["feedback-reports.post-comment", "/admin/feedback/reports"],
  ["feedback-reports.quick-approve", "/admin/feedback/reports"],
  ["feedback-reports.quick-approve-cancel", "/admin/feedback/reports"],
  ["feedback-reports.quick-approve-comment", "/admin/feedback/reports"],
  ["feedback-reports.quick-approve-confirm", "/admin/feedback/reports"],
  ["feedback-reports.refresh-status", "/admin/feedback/reports"],
  ["feedback-reports.report-card", "/admin/feedback/reports"],
  ["feedback-reports.report-row", "/admin/feedback/reports"],
  ["feedback-reports.root-cause", "/admin/feedback/reports"],
  ["feedback-reports.root-cause-period", "/admin/feedback/reports"],
  ["feedback-reports.root-cause-summary", "/admin/feedback/reports"],
  ["feedback-reports.source-filter", "/admin/feedback/reports"],
  ["feedback-reports.status-filter", "/admin/feedback/reports"],
  ["feedback-reports.technical-details", "/admin/feedback/reports"],
  ["feedback-reports.type-filter", "/admin/feedback/reports"],
  ["feedback-reports.verify-live", "/admin/feedback/reports"],
  ["finance-accounts.commission-approvals", "/finance-accounts"],
  ["finance-accounts.tab-accounts", "/finance-accounts"],
  ["finance-accounts.tab-finance", "/finance-accounts"],
  ["finance.cancel-generate", "/finance"],
  ["finance.cancel-generate", "/finance-accounts"],
  ["finance.cancel-payment", "/finance"],
  ["finance.cancel-payment", "/finance-accounts"],
  ["finance.commission-approvals", "/finance"],
  ["finance.commission-approvals", "/finance-accounts"],
  ["finance.confirm-generate", "/finance"],
  ["finance.confirm-generate", "/finance-accounts"],
  ["finance.confirm-payment", "/finance"],
  ["finance.confirm-payment", "/finance-accounts"],
  ["finance.deposit-add", "/finance"],
  ["finance.deposit-add", "/finance-accounts"],
  ["finance.deposit-deal-pick", "/finance"],
  ["finance.deposit-deal-pick", "/finance-accounts"],
  ["finance.deposit-deal-search", "/finance"],
  ["finance.deposit-deal-search", "/finance-accounts"],
  ["finance.deposit-edit", "/finance"],
  ["finance.deposit-edit", "/finance-accounts"],
  ["finance.deposits-pagination", "/finance"],
  ["finance.deposits-pagination", "/finance-accounts"],
  ["finance.filter-agent", "/finance"],
  ["finance.filter-agent", "/finance-accounts"],
  ["finance.generate-run", "/finance"],
  ["finance.generate-run", "/finance-accounts"],
  ["finance.interest-filter-all", "/finance"],
  ["finance.interest-filter-all", "/finance-accounts"],
  ["finance.interest-filter-to-invest", "/finance"],
  ["finance.interest-filter-to-invest", "/finance-accounts"],
  ["finance.interest-filter-to-withdraw", "/finance"],
  ["finance.interest-filter-to-withdraw", "/finance-accounts"],
  ["finance.mark-paid", "/finance"],
  ["finance.mark-paid", "/finance-accounts"],
  ["finance.new-deal", "/finance"],
  ["finance.new-deal", "/finance-accounts"],
  ["finance.new-deal-capture", "/finance"],
  ["finance.new-deal-capture", "/finance-accounts"],
  ["finance.new-deal-mobile", "/finance"],
  ["finance.new-deal-mobile", "/finance-accounts"],
  ["finance.new-deal-sheet", "/finance"],
  ["finance.new-deal-sheet", "/finance-accounts"],
  ["finance.new-deals-from", "/finance"],
  ["finance.new-deals-from", "/finance-accounts"],
  ["finance.new-deals-pagination", "/finance"],
  ["finance.new-deals-pagination", "/finance-accounts"],
  ["finance.new-deals-reset", "/finance"],
  ["finance.new-deals-reset", "/finance-accounts"],
  ["finance.new-deals-to", "/finance"],
  ["finance.new-deals-to", "/finance-accounts"],
  ["finance.open-commission-sheet", "/finance"],
  ["finance.open-commission-sheet", "/finance-accounts"],
  ["finance.payment-date", "/finance"],
  ["finance.payment-date", "/finance-accounts"],
  ["finance.payment-method", "/finance"],
  ["finance.payment-method", "/finance-accounts"],
  ["finance.payment-reference", "/finance"],
  ["finance.payment-reference", "/finance-accounts"],
  ["finance.payout-deal", "/finance"],
  ["finance.payout-deal", "/finance-accounts"],
  ["finance.payout-deal-mobile", "/finance"],
  ["finance.payout-deal-mobile", "/finance-accounts"],
  ["finance.period-add", "/accounts"],
  ["finance.period-add", "/finance"],
  ["finance.period-add", "/finance-accounts"],
  ["finance.period-balance", "/accounts"],
  ["finance.period-balance", "/finance"],
  ["finance.period-balance", "/finance-accounts"],
  ["finance.period-cancel", "/accounts"],
  ["finance.period-cancel", "/finance"],
  ["finance.period-cancel", "/finance-accounts"],
  ["finance.period-delete", "/accounts"],
  ["finance.period-delete", "/finance"],
  ["finance.period-delete", "/finance-accounts"],
  ["finance.period-edit", "/accounts"],
  ["finance.period-edit", "/finance"],
  ["finance.period-edit", "/finance-accounts"],
  ["finance.period-end", "/accounts"],
  ["finance.period-end", "/finance"],
  ["finance.period-end", "/finance-accounts"],
  ["finance.period-rate", "/accounts"],
  ["finance.period-rate", "/finance"],
  ["finance.period-rate", "/finance-accounts"],
  ["finance.period-save", "/accounts"],
  ["finance.period-save", "/finance"],
  ["finance.period-save", "/finance-accounts"],
  ["finance.period-start", "/accounts"],
  ["finance.period-start", "/finance"],
  ["finance.period-start", "/finance-accounts"],
  ["finance.rate-change", "/accounts"],
  ["finance.rate-change", "/finance"],
  ["finance.rate-change", "/finance-accounts"],
  ["finance.rate-change-cancel", "/accounts"],
  ["finance.rate-change-cancel", "/finance"],
  ["finance.rate-change-cancel", "/finance-accounts"],
  ["finance.rate-change-date", "/accounts"],
  ["finance.rate-change-date", "/finance"],
  ["finance.rate-change-date", "/finance-accounts"],
  ["finance.rate-change-rate", "/accounts"],
  ["finance.rate-change-rate", "/finance"],
  ["finance.rate-change-rate", "/finance-accounts"],
  ["finance.rate-change-save", "/accounts"],
  ["finance.rate-change-save", "/finance"],
  ["finance.rate-change-save", "/finance-accounts"],
  ["finance.record-authority", "/accounts"],
  ["finance.record-authority", "/finance"],
  ["finance.record-authority", "/finance-accounts"],
  ["finance.record-authority-date", "/accounts"],
  ["finance.record-authority-date", "/finance"],
  ["finance.record-authority-date", "/finance-accounts"],
  ["finance.record-close", "/accounts"],
  ["finance.record-close", "/finance"],
  ["finance.record-close", "/finance-accounts"],
  ["finance.record-fica", "/accounts"],
  ["finance.record-fica", "/finance"],
  ["finance.record-fica", "/finance-accounts"],
  ["finance.record-fica-date", "/accounts"],
  ["finance.record-fica-date", "/finance"],
  ["finance.record-fica-date", "/finance-accounts"],
  ["finance.record-generate-authority", "/accounts"],
  ["finance.record-generate-authority", "/finance"],
  ["finance.record-generate-authority", "/finance-accounts"],
  ["finance.record-invested-date", "/accounts"],
  ["finance.record-invested-date", "/finance"],
  ["finance.record-invested-date", "/finance-accounts"],
  ["finance.record-notes", "/accounts"],
  ["finance.record-notes", "/finance"],
  ["finance.record-notes", "/finance-accounts"],
  ["finance.record-rate", "/accounts"],
  ["finance.record-rate", "/finance"],
  ["finance.record-rate", "/finance-accounts"],
  ["finance.record-released-date", "/accounts"],
  ["finance.record-released-date", "/finance"],
  ["finance.record-released-date", "/finance-accounts"],
  ["finance.record-save", "/accounts"],
  ["finance.record-save", "/finance"],
  ["finance.record-save", "/finance-accounts"],
  ["finance.referral-cancel-paid", "/finance"],
  ["finance.referral-cancel-paid", "/finance-accounts"],
  ["finance.referral-confirm-paid", "/finance"],
  ["finance.referral-confirm-paid", "/finance-accounts"],
  ["finance.referral-deal", "/finance"],
  ["finance.referral-deal", "/finance-accounts"],
  ["finance.referral-mark-paid", "/finance"],
  ["finance.referral-mark-paid", "/finance-accounts"],
  ["finance.referral-paid-date", "/finance"],
  ["finance.referral-paid-date", "/finance-accounts"],
  ["finance.registered-deal", "/finance"],
  ["finance.registered-deal", "/finance-accounts"],
  ["finance.registered-deal-mobile", "/finance"],
  ["finance.registered-deal-mobile", "/finance-accounts"],
  ["finance.registered-pagination", "/finance"],
  ["finance.registered-pagination", "/finance-accounts"],
  ["finance.run-date", "/finance"],
  ["finance.run-date", "/finance-accounts"],
  ["finance.run-label", "/finance"],
  ["finance.run-label", "/finance-accounts"],
  ["finance.summary-commission-authorizations", "/finance"],
  ["finance.summary-commission-authorizations", "/finance-accounts"],
  ["finance.summary-deposits-to-invest", "/finance"],
  ["finance.summary-deposits-to-invest", "/finance-accounts"],
  ["finance.summary-deposits-to-withdraw", "/finance"],
  ["finance.summary-deposits-to-withdraw", "/finance-accounts"],
  ["finance.summary-lodged-deals", "/finance"],
  ["finance.summary-lodged-deals", "/finance-accounts"],
  ["finance.summary-registered-deals", "/finance"],
  ["finance.summary-registered-deals", "/finance-accounts"],
  ["finance.tab-authorized", "/finance"],
  ["finance.tab-authorized", "/finance-accounts"],
  ["finance.tab-deposits", "/finance"],
  ["finance.tab-deposits", "/finance-accounts"],
  ["finance.tab-new-deals", "/finance"],
  ["finance.tab-new-deals", "/finance-accounts"],
  ["finance.tab-referrals", "/finance"],
  ["finance.tab-referrals", "/finance-accounts"],
  ["finance.tab-registered", "/finance"],
  ["finance.tab-registered", "/finance-accounts"],
  ["finance.tab-runs", "/finance"],
  ["finance.tab-runs", "/finance-accounts"],
  ["hr-templates.delete", "/admin/hr-templates"],
  ["hr-templates.delete", "/crm/hr-templates"],
  ["hr-templates.delete-cancel", "/admin/hr-templates"],
  ["hr-templates.delete-cancel", "/crm/hr-templates"],
  ["hr-templates.delete-confirm", "/admin/hr-templates"],
  ["hr-templates.delete-confirm", "/crm/hr-templates"],
  ["hr-templates.file", "/admin/hr-templates"],
  ["hr-templates.file", "/crm/hr-templates"],
  ["hr-templates.name", "/admin/hr-templates"],
  ["hr-templates.name", "/crm/hr-templates"],
  ["hr-templates.upload", "/admin/hr-templates"],
  ["hr-templates.upload", "/crm/hr-templates"],
  ["hr-templates.view", "/admin/hr-templates"],
  ["hr-templates.view", "/crm/hr-templates"],
  ["kpi-exceptions.acknowledge", "/admin/kpi-exceptions"],
  ["kpi-exceptions.acknowledge", "/crm/oversight/kpi-exceptions"],
  ["kpi-exceptions.category", "/admin/kpi-exceptions"],
  ["kpi-exceptions.category", "/crm/oversight/kpi-exceptions"],
  ["kpi-exceptions.correction-cancel", "/admin/kpi-exceptions"],
  ["kpi-exceptions.correction-cancel", "/crm/oversight/kpi-exceptions"],
  ["kpi-exceptions.correction-save", "/admin/kpi-exceptions"],
  ["kpi-exceptions.correction-save", "/crm/oversight/kpi-exceptions"],
  ["kpi-exceptions.description", "/admin/kpi-exceptions"],
  ["kpi-exceptions.description", "/crm/oversight/kpi-exceptions"],
  ["kpi-exceptions.new-value", "/admin/kpi-exceptions"],
  ["kpi-exceptions.new-value", "/crm/oversight/kpi-exceptions"],
  ["kpi-exceptions.old-value", "/admin/kpi-exceptions"],
  ["kpi-exceptions.old-value", "/crm/oversight/kpi-exceptions"],
  ["kpi-exceptions.record-correction", "/admin/kpi-exceptions"],
  ["kpi-exceptions.record-correction", "/crm/oversight/kpi-exceptions"],
  ["kpi-exceptions.reopen", "/admin/kpi-exceptions"],
  ["kpi-exceptions.reopen", "/crm/oversight/kpi-exceptions"],
  ["kpi-exceptions.reporting-month", "/admin/kpi-exceptions"],
  ["kpi-exceptions.reporting-month", "/crm/oversight/kpi-exceptions"],
  ["kpi-exceptions.what-corrected", "/admin/kpi-exceptions"],
  ["kpi-exceptions.what-corrected", "/crm/oversight/kpi-exceptions"],
  ["kpi-metrics.active", "/admin/kpi-metrics"],
  ["kpi-metrics.active", "/crm/oversight/kpi-metrics"],
  ["kpi-metrics.advanced-scoring", "/admin/kpi-metrics"],
  ["kpi-metrics.advanced-scoring", "/crm/oversight/kpi-metrics"],
  ["kpi-metrics.base-points", "/admin/kpi-metrics"],
  ["kpi-metrics.base-points", "/crm/oversight/kpi-metrics"],
  ["kpi-metrics.cancel", "/admin/kpi-metrics"],
  ["kpi-metrics.cancel", "/crm/oversight/kpi-metrics"],
  ["kpi-metrics.close", "/admin/kpi-metrics"],
  ["kpi-metrics.close", "/crm/oversight/kpi-metrics"],
  ["kpi-metrics.confirm", "/admin/kpi-metrics"],
  ["kpi-metrics.confirm", "/crm/oversight/kpi-metrics"],
  ["kpi-metrics.confirm-cancel", "/admin/kpi-metrics"],
  ["kpi-metrics.confirm-cancel", "/crm/oversight/kpi-metrics"],
  ["kpi-metrics.description", "/admin/kpi-metrics"],
  ["kpi-metrics.description", "/crm/oversight/kpi-metrics"],
  ["kpi-metrics.discard-draft", "/admin/kpi-metrics"],
  ["kpi-metrics.discard-draft", "/crm/oversight/kpi-metrics"],
  ["kpi-metrics.display-order", "/admin/kpi-metrics"],
  ["kpi-metrics.display-order", "/crm/oversight/kpi-metrics"],
  ["kpi-metrics.edit-metric", "/admin/kpi-metrics"],
  ["kpi-metrics.edit-metric", "/crm/oversight/kpi-metrics"],
  ["kpi-metrics.extra-per-million", "/admin/kpi-metrics"],
  ["kpi-metrics.extra-per-million", "/crm/oversight/kpi-metrics"],
  ["kpi-metrics.group", "/admin/kpi-metrics"],
  ["kpi-metrics.group", "/crm/oversight/kpi-metrics"],
  ["kpi-metrics.impact-cancel", "/admin/kpi-metrics"],
  ["kpi-metrics.impact-cancel", "/crm/oversight/kpi-metrics"],
  ["kpi-metrics.monthly-target", "/admin/kpi-metrics"],
  ["kpi-metrics.monthly-target", "/crm/oversight/kpi-metrics"],
  ["kpi-metrics.name", "/admin/kpi-metrics"],
  ["kpi-metrics.name", "/crm/oversight/kpi-metrics"],
  ["kpi-metrics.new-metric", "/admin/kpi-metrics"],
  ["kpi-metrics.new-metric", "/crm/oversight/kpi-metrics"],
  ["kpi-metrics.points", "/admin/kpi-metrics"],
  ["kpi-metrics.points", "/crm/oversight/kpi-metrics"],
  ["kpi-metrics.publish-draft", "/admin/kpi-metrics"],
  ["kpi-metrics.publish-draft", "/crm/oversight/kpi-metrics"],
  ["kpi-metrics.publish-now", "/admin/kpi-metrics"],
  ["kpi-metrics.publish-now", "/crm/oversight/kpi-metrics"],
  ["kpi-metrics.remove-metric", "/admin/kpi-metrics"],
  ["kpi-metrics.remove-metric", "/crm/oversight/kpi-metrics"],
  ["kpi-metrics.restore-defaults", "/admin/kpi-metrics"],
  ["kpi-metrics.restore-defaults", "/crm/oversight/kpi-metrics"],
  ["kpi-metrics.save", "/admin/kpi-metrics"],
  ["kpi-metrics.save", "/crm/oversight/kpi-metrics"],
  ["kpi-metrics.save-as-draft", "/admin/kpi-metrics"],
  ["kpi-metrics.save-as-draft", "/crm/oversight/kpi-metrics"],
  ["kpi-metrics.split", "/admin/kpi-metrics"],
  ["kpi-metrics.split", "/crm/oversight/kpi-metrics"],
  ["kpi-metrics.tracked-action", "/admin/kpi-metrics"],
  ["kpi-metrics.tracked-action", "/crm/oversight/kpi-metrics"],
  ["kpi-metrics.tracking-auto", "/admin/kpi-metrics"],
  ["kpi-metrics.tracking-auto", "/crm/oversight/kpi-metrics"],
  ["kpi-metrics.tracking-manual", "/admin/kpi-metrics"],
  ["kpi-metrics.tracking-manual", "/crm/oversight/kpi-metrics"],
  ["kpi-metrics.unit", "/admin/kpi-metrics"],
  ["kpi-metrics.unit", "/crm/oversight/kpi-metrics"],
  ["kpi-metrics.value-scaled", "/admin/kpi-metrics"],
  ["kpi-metrics.value-scaled", "/crm/oversight/kpi-metrics"],
  ["kpi-monthly-files.column-field", "/admin/kpi-upload"],
  ["kpi-monthly-files.column-field", "/crm/oversight/kpi-upload"],
  ["kpi-monthly-files.columns", "/admin/kpi-upload"],
  ["kpi-monthly-files.columns", "/crm/oversight/kpi-upload"],
  ["kpi-monthly-files.mapping-cancel", "/admin/kpi-upload"],
  ["kpi-monthly-files.mapping-cancel", "/crm/oversight/kpi-upload"],
  ["kpi-monthly-files.new-month", "/admin/kpi-upload"],
  ["kpi-monthly-files.new-month", "/crm/oversight/kpi-upload"],
  ["kpi-monthly-files.new-month-cancel", "/admin/kpi-upload"],
  ["kpi-monthly-files.new-month-cancel", "/crm/oversight/kpi-upload"],
  ["kpi-monthly-files.new-month-open", "/admin/kpi-upload"],
  ["kpi-monthly-files.new-month-open", "/crm/oversight/kpi-upload"],
  ["kpi-monthly-files.open-month", "/admin/kpi-upload"],
  ["kpi-monthly-files.open-month", "/crm/oversight/kpi-upload"],
  ["kpi-monthly-files.preview", "/admin/kpi-upload"],
  ["kpi-monthly-files.preview", "/crm/oversight/kpi-upload"],
  ["kpi-monthly-files.preview-pages", "/admin/kpi-upload"],
  ["kpi-monthly-files.preview-pages", "/crm/oversight/kpi-upload"],
  ["kpi-monthly-files.reporting-date", "/admin/kpi-upload"],
  ["kpi-monthly-files.reporting-date", "/crm/oversight/kpi-upload"],
  ["kpi-monthly-files.reporting-month", "/admin/kpi-upload"],
  ["kpi-monthly-files.reporting-month", "/crm/oversight/kpi-upload"],
  ["kpi-monthly-files.save-mapping", "/admin/kpi-upload"],
  ["kpi-monthly-files.save-mapping", "/crm/oversight/kpi-upload"],
  ["kpi-monthly-files.upload-file", "/admin/kpi-upload"],
  ["kpi-monthly-files.upload-file", "/crm/oversight/kpi-upload"],
  ["kpi-scorecard.capture-correction", "/admin/kpi-scorecard"],
  ["kpi-scorecard.capture-correction", "/crm/oversight/kpi-scorecard"],
  ["kpi-scorecard.cc-management", "/admin/kpi-scorecard"],
  ["kpi-scorecard.cc-management", "/crm/oversight/kpi-scorecard"],
  ["kpi-scorecard.correction-activity", "/admin/kpi-scorecard"],
  ["kpi-scorecard.correction-activity", "/crm/oversight/kpi-scorecard"],
  ["kpi-scorecard.correction-corrected", "/admin/kpi-scorecard"],
  ["kpi-scorecard.correction-corrected", "/crm/oversight/kpi-scorecard"],
  ["kpi-scorecard.correction-original", "/admin/kpi-scorecard"],
  ["kpi-scorecard.correction-original", "/crm/oversight/kpi-scorecard"],
  ["kpi-scorecard.correction-reason", "/admin/kpi-scorecard"],
  ["kpi-scorecard.correction-reason", "/crm/oversight/kpi-scorecard"],
  ["kpi-scorecard.denominator", "/admin/kpi-scorecard"],
  ["kpi-scorecard.denominator", "/crm/oversight/kpi-scorecard"],
  ["kpi-scorecard.export-excel", "/admin/kpi-scorecard"],
  ["kpi-scorecard.export-excel", "/crm/oversight/kpi-scorecard"],
  ["kpi-scorecard.export-pdf", "/admin/kpi-scorecard"],
  ["kpi-scorecard.export-pdf", "/crm/oversight/kpi-scorecard"],
  ["kpi-scorecard.lock", "/admin/kpi-scorecard"],
  ["kpi-scorecard.lock", "/crm/oversight/kpi-scorecard"],
  ["kpi-scorecard.lock-override", "/admin/kpi-scorecard"],
  ["kpi-scorecard.lock-override", "/crm/oversight/kpi-scorecard"],
  ["kpi-scorecard.mark-applied", "/admin/kpi-scorecard"],
  ["kpi-scorecard.mark-applied", "/crm/oversight/kpi-scorecard"],
  ["kpi-scorecard.reporting-month", "/admin/kpi-scorecard"],
  ["kpi-scorecard.reporting-month", "/crm/oversight/kpi-scorecard"],
  ["kpi-scorecard.send-confirmations", "/admin/kpi-scorecard"],
  ["kpi-scorecard.send-confirmations", "/crm/oversight/kpi-scorecard"],
  ["kpi-scorecard.tab-confirmations", "/admin/kpi-scorecard"],
  ["kpi-scorecard.tab-confirmations", "/crm/oversight/kpi-scorecard"],
  ["kpi-scorecard.tab-involved", "/admin/kpi-scorecard"],
  ["kpi-scorecard.tab-involved", "/crm/oversight/kpi-scorecard"],
  ["kpi-scorecard.tab-property", "/admin/kpi-scorecard"],
  ["kpi-scorecard.tab-property", "/crm/oversight/kpi-scorecard"],
  ["kpi-scorecard.tab-rolling", "/admin/kpi-scorecard"],
  ["kpi-scorecard.tab-rolling", "/crm/oversight/kpi-scorecard"],
  ["kpi-scorecard.tab-scorecard", "/admin/kpi-scorecard"],
  ["kpi-scorecard.tab-scorecard", "/crm/oversight/kpi-scorecard"],
  ["kpi-tiers.agent-tier", "/admin/kpi-tiers"],
  ["kpi-tiers.agent-tier", "/crm/oversight/kpi-tiers"],
  ["kpi-tiers.cancel", "/admin/kpi-tiers"],
  ["kpi-tiers.cancel", "/crm/oversight/kpi-tiers"],
  ["kpi-tiers.default-tier", "/admin/kpi-tiers"],
  ["kpi-tiers.default-tier", "/crm/oversight/kpi-tiers"],
  ["kpi-tiers.delete-tier", "/admin/kpi-tiers"],
  ["kpi-tiers.delete-tier", "/crm/oversight/kpi-tiers"],
  ["kpi-tiers.display-order", "/admin/kpi-tiers"],
  ["kpi-tiers.display-order", "/crm/oversight/kpi-tiers"],
  ["kpi-tiers.edit-target", "/admin/kpi-tiers"],
  ["kpi-tiers.edit-target", "/crm/oversight/kpi-tiers"],
  ["kpi-tiers.edit-tier", "/admin/kpi-tiers"],
  ["kpi-tiers.edit-tier", "/crm/oversight/kpi-tiers"],
  ["kpi-tiers.monthly-target", "/admin/kpi-tiers"],
  ["kpi-tiers.monthly-target", "/crm/oversight/kpi-tiers"],
  ["kpi-tiers.new-tier", "/admin/kpi-tiers"],
  ["kpi-tiers.new-tier", "/crm/oversight/kpi-tiers"],
  ["kpi-tiers.save", "/admin/kpi-tiers"],
  ["kpi-tiers.save", "/crm/oversight/kpi-tiers"],
  ["kpi-tiers.tier-name", "/admin/kpi-tiers"],
  ["kpi-tiers.tier-name", "/crm/oversight/kpi-tiers"],
  ["kpis.agent-card", "/admin/kpis"],
  ["kpis.agent-card", "/crm/oversight/kpis"],
  ["kpis.agent-row", "/admin/kpis"],
  ["kpis.agent-row", "/crm/oversight/kpis"],
  ["kpis.average-score", "/admin/kpis"],
  ["kpis.average-score", "/crm/oversight/kpis"],
  ["kpis.column-toggle", "/admin/kpis"],
  ["kpis.column-toggle", "/crm/oversight/kpis"],
  ["kpis.columns", "/admin/kpis"],
  ["kpis.columns", "/crm/oversight/kpis"],
  ["kpis.data-source", "/admin/kpis"],
  ["kpis.data-source", "/crm/oversight/kpis"],
  ["kpis.dismiss-export-error", "/admin/kpis"],
  ["kpis.dismiss-export-error", "/crm/oversight/kpis"],
  ["kpis.dismiss-send-error", "/admin/kpis"],
  ["kpis.dismiss-send-error", "/crm/oversight/kpis"],
  ["kpis.dismiss-send-result", "/admin/kpis"],
  ["kpis.dismiss-send-result", "/crm/oversight/kpis"],
  ["kpis.export-all-csv", "/admin/kpis"],
  ["kpis.export-all-csv", "/crm/oversight/kpis"],
  ["kpis.export-csv", "/admin/kpis"],
  ["kpis.export-csv", "/crm/oversight/kpis"],
  ["kpis.manage-tiers", "/admin/kpis"],
  ["kpis.manage-tiers", "/crm/oversight/kpis"],
  ["kpis.meeting-target", "/admin/kpis"],
  ["kpis.meeting-target", "/crm/oversight/kpis"],
  ["kpis.next-month", "/admin/kpis"],
  ["kpis.next-month", "/crm/oversight/kpis"],
  ["kpis.previous-month", "/admin/kpis"],
  ["kpis.previous-month", "/crm/oversight/kpis"],
  ["kpis.print", "/admin/kpis"],
  ["kpis.print", "/crm/oversight/kpis"],
  ["kpis.send-cancel", "/admin/kpis"],
  ["kpis.send-cancel", "/crm/oversight/kpis"],
  ["kpis.send-confirm", "/admin/kpis"],
  ["kpis.send-confirm", "/crm/oversight/kpis"],
  ["kpis.send-reports", "/admin/kpis"],
  ["kpis.send-reports", "/crm/oversight/kpis"],
  ["kpis.sort-column", "/admin/kpis"],
  ["kpis.sort-column", "/crm/oversight/kpis"],
  ["kpis.total-agents", "/admin/kpis"],
  ["kpis.total-agents", "/crm/oversight/kpis"],
  ["leases.agent", "/admin/leases"],
  ["leases.agent", "/crm/leases"],
  ["leases.close", "/admin/leases"],
  ["leases.close", "/crm/leases"],
  ["leases.close-cancel", "/admin/leases"],
  ["leases.close-cancel", "/crm/leases"],
  ["leases.close-confirm", "/admin/leases"],
  ["leases.close-confirm", "/crm/leases"],
  ["leases.close-reason", "/admin/leases"],
  ["leases.close-reason", "/crm/leases"],
  ["leases.open-deal", "/admin/leases"],
  ["leases.open-deal", "/crm/leases"],
  ["leases.open-renewal", "/admin/leases"],
  ["leases.open-renewal", "/crm/leases"],
  ["leases.pages", "/admin/leases"],
  ["leases.pages", "/crm/leases"],
  ["leases.reopen", "/admin/leases"],
  ["leases.reopen", "/crm/leases"],
  ["leases.view", "/admin/leases"],
  ["leases.view", "/crm/leases"],
  ["legal.open-file", "/legal"],
  ["legal.pages", "/legal"],
  ["listing-to-registration.date-from", "/admin/listing-to-registration"],
  ["listing-to-registration.date-to", "/admin/listing-to-registration"],
  ["listing-to-registration.mode-fy", "/admin/listing-to-registration"],
  ["listing-to-registration.mode-range", "/admin/listing-to-registration"],
  ["listing-to-registration.open-deal", "/admin/listing-to-registration"],
  ["listing-to-registration.pagination", "/admin/listing-to-registration"],
  ["listing-to-registration.year", "/admin/listing-to-registration"],
  ["management.accept", "/management"],
  ["management.accept-mobile", "/management"],
  ["management.cancel-send-back", "/management"],
  ["management.cancellation-approve", "/management"],
  ["management.cancellation-approve-mobile", "/management"],
  ["management.cancellation-close", "/management"],
  ["management.cancellation-open-deal", "/management"],
  ["management.cancellation-open-deal-mobile", "/management"],
  ["management.cancellation-reason", "/management"],
  ["management.cancellation-reject", "/management"],
  ["management.cancellation-reject-mobile", "/management"],
  ["management.cancellation-reopen-status", "/management"],
  ["management.cancellation-submit", "/management"],
  ["management.confirm-send-back", "/management"],
  ["management.send-back", "/management"],
  ["management.send-back-mobile", "/management"],
  ["management.send-back-reason", "/management"],
  ["management.view-deeds-report", "/management"],
  ["management.view-signed-otp", "/management"],
  ["market-share.financial-year", "/admin/market-share"],
  ["market-share.financial-year", "/crm/market-share"],
  ["market-share.financial-year", "/crm/oversight/market-share"],
  ["market-share.monthly", "/admin/market-share"],
  ["market-share.monthly", "/crm/market-share"],
  ["market-share.monthly", "/crm/oversight/market-share"],
  ["market-share.refresh", "/admin/market-share"],
  ["market-share.refresh", "/crm/market-share"],
  ["market-share.refresh", "/crm/oversight/market-share"],
  ["market-share.trend", "/admin/market-share"],
  ["market-share.trend", "/crm/market-share"],
  ["market-share.trend", "/crm/oversight/market-share"],
  ["market-share.try-again", "/admin/market-share"],
  ["market-share.try-again", "/crm/market-share"],
  ["market-share.try-again", "/crm/oversight/market-share"],
  ["market-share.year", "/admin/market-share"],
  ["market-share.year", "/crm/market-share"],
  ["market-share.year", "/crm/oversight/market-share"],
  ["monthly-deals.agent", "/admin/monthly-deals"],
  ["monthly-deals.agent", "/crm/oversight/monthly-deals"],
  ["monthly-deals.area", "/admin/monthly-deals"],
  ["monthly-deals.area", "/crm/oversight/monthly-deals"],
  ["monthly-deals.date-from", "/admin/monthly-deals"],
  ["monthly-deals.date-from", "/crm/oversight/monthly-deals"],
  ["monthly-deals.date-to", "/admin/monthly-deals"],
  ["monthly-deals.date-to", "/crm/oversight/monthly-deals"],
  ["monthly-deals.deal-type", "/admin/monthly-deals"],
  ["monthly-deals.deal-type", "/crm/oversight/monthly-deals"],
  ["monthly-deals.section", "/admin/monthly-deals"],
  ["monthly-deals.section", "/crm/oversight/monthly-deals"],
  ["outstanding-deals.age", "/admin/outstanding-deals"],
  ["outstanding-deals.age", "/crm/outstanding-deals"],
  ["outstanding-deals.export", "/admin/outstanding-deals"],
  ["outstanding-deals.export", "/crm/outstanding-deals"],
  ["outstanding-deals.export-excel", "/admin/outstanding-deals"],
  ["outstanding-deals.export-excel", "/crm/outstanding-deals"],
  ["outstanding-deals.export-pdf", "/admin/outstanding-deals"],
  ["outstanding-deals.export-pdf", "/crm/outstanding-deals"],
  ["outstanding-deals.filter", "/admin/outstanding-deals"],
  ["outstanding-deals.filter", "/crm/outstanding-deals"],
  ["outstanding-deals.pages", "/admin/outstanding-deals"],
  ["outstanding-deals.pages", "/crm/outstanding-deals"],
  ["outstanding-deals.sort", "/admin/outstanding-deals"],
  ["outstanding-deals.sort", "/crm/outstanding-deals"],
  ["overrider-schedules.active", "/admin/overrider-schedules"],
  ["overrider-schedules.add", "/admin/overrider-schedules"],
  ["overrider-schedules.add-band", "/admin/overrider-schedules"],
  ["overrider-schedules.applies-to", "/admin/overrider-schedules"],
  ["overrider-schedules.band-amount", "/admin/overrider-schedules"],
  ["overrider-schedules.band-lower", "/admin/overrider-schedules"],
  ["overrider-schedules.band-upper", "/admin/overrider-schedules"],
  ["overrider-schedules.beneficiary", "/admin/overrider-schedules"],
  ["overrider-schedules.delete", "/admin/overrider-schedules"],
  ["overrider-schedules.delete-cancel", "/admin/overrider-schedules"],
  ["overrider-schedules.delete-confirm", "/admin/overrider-schedules"],
  ["overrider-schedules.edit", "/admin/overrider-schedules"],
  ["overrider-schedules.form-cancel", "/admin/overrider-schedules"],
  ["overrider-schedules.form-save", "/admin/overrider-schedules"],
  ["overrider-schedules.name", "/admin/overrider-schedules"],
  ["overrider-schedules.remove-band", "/admin/overrider-schedules"],
  ["paralegal.address-search", "/paralegal"],
  ["paralegal.capture-add-lease", "/admin/users"],
  ["paralegal.capture-add-lease", "/crm/users"],
  ["paralegal.capture-add-lease", "/management"],
  ["paralegal.capture-add-lease", "/paralegal"],
  ["paralegal.capture-add-listing", "/admin/users"],
  ["paralegal.capture-add-listing", "/crm/users"],
  ["paralegal.capture-add-listing", "/management"],
  ["paralegal.capture-add-listing", "/paralegal"],
  ["paralegal.capture-add-sale", "/admin/users"],
  ["paralegal.capture-add-sale", "/crm/users"],
  ["paralegal.capture-add-sale", "/management"],
  ["paralegal.capture-add-sale", "/paralegal"],
  ["paralegal.capture-on-behalf", "/admin/users"],
  ["paralegal.capture-on-behalf", "/crm/users"],
  ["paralegal.capture-on-behalf", "/management"],
  ["paralegal.capture-on-behalf", "/paralegal"],
  ["paralegal.clear-filters", "/paralegal"],
  ["paralegal.filter-agent", "/paralegal"],
  ["paralegal.filter-area", "/paralegal"],
  ["paralegal.filter-category", "/paralegal"],
  ["paralegal.needs-attention-deal", "/paralegal"],
  ["paralegal.open-deal", "/paralegal"],
  ["paralegal.tab-all", "/paralegal"],
  ["paralegal.tab-in-prep", "/paralegal"],
  ["paralegal.tab-lodged", "/paralegal"],
  ["paralegal.tab-registered", "/paralegal"],
  ["paralegal.widget-row", "/paralegal"],
  ["partners.active", "/admin/partners"],
  ["partners.active", "/crm/partners"],
  ["partners.add-firm", "/admin/partners"],
  ["partners.add-firm", "/crm/partners"],
  ["partners.conveyancer-result", "/admin/partners"],
  ["partners.conveyancer-result", "/crm/partners"],
  ["partners.firm-email", "/admin/partners"],
  ["partners.firm-email", "/crm/partners"],
  ["partners.firm-name", "/admin/partners"],
  ["partners.firm-name", "/crm/partners"],
  ["partners.firm-name-field", "/admin/partners"],
  ["partners.firm-name-field", "/crm/partners"],
  ["partners.firm-type", "/admin/partners"],
  ["partners.firm-type", "/crm/partners"],
  ["partners.firm-type-filter", "/admin/partners"],
  ["partners.firm-type-filter", "/crm/partners"],
  ["partners.form-cancel", "/admin/partners"],
  ["partners.form-cancel", "/crm/partners"],
  ["partners.form-save", "/admin/partners"],
  ["partners.form-save", "/crm/partners"],
  ["partners.linked-conveyancer", "/admin/partners"],
  ["partners.linked-conveyancer", "/crm/partners"],
  ["partners.open-card", "/admin/partners"],
  ["partners.open-card", "/crm/partners"],
  ["partners.open-row", "/admin/partners"],
  ["partners.open-row", "/crm/partners"],
  ["partners.pages", "/admin/partners"],
  ["partners.pages", "/crm/partners"],
  ["partners.phone", "/admin/partners"],
  ["partners.phone", "/crm/partners"],
  ["partners.remove-conveyancer", "/admin/partners"],
  ["partners.remove-conveyancer", "/crm/partners"],
  ["partners.search", "/admin/partners"],
  ["partners.search", "/crm/partners"],
  ["partners.show-contact", "/admin/partners"],
  ["partners.show-contact", "/crm/partners"],
  ["partners.status-filter", "/admin/partners"],
  ["partners.status-filter", "/crm/partners"],
  ["partners.try-again", "/admin/partners"],
  ["partners.try-again", "/crm/partners"],
  ["payslips.agent", "/admin/payslips"],
  ["payslips.agent", "/crm/payslips"],
  ["payslips.cancel-resend", "/admin/payslips"],
  ["payslips.cancel-resend", "/crm/payslips"],
  ["payslips.confirm-resend", "/admin/payslips"],
  ["payslips.confirm-resend", "/crm/payslips"],
  ["payslips.download-again", "/admin/payslips"],
  ["payslips.download-again", "/crm/payslips"],
  ["payslips.generate", "/admin/payslips"],
  ["payslips.generate", "/crm/payslips"],
  ["payslips.month", "/admin/payslips"],
  ["payslips.month", "/crm/payslips"],
  ["payslips.refresh", "/admin/payslips"],
  ["payslips.refresh", "/crm/payslips"],
  ["payslips.resend", "/admin/payslips"],
  ["payslips.resend", "/crm/payslips"],
  ["payslips.retry-agents", "/admin/payslips"],
  ["payslips.retry-agents", "/crm/payslips"],
  ["payslips.row-download", "/admin/payslips"],
  ["payslips.row-download", "/crm/payslips"],
  ["payslips.row-download-mobile", "/admin/payslips"],
  ["payslips.row-download-mobile", "/crm/payslips"],
  ["payslips.year", "/admin/payslips"],
  ["payslips.year", "/crm/payslips"],
  ["pipeline-cashflow.agent", "/admin/pipeline-cashflow"],
  ["pipeline-cashflow.agent", "/crm/oversight/pipeline-cashflow"],
  ["pipeline-cashflow.approve-cancellation", "/admin/pipeline-cashflow"],
  ["pipeline-cashflow.approve-cancellation", "/crm/oversight/pipeline-cashflow"],
  ["pipeline-cashflow.area", "/admin/pipeline-cashflow"],
  ["pipeline-cashflow.area", "/crm/oversight/pipeline-cashflow"],
  ["pipeline-cashflow.cancellation-close", "/admin/pipeline-cashflow"],
  ["pipeline-cashflow.cancellation-close", "/crm/oversight/pipeline-cashflow"],
  ["pipeline-cashflow.cancellation-reason", "/admin/pipeline-cashflow"],
  ["pipeline-cashflow.cancellation-reason", "/crm/oversight/pipeline-cashflow"],
  ["pipeline-cashflow.cancellation-reopen-status", "/admin/pipeline-cashflow"],
  ["pipeline-cashflow.cancellation-reopen-status", "/crm/oversight/pipeline-cashflow"],
  ["pipeline-cashflow.cancellation-submit", "/admin/pipeline-cashflow"],
  ["pipeline-cashflow.cancellation-submit", "/crm/oversight/pipeline-cashflow"],
  ["pipeline-cashflow.current-fy", "/admin/pipeline-cashflow"],
  ["pipeline-cashflow.current-fy", "/crm/oversight/pipeline-cashflow"],
  ["pipeline-cashflow.date-from", "/admin/pipeline-cashflow"],
  ["pipeline-cashflow.date-from", "/crm/oversight/pipeline-cashflow"],
  ["pipeline-cashflow.date-to", "/admin/pipeline-cashflow"],
  ["pipeline-cashflow.date-to", "/crm/oversight/pipeline-cashflow"],
  ["pipeline-cashflow.pages", "/admin/pipeline-cashflow"],
  ["pipeline-cashflow.pages", "/crm/oversight/pipeline-cashflow"],
  ["pipeline-cashflow.reject-cancellation", "/admin/pipeline-cashflow"],
  ["pipeline-cashflow.reject-cancellation", "/crm/oversight/pipeline-cashflow"],
  ["pipeline-cashflow.reopen", "/admin/pipeline-cashflow"],
  ["pipeline-cashflow.reopen", "/crm/oversight/pipeline-cashflow"],
  ["pipeline-cashflow.status", "/admin/pipeline-cashflow"],
  ["pipeline-cashflow.status", "/crm/oversight/pipeline-cashflow"],
  ["training.add-first-item", "/admin/training"],
  ["training.add-first-item", "/crm/training"],
  ["training.add-item", "/admin/training"],
  ["training.add-item", "/crm/training"],
  ["training.choice-add", "/admin/training"],
  ["training.choice-add", "/crm/training"],
  ["training.choice-correct", "/admin/training"],
  ["training.choice-correct", "/crm/training"],
  ["training.choice-remove", "/admin/training"],
  ["training.choice-remove", "/crm/training"],
  ["training.choice-text", "/admin/training"],
  ["training.choice-text", "/crm/training"],
  ["training.form-cancel", "/admin/training"],
  ["training.form-cancel", "/crm/training"],
  ["training.form-category", "/admin/training"],
  ["training.form-category", "/crm/training"],
  ["training.form-close", "/admin/training"],
  ["training.form-close", "/crm/training"],
  ["training.form-description", "/admin/training"],
  ["training.form-description", "/crm/training"],
  ["training.form-file", "/admin/training"],
  ["training.form-file", "/crm/training"],
  ["training.form-new-category", "/admin/training"],
  ["training.form-new-category", "/crm/training"],
  ["training.form-order", "/admin/training"],
  ["training.form-order", "/crm/training"],
  ["training.form-save", "/admin/training"],
  ["training.form-save", "/crm/training"],
  ["training.form-source-embed", "/admin/training"],
  ["training.form-source-embed", "/crm/training"],
  ["training.form-source-upload", "/admin/training"],
  ["training.form-source-upload", "/crm/training"],
  ["training.form-title", "/admin/training"],
  ["training.form-title", "/crm/training"],
  ["training.form-video-url", "/admin/training"],
  ["training.form-video-url", "/crm/training"],
  ["training.form-visible", "/admin/training"],
  ["training.form-visible", "/crm/training"],
  ["training.guide-link", "/admin/training"],
  ["training.guide-link", "/crm/training"],
  ["training.guide-link-external", "/admin/training"],
  ["training.guide-link-external", "/crm/training"],
  ["training.item-card", "/admin/training"],
  ["training.item-card", "/crm/training"],
  ["training.manage-questionnaire", "/admin/training"],
  ["training.manage-questionnaire", "/crm/training"],
  ["training.mark-complete", "/admin/training"],
  ["training.mark-complete", "/crm/training"],
  ["training.question-add", "/admin/training"],
  ["training.question-add", "/crm/training"],
  ["training.question-remove", "/admin/training"],
  ["training.question-remove", "/crm/training"],
  ["training.question-text", "/admin/training"],
  ["training.question-text", "/crm/training"],
  ["training.questionnaire-active", "/admin/training"],
  ["training.questionnaire-active", "/crm/training"],
  ["training.questionnaire-cancel", "/admin/training"],
  ["training.questionnaire-cancel", "/crm/training"],
  ["training.questionnaire-delete", "/admin/training"],
  ["training.questionnaire-delete", "/crm/training"],
  ["training.questionnaire-pass-mark", "/admin/training"],
  ["training.questionnaire-pass-mark", "/crm/training"],
  ["training.questionnaire-save", "/admin/training"],
  ["training.questionnaire-save", "/crm/training"],
  ["training.questionnaire-title", "/admin/training"],
  ["training.questionnaire-title", "/crm/training"],
  ["training.quiz-answer", "/admin/training"],
  ["training.quiz-answer", "/crm/training"],
  ["training.quiz-cancel", "/admin/training"],
  ["training.quiz-cancel", "/crm/training"],
  ["training.quiz-close", "/admin/training"],
  ["training.quiz-close", "/crm/training"],
  ["training.quiz-retake", "/admin/training"],
  ["training.quiz-retake", "/crm/training"],
  ["training.quiz-submit", "/admin/training"],
  ["training.quiz-submit", "/crm/training"],
  ["training.tab-ai", "/admin/training"],
  ["training.tab-ai", "/crm/training"],
  ["training.tab-crm-howto", "/admin/training"],
  ["training.tab-crm-howto", "/crm/training"],
  ["training.take-questionnaire", "/admin/training"],
  ["training.take-questionnaire", "/crm/training"],
  ["training.viewer-close", "/admin/training"],
  ["training.viewer-close", "/crm/training"],
  ["training.viewer-download", "/admin/training"],
  ["training.viewer-download", "/crm/training"],
  ["users.add-user", "/admin/users"],
  ["users.add-user", "/crm/users"],
  ["users.areas-add", "/admin/users"],
  ["users.areas-add", "/crm/users"],
  ["users.areas-allocate", "/admin/users"],
  ["users.areas-allocate", "/crm/users"],
  ["users.areas-area", "/admin/users"],
  ["users.areas-area", "/crm/users"],
  ["users.areas-remove", "/admin/users"],
  ["users.areas-remove", "/crm/users"],
  ["users.areas-user", "/admin/users"],
  ["users.areas-user", "/crm/users"],
  ["users.create-team", "/admin/users"],
  ["users.create-team", "/crm/users"],
  ["users.delete-team", "/admin/users"],
  ["users.delete-team", "/crm/users"],
  ["users.duplicate-create-anyway", "/admin/users"],
  ["users.duplicate-create-anyway", "/crm/users"],
  ["users.duplicate-reactivate", "/admin/users"],
  ["users.duplicate-reactivate", "/crm/users"],
  ["users.edit-team", "/admin/users"],
  ["users.edit-team", "/crm/users"],
  ["users.edit-user", "/admin/users"],
  ["users.edit-user", "/crm/users"],
  ["users.form-active", "/admin/users"],
  ["users.form-active", "/crm/users"],
  ["users.form-cancel", "/admin/users"],
  ["users.form-cancel", "/crm/users"],
  ["users.form-canvasser-agent", "/admin/users"],
  ["users.form-canvasser-agent", "/crm/users"],
  ["users.form-custom-permission", "/admin/users"],
  ["users.form-custom-permission", "/crm/users"],
  ["users.form-designation", "/admin/users"],
  ["users.form-designation", "/crm/users"],
  ["users.form-email", "/admin/users"],
  ["users.form-email", "/crm/users"],
  ["users.form-email-templates", "/admin/users"],
  ["users.form-email-templates", "/crm/users"],
  ["users.form-farm-view-only", "/admin/users"],
  ["users.form-farm-view-only", "/crm/users"],
  ["users.form-farm-wide-canvass", "/admin/users"],
  ["users.form-farm-wide-canvass", "/crm/users"],
  ["users.form-first-name", "/admin/users"],
  ["users.form-first-name", "/crm/users"],
  ["users.form-hide-from-agent-rosters", "/admin/users"],
  ["users.form-hide-from-agent-rosters", "/crm/users"],
  ["users.form-last-name", "/admin/users"],
  ["users.form-last-name", "/crm/users"],
  ["users.form-password", "/admin/users"],
  ["users.form-password", "/crm/users"],
  ["users.form-phone", "/admin/users"],
  ["users.form-phone", "/crm/users"],
  ["users.form-preset", "/admin/users"],
  ["users.form-preset", "/crm/users"],
  ["users.form-role", "/admin/users"],
  ["users.form-role", "/crm/users"],
  ["users.form-save", "/admin/users"],
  ["users.form-save", "/crm/users"],
  ["users.form-team", "/admin/users"],
  ["users.form-team", "/crm/users"],
  ["users.form-username", "/admin/users"],
  ["users.form-username", "/crm/users"],
  ["users.invite-link", "/admin/users"],
  ["users.invite-link", "/crm/users"],
  ["users.invite-link-copy", "/admin/users"],
  ["users.invite-link-copy", "/crm/users"],
  ["users.invite-notice-dismiss", "/admin/users"],
  ["users.invite-notice-dismiss", "/crm/users"],
  ["users.pages", "/admin/users"],
  ["users.pages", "/crm/users"],
  ["users.role-filter", "/admin/users"],
  ["users.role-filter", "/crm/users"],
  ["users.search", "/admin/users"],
  ["users.search", "/crm/users"],
  ["users.send-invite", "/admin/users"],
  ["users.send-invite", "/crm/users"],
  ["users.status-filter", "/admin/users"],
  ["users.status-filter", "/crm/users"],
  ["users.tab-farm-areas", "/admin/users"],
  ["users.tab-farm-areas", "/crm/users"],
  ["users.tab-owner-lookups", "/admin/users"],
  ["users.tab-owner-lookups", "/crm/users"],
  ["users.tab-teams", "/admin/users"],
  ["users.tab-teams", "/crm/users"],
  ["users.tab-users", "/admin/users"],
  ["users.tab-users", "/crm/users"],
  ["users.team-add-member", "/admin/users"],
  ["users.team-add-member", "/crm/users"],
  ["users.team-add-member-select", "/admin/users"],
  ["users.team-add-member-select", "/crm/users"],
  ["users.team-cancel", "/admin/users"],
  ["users.team-cancel", "/crm/users"],
  ["users.team-description", "/admin/users"],
  ["users.team-description", "/crm/users"],
  ["users.team-name", "/admin/users"],
  ["users.team-name", "/crm/users"],
  ["users.team-remove-member", "/admin/users"],
  ["users.team-remove-member", "/crm/users"],
  ["users.team-row", "/admin/users"],
  ["users.team-row", "/crm/users"],
  ["users.team-save", "/admin/users"],
  ["users.team-save", "/crm/users"],
  ["users.toggle-active", "/admin/users"],
  ["users.toggle-active", "/crm/users"],
  ["users.top-up", "/admin/users"],
  ["users.top-up", "/crm/users"],
  ["users.top-up-amount", "/admin/users"],
  ["users.top-up-amount", "/crm/users"],
  ["users.top-up-cancel", "/admin/users"],
  ["users.top-up-cancel", "/crm/users"],
  ["users.top-up-reason", "/admin/users"],
  ["users.top-up-reason", "/crm/users"],
  ["users.top-up-submit", "/admin/users"],
  ["users.top-up-submit", "/crm/users"],
  ["users.view-as", "/admin/users"],
  ["users.view-as", "/crm/users"],
];

/**
 * Documented `data-help` anchors on record pages: the anchor, the record route
 * pattern it lives on, and the static page that grants access to those records.
 * Pointable only on the record page the user is already on (#3633).
 */
export const RECORD_HELP_ANCHORS: ReadonlyArray<
  readonly [anchor: string, pattern: string, page: string]
> = [
  ["activity.date-month", "/admin/deals/:id", "/admin/deals"],
  ["activity.date-month", "/crm/buyers/:id", "/crm/buyers"],
  ["activity.date-month", "/crm/deals/:id", "/crm/deals"],
  ["activity.date-month", "/crm/farm/:id", "/crm/farm"],
  ["activity.date-month", "/crm/listings/:id", "/crm/listings"],
  ["activity.date-month", "/crm/tasks/:id", "/crm/tasks"],
  ["activity.date-month", "/legal/:otpId", "/legal"],
  ["activity.date-today", "/admin/deals/:id", "/admin/deals"],
  ["activity.date-today", "/crm/buyers/:id", "/crm/buyers"],
  ["activity.date-today", "/crm/deals/:id", "/crm/deals"],
  ["activity.date-today", "/crm/farm/:id", "/crm/farm"],
  ["activity.date-today", "/crm/listings/:id", "/crm/listings"],
  ["activity.date-today", "/crm/tasks/:id", "/crm/tasks"],
  ["activity.date-today", "/legal/:otpId", "/legal"],
  ["activity.date-year", "/admin/deals/:id", "/admin/deals"],
  ["activity.date-year", "/crm/buyers/:id", "/crm/buyers"],
  ["activity.date-year", "/crm/deals/:id", "/crm/deals"],
  ["activity.date-year", "/crm/farm/:id", "/crm/farm"],
  ["activity.date-year", "/crm/listings/:id", "/crm/listings"],
  ["activity.date-year", "/crm/tasks/:id", "/crm/tasks"],
  ["activity.date-year", "/legal/:otpId", "/legal"],
  ["admin-commission.statement-excel", "/admin/deals/:id", "/admin/deals"],
  ["admin-commission.statement-excel", "/crm/deals/:id", "/crm/deals"],
  ["admin-commission.statement-export", "/admin/deals/:id", "/admin/deals"],
  ["admin-commission.statement-export", "/crm/deals/:id", "/crm/deals"],
  ["admin-commission.statement-pdf", "/admin/deals/:id", "/admin/deals"],
  ["admin-commission.statement-pdf", "/crm/deals/:id", "/crm/deals"],
  ["admin-commission.statement-send", "/admin/deals/:id", "/admin/deals"],
  ["admin-commission.statement-send", "/crm/deals/:id", "/crm/deals"],
  ["admin-commission.statement-send-cancel", "/admin/deals/:id", "/admin/deals"],
  ["admin-commission.statement-send-cancel", "/crm/deals/:id", "/crm/deals"],
  ["admin-commission.statement-send-confirm", "/admin/deals/:id", "/admin/deals"],
  ["admin-commission.statement-send-confirm", "/crm/deals/:id", "/crm/deals"],
  ["admin-integrations.consent-notice-view-terms", "/crm/listings/:id", "/crm/listings"],
  ["compliance-agents.download-file", "/admin/deals/:id", "/admin/deals"],
  ["compliance-agents.download-file", "/crm/buyers/:id", "/crm/buyers"],
  ["compliance-agents.download-file", "/crm/contacts/:id", "/crm/contacts"],
  ["compliance-agents.download-file", "/crm/deals/:id", "/crm/deals"],
  ["compliance-agents.download-file", "/crm/farm/:id", "/crm/farm"],
  ["compliance-agents.download-file", "/crm/listings/:id", "/crm/listings"],
  ["compliance-agents.download-file", "/legal/:otpId", "/legal"],
  ["compliance-agents.preview-close", "/admin/deals/:id", "/admin/deals"],
  ["compliance-agents.preview-close", "/crm/buyers/:id", "/crm/buyers"],
  ["compliance-agents.preview-close", "/crm/contacts/:id", "/crm/contacts"],
  ["compliance-agents.preview-close", "/crm/deals/:id", "/crm/deals"],
  ["compliance-agents.preview-close", "/crm/farm/:id", "/crm/farm"],
  ["compliance-agents.preview-close", "/crm/listings/:id", "/crm/listings"],
  ["compliance-agents.preview-close", "/legal/:otpId", "/legal"],
  ["compliance-agents.preview-download", "/admin/deals/:id", "/admin/deals"],
  ["compliance-agents.preview-download", "/crm/buyers/:id", "/crm/buyers"],
  ["compliance-agents.preview-download", "/crm/contacts/:id", "/crm/contacts"],
  ["compliance-agents.preview-download", "/crm/deals/:id", "/crm/deals"],
  ["compliance-agents.preview-download", "/crm/farm/:id", "/crm/farm"],
  ["compliance-agents.preview-download", "/crm/listings/:id", "/crm/listings"],
  ["compliance-agents.preview-download", "/legal/:otpId", "/legal"],
  ["compliance-agents.preview-open-tab", "/admin/deals/:id", "/admin/deals"],
  ["compliance-agents.preview-open-tab", "/crm/buyers/:id", "/crm/buyers"],
  ["compliance-agents.preview-open-tab", "/crm/contacts/:id", "/crm/contacts"],
  ["compliance-agents.preview-open-tab", "/crm/deals/:id", "/crm/deals"],
  ["compliance-agents.preview-open-tab", "/crm/farm/:id", "/crm/farm"],
  ["compliance-agents.preview-open-tab", "/crm/listings/:id", "/crm/listings"],
  ["compliance-agents.preview-open-tab", "/legal/:otpId", "/legal"],
  ["crm-appointments.attendees", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-appointments.attendees", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-appointments.attendees", "/crm/listings/:id", "/crm/listings"],
  ["crm-appointments.cancel", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-appointments.cancel", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-appointments.cancel", "/crm/listings/:id", "/crm/listings"],
  ["crm-appointments.end", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-appointments.end", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-appointments.end", "/crm/listings/:id", "/crm/listings"],
  ["crm-appointments.enter-buyer", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-appointments.enter-buyer", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-appointments.enter-buyer", "/crm/listings/:id", "/crm/listings"],
  ["crm-appointments.link-add", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-appointments.link-add", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-appointments.link-add", "/crm/listings/:id", "/crm/listings"],
  ["crm-appointments.link-remove", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-appointments.link-remove", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-appointments.link-remove", "/crm/listings/:id", "/crm/listings"],
  ["crm-appointments.link-result", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-appointments.link-result", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-appointments.link-result", "/crm/listings/:id", "/crm/listings"],
  ["crm-appointments.link-search", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-appointments.link-search", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-appointments.link-search", "/crm/listings/:id", "/crm/listings"],
  ["crm-appointments.location", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-appointments.location", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-appointments.location", "/crm/listings/:id", "/crm/listings"],
  ["crm-appointments.notes", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-appointments.notes", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-appointments.notes", "/crm/listings/:id", "/crm/listings"],
  ["crm-appointments.open-in-maps", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-appointments.open-in-maps", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-appointments.open-in-maps", "/crm/listings/:id", "/crm/listings"],
  ["crm-appointments.quick-buyer-back", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-appointments.quick-buyer-back", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-appointments.quick-buyer-back", "/crm/listings/:id", "/crm/listings"],
  ["crm-appointments.quick-buyer-cancel", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-appointments.quick-buyer-cancel", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-appointments.quick-buyer-cancel", "/crm/listings/:id", "/crm/listings"],
  ["crm-appointments.quick-buyer-cell", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-appointments.quick-buyer-cell", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-appointments.quick-buyer-cell", "/crm/listings/:id", "/crm/listings"],
  ["crm-appointments.quick-buyer-create-anyway", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-appointments.quick-buyer-create-anyway", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-appointments.quick-buyer-create-anyway", "/crm/listings/:id", "/crm/listings"],
  ["crm-appointments.quick-buyer-email", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-appointments.quick-buyer-email", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-appointments.quick-buyer-email", "/crm/listings/:id", "/crm/listings"],
  ["crm-appointments.quick-buyer-first-name", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-appointments.quick-buyer-first-name", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-appointments.quick-buyer-first-name", "/crm/listings/:id", "/crm/listings"],
  ["crm-appointments.quick-buyer-save", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-appointments.quick-buyer-save", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-appointments.quick-buyer-save", "/crm/listings/:id", "/crm/listings"],
  ["crm-appointments.quick-buyer-surname", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-appointments.quick-buyer-surname", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-appointments.quick-buyer-surname", "/crm/listings/:id", "/crm/listings"],
  ["crm-appointments.quick-buyer-use-contact", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-appointments.quick-buyer-use-contact", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-appointments.quick-buyer-use-contact", "/crm/listings/:id", "/crm/listings"],
  ["crm-appointments.quick-buyer-use-lead", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-appointments.quick-buyer-use-lead", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-appointments.quick-buyer-use-lead", "/crm/listings/:id", "/crm/listings"],
  ["crm-appointments.save", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-appointments.save", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-appointments.save", "/crm/listings/:id", "/crm/listings"],
  ["crm-appointments.start", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-appointments.start", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-appointments.start", "/crm/listings/:id", "/crm/listings"],
  ["crm-appointments.status", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-appointments.status", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-appointments.status", "/crm/listings/:id", "/crm/listings"],
  ["crm-appointments.title", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-appointments.title", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-appointments.title", "/crm/listings/:id", "/crm/listings"],
  ["crm-appointments.type", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-appointments.type", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-appointments.type", "/crm/listings/:id", "/crm/listings"],
  ["crm-buyers-id.add-area", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.add-viewing", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.attach-vault-document", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.back", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.bathrooms", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.bedrooms", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.cancel-edit", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.currently-staying-in", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.edit", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.enquiry-row", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.funnel-stage", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.garages", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.lifestyle-options", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.linked-deal-open", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.linked-property-cancel", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.linked-property-change", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.linked-property-clear", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.linked-property-open", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.linked-property-result", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.linked-property-search", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.linked-property-search-button", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.looking-for", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.mark-interested", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.mark-not-interested", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.mark-offer-accepted", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.mark-offer-received", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.max-budget", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.min-budget", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.must-sell-first", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.new-task", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.notes", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.refer-buyer", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.remove-area", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.save", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.schedule-viewing", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.sold-renting", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.source", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.stage-move-cancel", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.stage-move-confirm", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.stand-size", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.status", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.tab-activity-history", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.tab-change-log", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.tab-documents", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.tab-enquiries", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.tab-funnel-mailers", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.tab-property-comms", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.tab-viewings", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.vault-attach", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.vault-search", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.vault-search-button", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.viewing-cancel", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.viewing-change-property", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.viewing-comments", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.viewing-date", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.viewing-interest", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.viewing-property-result", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.viewing-property-search", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-buyers-id.viewing-save", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-contacts-id.add-note", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-contacts-id.archive", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-contacts-id.back", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-contacts-id.contact-call", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-contacts-id.contact-call", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-contacts-id.contact-email", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-contacts-id.contact-email", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-contacts-id.contact-menu", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-contacts-id.contact-menu", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-contacts-id.contact-whatsapp", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-contacts-id.contact-whatsapp", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-contacts-id.delete", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-contacts-id.delete-document", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-contacts-id.edit", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-contacts-id.enquiry-open", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-contacts-id.enquiry-open", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-contacts-id.enquiry-pages", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-contacts-id.enquiry-pages", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-contacts-id.enquiry-property", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-contacts-id.enquiry-property", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-contacts-id.note-text", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-contacts-id.schedule", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-contacts-id.tab-change-log", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-contacts-id.tab-details", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-contacts-id.tab-documents", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-contacts-id.tab-enquiries", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-contacts-id.tab-notes", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-contacts-id.tab-related", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-contacts-id.upload-document", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-contacts-id.view-document", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-contacts.form-cancel", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-contacts.form-details", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-contacts.form-gender", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-contacts.form-notes", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-contacts.form-opt-in", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-contacts.form-roles", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-contacts.form-save", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-contacts.form-spouse-title", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-contacts.form-title", "/crm/contacts/:id", "/crm/contacts"],
  ["crm-deals-add-sale.lease-year-commission", "/admin/deals/:id", "/admin/deals"],
  ["crm-deals-add-sale.lease-year-commission", "/crm/deals/:id", "/crm/deals"],
  ["crm-deals-add-sale.lease-year-rental", "/admin/deals/:id", "/admin/deals"],
  ["crm-deals-add-sale.lease-year-rental", "/crm/deals/:id", "/crm/deals"],
  ["crm-deals-id-commission.add-agent", "/crm/deals/:id/commission", "/crm/deals"],
  ["crm-deals-id-commission.add-referral", "/crm/deals/:id/commission", "/crm/deals"],
  ["crm-deals-id-commission.back", "/crm/deals/:id/commission", "/crm/deals"],
  ["crm-deals-id-commission.commission-excl-vat", "/crm/deals/:id/commission", "/crm/deals"],
  ["crm-deals-id-commission.line-name", "/crm/deals/:id/commission", "/crm/deals"],
  ["crm-deals-id-commission.line-percent", "/crm/deals/:id/commission", "/crm/deals"],
  ["crm-deals-id-commission.remove-line", "/crm/deals/:id/commission", "/crm/deals"],
  ["crm-deals-id-commission.review-approval", "/crm/deals/:id/commission", "/crm/deals"],
  ["crm-deals-id-commission.sale-price", "/crm/deals/:id/commission", "/crm/deals"],
  ["crm-deals-id-commission.save-draft", "/crm/deals/:id/commission", "/crm/deals"],
  ["crm-deals-id-commission.source", "/crm/deals/:id/commission", "/crm/deals"],
  ["crm-deals-id-commission.submit", "/crm/deals/:id/commission", "/crm/deals"],
  ["crm-documents.prefill-apply", "/admin/deals/:id", "/admin/deals"],
  ["crm-documents.prefill-apply", "/crm/deals/:id", "/crm/deals"],
  ["crm-documents.prefill-apply", "/crm/farm/:id", "/crm/farm"],
  ["crm-documents.prefill-apply", "/crm/listings/:id", "/crm/listings"],
  ["crm-documents.prefill-close", "/admin/deals/:id", "/admin/deals"],
  ["crm-documents.prefill-close", "/crm/deals/:id", "/crm/deals"],
  ["crm-documents.prefill-close", "/crm/farm/:id", "/crm/farm"],
  ["crm-documents.prefill-close", "/crm/listings/:id", "/crm/listings"],
  ["crm-documents.prefill-field", "/admin/deals/:id", "/admin/deals"],
  ["crm-documents.prefill-field", "/crm/deals/:id", "/crm/deals"],
  ["crm-documents.prefill-field", "/crm/farm/:id", "/crm/farm"],
  ["crm-documents.prefill-field", "/crm/listings/:id", "/crm/listings"],
  ["crm-documents.prefill-generate-pdf", "/admin/deals/:id", "/admin/deals"],
  ["crm-documents.prefill-generate-pdf", "/crm/deals/:id", "/crm/deals"],
  ["crm-documents.prefill-generate-pdf", "/crm/farm/:id", "/crm/farm"],
  ["crm-documents.prefill-generate-pdf", "/crm/listings/:id", "/crm/listings"],
  ["crm-documents.prefill-generate-word", "/admin/deals/:id", "/admin/deals"],
  ["crm-documents.prefill-generate-word", "/crm/deals/:id", "/crm/deals"],
  ["crm-documents.prefill-generate-word", "/crm/farm/:id", "/crm/farm"],
  ["crm-documents.prefill-generate-word", "/crm/listings/:id", "/crm/listings"],
  ["crm-documents.prefill-open", "/admin/deals/:id", "/admin/deals"],
  ["crm-documents.prefill-open", "/crm/deals/:id", "/crm/deals"],
  ["crm-documents.prefill-open", "/crm/farm/:id", "/crm/farm"],
  ["crm-documents.prefill-open", "/crm/listings/:id", "/crm/listings"],
  ["crm-documents.prefill-save-to-record", "/admin/deals/:id", "/admin/deals"],
  ["crm-documents.prefill-save-to-record", "/crm/deals/:id", "/crm/deals"],
  ["crm-documents.prefill-save-to-record", "/crm/farm/:id", "/crm/farm"],
  ["crm-documents.prefill-save-to-record", "/crm/listings/:id", "/crm/listings"],
  ["crm-documents.prefill-template", "/admin/deals/:id", "/admin/deals"],
  ["crm-documents.prefill-template", "/crm/deals/:id", "/crm/deals"],
  ["crm-documents.prefill-template", "/crm/farm/:id", "/crm/farm"],
  ["crm-documents.prefill-template", "/crm/listings/:id", "/crm/listings"],
  ["crm-farm-id.add-sale", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.back", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.client-answered", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.create-listing", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.create-reminder", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.director-email", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.director-phone", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.edit-tags", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.features-cancel", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.features-edit", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.features-ensuite", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.features-save", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.generate-document", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.history-note", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.linked-doc-change-type", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.linked-doc-change-type", "/crm/listings/:id", "/crm/listings"],
  ["crm-farm-id.linked-doc-delete", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.linked-doc-delete", "/crm/listings/:id", "/crm/listings"],
  ["crm-farm-id.linked-doc-open-record", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.linked-doc-open-record", "/crm/listings/:id", "/crm/listings"],
  ["crm-farm-id.linked-doc-rename", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.linked-doc-rename", "/crm/listings/:id", "/crm/listings"],
  ["crm-farm-id.linked-doc-restore", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.linked-doc-restore", "/crm/listings/:id", "/crm/listings"],
  ["crm-farm-id.linked-doc-show-archived", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.linked-doc-show-archived", "/crm/listings/:id", "/crm/listings"],
  ["crm-farm-id.linked-doc-view", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.linked-doc-view", "/crm/listings/:id", "/crm/listings"],
  ["crm-farm-id.linked-listing", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.linked-listing-cancel", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.linked-listing-change-target", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.linked-listing-confirm", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.linked-listing-match", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.linked-listing-move", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.linked-listing-reason", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.linked-listing-search", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.linked-listing-target", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.linked-listing-unlink", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.new-task", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.open-tasks-callout", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.owner-add", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.owner-cancel", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.owner-contact-record-email", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.owner-contact-record-link", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.owner-contact-record-phone", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.owner-edit", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.owner-email", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.owner-loom-number", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.owner-loom-number-confirm", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.owner-name", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.owner-number", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.owner-remove", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.owner-save", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.previous-owners", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.refer-property", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.status-select", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.tab-change-log", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.tab-details", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.tab-documents", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.tab-features", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.tab-history", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.tab-tasks", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.tag-history", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.tag-toggle", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.tasks-new", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.view-all-history", "/crm/farm/:id", "/crm/farm"],
  ["crm-farm-id.view-listing", "/crm/farm/:id", "/crm/farm"],
  ["crm-listings-id.add-history", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.ai-accept", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.ai-dismiss", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.ai-draft-text", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.archive", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.area-approve", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.area-decline", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.area-decline-cancel", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.area-decline-confirm", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.area-decline-reason", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.area-rerequest", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.back", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.checklist-add-party", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.checklist-party-type", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.checklist-received", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.checklist-show-all", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.checklist-upload", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.checklist-upload-file", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.condition-notes", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.delete", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.description-cancel", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.description-edit", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.description-save", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.description-text", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.doc-change-type", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-listings-id.doc-change-type", "/crm/farm/:id", "/crm/farm"],
  ["crm-listings-id.doc-change-type", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.doc-delete", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-listings-id.doc-delete", "/crm/farm/:id", "/crm/farm"],
  ["crm-listings-id.doc-delete", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.doc-description", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-listings-id.doc-description", "/crm/farm/:id", "/crm/farm"],
  ["crm-listings-id.doc-description", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.doc-fica-for", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-listings-id.doc-fica-for", "/crm/farm/:id", "/crm/farm"],
  ["crm-listings-id.doc-fica-for", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.doc-fica-kind", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-listings-id.doc-fica-kind", "/crm/farm/:id", "/crm/farm"],
  ["crm-listings-id.doc-fica-kind", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.doc-pending-cancel", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-listings-id.doc-pending-cancel", "/crm/farm/:id", "/crm/farm"],
  ["crm-listings-id.doc-pending-cancel", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.doc-pending-upload", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-listings-id.doc-pending-upload", "/crm/farm/:id", "/crm/farm"],
  ["crm-listings-id.doc-pending-upload", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.doc-rename", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-listings-id.doc-rename", "/crm/farm/:id", "/crm/farm"],
  ["crm-listings-id.doc-rename", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.doc-rename-cancel", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-listings-id.doc-rename-cancel", "/crm/farm/:id", "/crm/farm"],
  ["crm-listings-id.doc-rename-cancel", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.doc-rename-input", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-listings-id.doc-rename-input", "/crm/farm/:id", "/crm/farm"],
  ["crm-listings-id.doc-rename-input", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.doc-rename-save", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-listings-id.doc-rename-save", "/crm/farm/:id", "/crm/farm"],
  ["crm-listings-id.doc-rename-save", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.doc-restore", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-listings-id.doc-restore", "/crm/farm/:id", "/crm/farm"],
  ["crm-listings-id.doc-restore", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.doc-show-archived", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-listings-id.doc-show-archived", "/crm/farm/:id", "/crm/farm"],
  ["crm-listings-id.doc-show-archived", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.doc-type", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-listings-id.doc-type", "/crm/farm/:id", "/crm/farm"],
  ["crm-listings-id.doc-type", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.doc-upload", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-listings-id.doc-upload", "/crm/farm/:id", "/crm/farm"],
  ["crm-listings-id.doc-upload", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.doc-view", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-listings-id.doc-view", "/crm/farm/:id", "/crm/farm"],
  ["crm-listings-id.doc-view", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.edit", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.edit-features", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.enquiries-pages", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.enquiry-buyer", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.enquiry-card", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.enquiry-row", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.features-copy-from-farm", "/crm/farm/:id", "/crm/farm"],
  ["crm-listings-id.features-copy-from-farm", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.generate-close", "/crm/farm/:id", "/crm/farm"],
  ["crm-listings-id.generate-close", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.generate-description", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.generate-document", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.generate-filter", "/crm/farm/:id", "/crm/farm"],
  ["crm-listings-id.generate-filter", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.generate-pdf", "/crm/farm/:id", "/crm/farm"],
  ["crm-listings-id.generate-pdf", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.generate-which-document", "/crm/farm/:id", "/crm/farm"],
  ["crm-listings-id.generate-which-document", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.golive-agent-approve", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.golive-authorise", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.golive-change-status", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.golive-confirm-send-back", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.golive-mark-photos", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.golive-send-back", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.golive-send-back-reason", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.golive-submit", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.golive-submit-for-listing", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.golive-thank-you-letter", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.history-note", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.linked-doc-use-as-loom", "/crm/farm/:id", "/crm/farm"],
  ["crm-listings-id.linked-doc-use-as-loom", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.market-confirm-request", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.market-generate-cma", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.market-pages", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.market-request-report", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.market-sold-within", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.market-use-deeds-comps", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.marketing-from", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.marketing-send-email", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.marketing-send-whatsapp", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.marketing-to", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.marketing-update", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.matching-channel-email", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.matching-channel-whatsapp", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.matching-email", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.matching-select-all", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.matching-select-buyer", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.matching-send-selected", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.matching-whatsapp", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.photo-caption", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.photo-delete", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.photo-download", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.photo-download-all", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.photo-retry", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.photo-set-main", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.photo-set-main-on-upload", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.photo-upload", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.schedule", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.send-changes-cancel", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.send-changes-confirm", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.send-changes-note", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.send-changes-to-office", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.tab-change-log", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.tab-checklist", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.tab-condition", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.tab-details", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.tab-documents", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.tab-enquiries", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.tab-features", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.tab-history", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.tab-market-insights", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.tab-marketing-report", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.tab-matching-buyers", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.tab-photos", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.thank-you-cancel", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.thank-you-close", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.thank-you-done", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.thank-you-send", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings-id.view-online", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings.form-brochure", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings.form-cancel", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings.form-capturing-for", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings.form-classification", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings.form-co-agent-add", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings.form-co-agent-remove", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings.form-description", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings.form-details", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings.form-ensuite", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings.form-features", "/crm/farm/:id", "/crm/farm"],
  ["crm-listings.form-features", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings.form-garages", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings.form-notes", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings.form-pick-property", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings.form-save", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings.form-stage-draft", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings.form-stage-submit", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings.form-title-deed", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings.source-farm-result", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings.source-farm-search", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings.source-loom-list", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings.source-loom-search", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings.source-loom-search-button", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings.source-loom-units", "/crm/listings/:id", "/crm/listings"],
  ["crm-listings.source-manual-address", "/crm/listings/:id", "/crm/listings"],
  ["crm-oversight-agent-id.back", "/crm/oversight/agent/:id", "/crm/oversight/activity"],
  ["crm-oversight-agent-id.view-as", "/crm/oversight/agent/:id", "/crm/oversight/activity"],
  ["crm-referrals.agency-ffc", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-referrals.agency-ffc", "/crm/farm/:id", "/crm/farm"],
  ["crm-referrals.agency-name", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-referrals.agency-name", "/crm/farm/:id", "/crm/farm"],
  ["crm-referrals.agent", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-referrals.agent", "/crm/farm/:id", "/crm/farm"],
  ["crm-referrals.agent-ffc", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-referrals.agent-ffc", "/crm/farm/:id", "/crm/farm"],
  ["crm-referrals.agent-name", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-referrals.agent-name", "/crm/farm/:id", "/crm/farm"],
  ["crm-referrals.amount", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-referrals.amount", "/crm/farm/:id", "/crm/farm"],
  ["crm-referrals.cancel", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-referrals.cancel", "/crm/farm/:id", "/crm/farm"],
  ["crm-referrals.external", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-referrals.external", "/crm/farm/:id", "/crm/farm"],
  ["crm-referrals.invoice-number", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-referrals.invoice-number", "/crm/farm/:id", "/crm/farm"],
  ["crm-referrals.note", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-referrals.note", "/crm/farm/:id", "/crm/farm"],
  ["crm-referrals.owner-contact", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-referrals.owner-contact", "/crm/farm/:id", "/crm/farm"],
  ["crm-referrals.owner-name", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-referrals.owner-name", "/crm/farm/:id", "/crm/farm"],
  ["crm-referrals.paid-to", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-referrals.paid-to", "/crm/farm/:id", "/crm/farm"],
  ["crm-referrals.property-address", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-referrals.property-address", "/crm/farm/:id", "/crm/farm"],
  ["crm-referrals.send", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-referrals.send", "/crm/farm/:id", "/crm/farm"],
  ["crm-referrals.type", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-referrals.type", "/crm/farm/:id", "/crm/farm"],
  ["crm-tasks-id.back", "/crm/tasks/:id", "/crm/tasks"],
  ["crm-tasks-id.call-again-date", "/crm/tasks/:id", "/crm/tasks"],
  ["crm-tasks-id.call-again-six-months", "/crm/tasks/:id", "/crm/tasks"],
  ["crm-tasks-id.call-again-three-months", "/crm/tasks/:id", "/crm/tasks"],
  ["crm-tasks-id.call-again-tomorrow", "/crm/tasks/:id", "/crm/tasks"],
  ["crm-tasks-id.call-again-two-weeks", "/crm/tasks/:id", "/crm/tasks"],
  ["crm-tasks-id.call-again-week", "/crm/tasks/:id", "/crm/tasks"],
  ["crm-tasks-id.call-again-year", "/crm/tasks/:id", "/crm/tasks"],
  ["crm-tasks-id.cancel-task", "/crm/tasks/:id", "/crm/tasks"],
  ["crm-tasks-id.channel-call", "/crm/tasks/:id", "/crm/tasks"],
  ["crm-tasks-id.channel-email", "/crm/tasks/:id", "/crm/tasks"],
  ["crm-tasks-id.channel-whatsapp", "/crm/tasks/:id", "/crm/tasks"],
  ["crm-tasks-id.channel-whatsapp-link", "/crm/tasks/:id", "/crm/tasks"],
  ["crm-tasks-id.client-answered", "/crm/tasks/:id", "/crm/tasks"],
  ["crm-tasks-id.complete", "/crm/tasks/:id", "/crm/tasks"],
  ["crm-tasks-id.contact-farm-record", "/crm/tasks/:id", "/crm/tasks"],
  ["crm-tasks-id.linked-contact", "/crm/tasks/:id", "/crm/tasks"],
  ["crm-tasks-id.linked-deal", "/crm/tasks/:id", "/crm/tasks"],
  ["crm-tasks-id.linked-farm-record", "/crm/tasks/:id", "/crm/tasks"],
  ["crm-tasks-id.linked-lead", "/crm/tasks/:id", "/crm/tasks"],
  ["crm-tasks-id.linked-property", "/crm/tasks/:id", "/crm/tasks"],
  ["crm-tasks-id.log-note", "/crm/tasks/:id", "/crm/tasks"],
  ["crm-tasks-id.log-save", "/crm/tasks/:id", "/crm/tasks"],
  ["crm-tasks-id.message-close", "/crm/tasks/:id", "/crm/tasks"],
  ["crm-tasks-id.message-reset", "/crm/tasks/:id", "/crm/tasks"],
  ["crm-tasks-id.message-send", "/crm/tasks/:id", "/crm/tasks"],
  ["crm-tasks-id.message-subject", "/crm/tasks/:id", "/crm/tasks"],
  ["crm-tasks-id.message-text", "/crm/tasks/:id", "/crm/tasks"],
  ["crm-tasks-id.open-dialler", "/crm/tasks/:id", "/crm/tasks"],
  ["crm-tasks-id.send-message", "/crm/tasks/:id", "/crm/tasks"],
  ["crm-tasks-id.start", "/crm/tasks/:id", "/crm/tasks"],
  ["crm-tasks.cancel", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-tasks.cancel", "/crm/farm/:id", "/crm/farm"],
  ["crm-tasks.description", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-tasks.description", "/crm/farm/:id", "/crm/farm"],
  ["crm-tasks.detail", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-tasks.detail", "/crm/farm/:id", "/crm/farm"],
  ["crm-tasks.due-date", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-tasks.due-date", "/crm/farm/:id", "/crm/farm"],
  ["crm-tasks.due-time", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-tasks.due-time", "/crm/farm/:id", "/crm/farm"],
  ["crm-tasks.form-reminder-type", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-tasks.form-reminder-type", "/crm/farm/:id", "/crm/farm"],
  ["crm-tasks.link-result", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-tasks.link-result", "/crm/farm/:id", "/crm/farm"],
  ["crm-tasks.link-search", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-tasks.link-search", "/crm/farm/:id", "/crm/farm"],
  ["crm-tasks.link-type", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-tasks.link-type", "/crm/farm/:id", "/crm/farm"],
  ["crm-tasks.remove-link", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-tasks.remove-link", "/crm/farm/:id", "/crm/farm"],
  ["crm-tasks.save", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-tasks.save", "/crm/farm/:id", "/crm/farm"],
  ["crm-tasks.status", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-tasks.status", "/crm/farm/:id", "/crm/farm"],
  ["crm-tasks.team", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-tasks.team", "/crm/farm/:id", "/crm/farm"],
  ["crm-tasks.type", "/crm/buyers/:id", "/crm/buyers"],
  ["crm-tasks.type", "/crm/farm/:id", "/crm/farm"],
  ["deals-id.add-address", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.add-address", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.add-note", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.add-note", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.add-person", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.add-person", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.add-related-person", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.add-related-person", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.address-deeds-search", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.address-deeds-search", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.address-erf", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.address-erf", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.address-farm", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.address-farm", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.address-listing", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.address-listing", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.address-loom-address", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.address-loom-address", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.address-loom-mode", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.address-loom-mode", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.address-loom-search", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.address-loom-search", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.address-loom-use", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.address-loom-use", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.address-manual-erf", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.address-manual-erf", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.address-manual-street", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.address-manual-street", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.address-manual-suburb", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.address-manual-suburb", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.address-manual-unit", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.address-manual-unit", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.address-manual-use", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.address-manual-use", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.address-scheme", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.address-scheme", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.address-search", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.address-search", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.address-township", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.address-township", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.address-unit", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.address-unit", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.attachment-delete", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.attachment-delete", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.attachment-move", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.attachment-move", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.attachment-view", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.attachment-view", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.attachment-view", "/crm/listings/:id", "/crm/listings"],
  ["deals-id.authorise-payment", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.authorise-payment", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.back-to-deals", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.back-to-deals", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.batch-cancel", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.batch-cancel", "/crm/buyers/:id", "/crm/buyers"],
  ["deals-id.batch-cancel", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.batch-cancel", "/crm/farm/:id", "/crm/farm"],
  ["deals-id.batch-cancel", "/crm/listings/:id", "/crm/listings"],
  ["deals-id.batch-description", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.batch-description", "/crm/buyers/:id", "/crm/buyers"],
  ["deals-id.batch-description", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.batch-description", "/crm/farm/:id", "/crm/farm"],
  ["deals-id.batch-description", "/crm/listings/:id", "/crm/listings"],
  ["deals-id.batch-fica-for", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.batch-fica-for", "/crm/buyers/:id", "/crm/buyers"],
  ["deals-id.batch-fica-for", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.batch-fica-for", "/crm/farm/:id", "/crm/farm"],
  ["deals-id.batch-fica-for", "/crm/listings/:id", "/crm/listings"],
  ["deals-id.batch-fica-kind", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.batch-fica-kind", "/crm/buyers/:id", "/crm/buyers"],
  ["deals-id.batch-fica-kind", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.batch-fica-kind", "/crm/farm/:id", "/crm/farm"],
  ["deals-id.batch-fica-kind", "/crm/listings/:id", "/crm/listings"],
  ["deals-id.batch-remove", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.batch-remove", "/crm/buyers/:id", "/crm/buyers"],
  ["deals-id.batch-remove", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.batch-remove", "/crm/farm/:id", "/crm/farm"],
  ["deals-id.batch-remove", "/crm/listings/:id", "/crm/listings"],
  ["deals-id.batch-type", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.batch-type", "/crm/buyers/:id", "/crm/buyers"],
  ["deals-id.batch-type", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.batch-type", "/crm/farm/:id", "/crm/farm"],
  ["deals-id.batch-type", "/crm/listings/:id", "/crm/listings"],
  ["deals-id.batch-upload", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.batch-upload", "/crm/buyers/:id", "/crm/buyers"],
  ["deals-id.batch-upload", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.batch-upload", "/crm/farm/:id", "/crm/farm"],
  ["deals-id.batch-upload", "/crm/listings/:id", "/crm/listings"],
  ["deals-id.bond-account-no", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.bond-account-no", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.bond-amount", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.bond-amount", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.bond-apply-all", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.bond-apply-all", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.bond-apply-cancel", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.bond-apply-cancel", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.bond-apply-confirm", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.bond-apply-confirm", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.bond-apply-finish", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.bond-apply-finish", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.bond-apply-refresh", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.bond-apply-refresh", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.bond-apply-row", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.bond-apply-row", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.bond-apply-selected", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.bond-apply-selected", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.bond-apply-try-again", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.bond-apply-try-again", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.bond-approved-amount", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.bond-approved-amount", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.bond-approved-date", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.bond-approved-date", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.bond-cash-deal", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.bond-cash-deal", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.bond-due-date", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.bond-due-date", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.bond-edit", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.bond-edit", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.bond-institution", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.bond-institution", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.bond-originator-details", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.bond-originator-details", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.bond-pack-applicant", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.bond-pack-applicant", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.bond-pack-download-pdf", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.bond-pack-download-pdf", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.bond-pack-originator", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.bond-pack-originator", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.bond-pack-produce-pdf", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.bond-pack-produce-pdf", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.bond-pack-save-details", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.bond-pack-save-details", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.bond-pack-section", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.bond-pack-section", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.bond-pack-send", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.bond-pack-send", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.bond-pack-status", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.bond-pack-status", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.bond-pack-term", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.bond-pack-term", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.bond-pack-try-again", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.bond-pack-try-again", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.cancel-reopen", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.cancel-reopen", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.cancellation-approve", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.cancellation-approve", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.cancellation-close", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.cancellation-close", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.cancellation-reason", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.cancellation-reason", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.cancellation-reject", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.cancellation-reject", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.cancellation-reopen", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.cancellation-reopen", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.cancellation-reopen-status", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.cancellation-reopen-status", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.cancellation-request", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.cancellation-request", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.cancellation-submit", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.cancellation-submit", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.change-log-next", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.change-log-next", "/crm/buyers/:id", "/crm/buyers"],
  ["deals-id.change-log-next", "/crm/contacts/:id", "/crm/contacts"],
  ["deals-id.change-log-next", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.change-log-next", "/crm/farm/:id", "/crm/farm"],
  ["deals-id.change-log-next", "/crm/listings/:id", "/crm/listings"],
  ["deals-id.change-log-previous", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.change-log-previous", "/crm/buyers/:id", "/crm/buyers"],
  ["deals-id.change-log-previous", "/crm/contacts/:id", "/crm/contacts"],
  ["deals-id.change-log-previous", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.change-log-previous", "/crm/farm/:id", "/crm/farm"],
  ["deals-id.change-log-previous", "/crm/listings/:id", "/crm/listings"],
  ["deals-id.change-log-retry", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.change-log-retry", "/crm/buyers/:id", "/crm/buyers"],
  ["deals-id.change-log-retry", "/crm/contacts/:id", "/crm/contacts"],
  ["deals-id.change-log-retry", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.change-log-retry", "/crm/farm/:id", "/crm/farm"],
  ["deals-id.change-log-retry", "/crm/listings/:id", "/crm/listings"],
  ["deals-id.change-status", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.change-status", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.clear-commission-advance", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.clear-commission-advance", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.close-paid", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.close-paid", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.commission-edit-figures", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.commission-edit-figures", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.commission-edit-figures-amount", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.commission-edit-figures-amount", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.commission-edit-figures-cancel", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.commission-edit-figures-cancel", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.commission-edit-figures-save", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.commission-edit-figures-save", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.commission-split-sheet", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.commission-split-sheet", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.confirm-reopen", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.confirm-reopen", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.ctr-download-xml", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.ctr-download-xml", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.ctr-upload", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.ctr-upload", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.deposit-amount", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.deposit-amount", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.deposit-due-date", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.deposit-due-date", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.deposit-edit", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.deposit-edit", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.deposit-interest", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.deposit-interest", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.deposit-paid", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.deposit-paid", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.deposit-paid-date", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.deposit-paid-date", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.deposit-paid-where", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.deposit-paid-where", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.document-delete", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.document-delete", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.document-description", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.document-description", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.document-move", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.document-move", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.document-type", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.document-type", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.document-upload", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.document-upload", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.document-view", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.document-view", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-archive-back", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-archive-back", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-archive-cancel", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-archive-cancel", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-archive-confirm", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-archive-confirm", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-archive-confirm-delete", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-archive-confirm-delete", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-archive-delete-instead", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-archive-delete-instead", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-archive-reason", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-archive-reason", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-assess-risk", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-assess-risk", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-bank-account-number", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-bank-account-number", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-bank-branch-code", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-bank-branch-code", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-bank-cancel", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-bank-cancel", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-bank-close-x", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-bank-close-x", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-bank-done", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-bank-done", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-bank-name", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-bank-name", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-bank-quick-select", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-bank-quick-select", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-bank-submit", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-bank-submit", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-checklist-templates", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-checklist-templates", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-company-cancel", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-company-cancel", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-company-close-x", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-company-close-x", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-company-done", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-company-done", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-company-reg-number", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-company-reg-number", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-company-submit", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-company-submit", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-copy-open", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-copy-open", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-dismiss-alerts-error", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-dismiss-alerts-error", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-doc-archive", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-doc-archive", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-doc-received", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-doc-received", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-doc-refile", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-doc-refile", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-doc-restore", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-doc-restore", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-doc-view", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-doc-view", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-edd-narrative", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-edd-narrative", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-edd-review-date", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-edd-review-date", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-edd-save", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-edd-save", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-face-cancel", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-face-cancel", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-face-close-x", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-face-close-x", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-face-done", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-face-done", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-face-id-photo", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-face-id-photo", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-face-match", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-face-match", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-face-selfie", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-face-selfie", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-face-submit", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-face-submit", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-go-to-parties", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-go-to-parties", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-id-cancel", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-id-cancel", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-id-close-x", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-id-close-x", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-id-done", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-id-done", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-id-number", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-id-number", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-id-submit", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-id-submit", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-item-mark-reviewed", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-item-mark-reviewed", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-item-upload", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-item-upload", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-open-cover-page", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-open-cover-page", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-ownership-expand", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-ownership-expand", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-ownership-tree", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-ownership-tree", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-pack-cancel", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-pack-cancel", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-pack-cancel", "/legal/:otpId", "/legal"],
  ["deals-id.fica-pack-confirm", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-pack-confirm", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-pack-confirm", "/legal/:otpId", "/legal"],
  ["deals-id.fica-pack-pin-copy", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-pack-pin-copy", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-pack-pin-copy", "/legal/:otpId", "/legal"],
  ["deals-id.fica-pack-pin-done", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-pack-pin-done", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-pack-pin-done", "/legal/:otpId", "/legal"],
  ["deals-id.fica-pack-reissue", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-pack-reissue", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-pack-reissue", "/legal/:otpId", "/legal"],
  ["deals-id.fica-pack-share", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-pack-share", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-pack-share", "/legal/:otpId", "/legal"],
  ["deals-id.fica-pack-stop", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-pack-stop", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-pack-stop", "/legal/:otpId", "/legal"],
  ["deals-id.fica-paper-cancel", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-paper-cancel", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-paper-check-off", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-paper-check-off", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-paper-confirm", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-paper-confirm", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-paper-date", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-paper-date", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-paper-note", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-paper-note", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-paperwork-toggle", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-paperwork-toggle", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-party-card", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-party-card", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-review-cancel", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-review-cancel", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-review-confirm", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-review-confirm", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-review-note", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-review-note", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-risk-cancel", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-risk-cancel", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-risk-close-x", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-risk-close-x", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-risk-done", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-risk-done", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-risk-edd-narrative", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-risk-edd-narrative", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-risk-edd-review-date", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-risk-edd-review-date", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-risk-factor", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-risk-factor", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-risk-submit", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-risk-submit", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-screen", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-screen", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-screen-cancel", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-screen-cancel", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-screen-close-x", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-screen-close-x", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-screen-done", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-screen-done", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-screen-id-number", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-screen-id-number", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-screen-name", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-screen-name", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-screen-submit", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-screen-submit", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-seller-cards", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-seller-cards", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-seller-go-to-parties", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-seller-go-to-parties", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-seller-listing-checklist", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-seller-listing-checklist", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-send-link", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-send-link", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-show-archived", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-show-archived", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-start", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-start", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-tpr-download", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-tpr-download", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-tpr-upload", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-tpr-upload", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-upload-cancel", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-upload-cancel", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-upload-close-x", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-upload-close-x", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-upload-dismiss-scan-error", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-upload-dismiss-scan-error", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-upload-done", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-upload-done", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-upload-file", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-upload-file", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-upload-override", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-upload-override", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-verify-bank", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-verify-bank", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-verify-company", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-verify-company", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.fica-verify-id", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.fica-verify-id", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.file-number", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.file-number", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.file-number-action", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.file-number-action", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.file-number-action", "/legal/:otpId", "/legal"],
  ["deals-id.file-number-cancel", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.file-number-cancel", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.file-number-cancel", "/legal/:otpId", "/legal"],
  ["deals-id.file-number-note", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.file-number-note", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.file-number-note", "/legal/:otpId", "/legal"],
  ["deals-id.file-number-save", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.file-number-save", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.file-number-save", "/legal/:otpId", "/legal"],
  ["deals-id.file-number-value", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.file-number-value", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.file-number-value", "/legal/:otpId", "/legal"],
  ["deals-id.flag-suspicious", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.flag-suspicious", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.generate-letters", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.generate-letters", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.intake-cancel", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.intake-cancel", "/crm/buyers/:id", "/crm/buyers"],
  ["deals-id.intake-cancel", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.intake-channel", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.intake-channel", "/crm/buyers/:id", "/crm/buyers"],
  ["deals-id.intake-channel", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.intake-copy-link", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.intake-copy-link", "/crm/buyers/:id", "/crm/buyers"],
  ["deals-id.intake-copy-link", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.intake-done", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.intake-done", "/crm/buyers/:id", "/crm/buyers"],
  ["deals-id.intake-done", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.intake-link", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.intake-link", "/crm/buyers/:id", "/crm/buyers"],
  ["deals-id.intake-link", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.intake-open-whatsapp", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.intake-open-whatsapp", "/crm/buyers/:id", "/crm/buyers"],
  ["deals-id.intake-open-whatsapp", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.intake-recipient-checked", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.intake-recipient-checked", "/crm/buyers/:id", "/crm/buyers"],
  ["deals-id.intake-recipient-checked", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.intake-revoke", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.intake-revoke", "/crm/buyers/:id", "/crm/buyers"],
  ["deals-id.intake-revoke", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.intake-revoke-cancel", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.intake-revoke-cancel", "/crm/buyers/:id", "/crm/buyers"],
  ["deals-id.intake-revoke-cancel", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.intake-revoke-confirm", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.intake-revoke-confirm", "/crm/buyers/:id", "/crm/buyers"],
  ["deals-id.intake-revoke-confirm", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.intake-revoke-reason", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.intake-revoke-reason", "/crm/buyers/:id", "/crm/buyers"],
  ["deals-id.intake-revoke-reason", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.intake-send", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.intake-send", "/crm/buyers/:id", "/crm/buyers"],
  ["deals-id.intake-send", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.intake-send-confirm", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.intake-send-confirm", "/crm/buyers/:id", "/crm/buyers"],
  ["deals-id.intake-send-confirm", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.intake-try-again", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.intake-try-again", "/crm/buyers/:id", "/crm/buyers"],
  ["deals-id.intake-try-again", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.lease-document-view", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.lease-document-view", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.lease-generate-all", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.lease-generate-all", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.lease-generate-one", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.lease-generate-one", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.letter-templates-link", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.letter-templates-link", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.linked-buyer-cancel", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.linked-buyer-cancel", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.linked-buyer-change", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.linked-buyer-change", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.linked-buyer-open", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.linked-buyer-open", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.linked-buyer-remove", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.linked-buyer-remove", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.linked-buyer-result", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.linked-buyer-result", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.linked-buyer-search", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.linked-buyer-search", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.linked-buyer-search-button", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.linked-buyer-search-button", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.mark-commission-advance", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.mark-commission-advance", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.note-text", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.note-text", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.occupation-birthday-kit", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.occupation-birthday-kit", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.occupation-edit", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.occupation-edit", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.occupation-farmbook-updated", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.occupation-farmbook-updated", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.occupation-gift-delivered", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.occupation-gift-delivered", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.occupation-gift-ordered", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.occupation-gift-ordered", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.occupation-occupy-date", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.occupation-occupy-date", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.occupation-occupy-rent", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.occupation-occupy-rent", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.occupation-transfer-on-occupation", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.occupation-transfer-on-occupation", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.open-split-sheet", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.open-split-sheet", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.originator-cancel", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.originator-cancel", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.originator-choose", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.originator-choose", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.originator-download-pdf", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.originator-download-pdf", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.originator-mark-sent", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.originator-mark-sent", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.originator-note", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.originator-note", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.originator-send", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.originator-send", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.other-sale-address", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.other-sale-address", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.other-sale-address", "/legal/:otpId", "/legal"],
  ["deals-id.other-sale-agent", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.other-sale-agent", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.other-sale-agent", "/legal/:otpId", "/legal"],
  ["deals-id.other-sale-days", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.other-sale-days", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.other-sale-days", "/legal/:otpId", "/legal"],
  ["deals-id.other-sale-edit", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.other-sale-edit", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.other-sale-edit", "/legal/:otpId", "/legal"],
  ["deals-id.other-sale-expiry", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.other-sale-expiry", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.other-sale-expiry", "/legal/:otpId", "/legal"],
  ["deals-id.other-sale-fulfilled", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.other-sale-fulfilled", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.other-sale-fulfilled", "/legal/:otpId", "/legal"],
  ["deals-id.other-sale-price", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.other-sale-price", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.other-sale-price", "/legal/:otpId", "/legal"],
  ["deals-id.person-address", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.person-address", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.person-cell", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.person-cell", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.person-email", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.person-email", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.person-id", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.person-id", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.person-name", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.person-name", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.person-representative", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.person-representative", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.person-role", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.person-role", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.person-tax", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.person-tax", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-access-log-close", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-access-log-close", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-access-log-close", "/legal/:otpId", "/legal"],
  ["deals-id.portal-access-log-export-csv", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-access-log-export-csv", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-access-log-export-csv", "/legal/:otpId", "/legal"],
  ["deals-id.portal-access-log-export-pdf", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-access-log-export-pdf", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-access-log-export-pdf", "/legal/:otpId", "/legal"],
  ["deals-id.portal-access-log-link", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-access-log-link", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-access-log-link", "/legal/:otpId", "/legal"],
  ["deals-id.portal-access-log-pagination", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-access-log-pagination", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-access-log-pagination", "/legal/:otpId", "/legal"],
  ["deals-id.portal-access-log-try-again", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-access-log-try-again", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-access-log-try-again", "/legal/:otpId", "/legal"],
  ["deals-id.portal-cancel", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-cancel", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-cancel", "/legal/:otpId", "/legal"],
  ["deals-id.portal-channel", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-channel", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-channel", "/legal/:otpId", "/legal"],
  ["deals-id.portal-copy-link", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-copy-link", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-copy-link", "/legal/:otpId", "/legal"],
  ["deals-id.portal-docs-accept", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-docs-accept", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-docs-accept", "/legal/:otpId", "/legal"],
  ["deals-id.portal-docs-new", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-docs-new", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-docs-new", "/legal/:otpId", "/legal"],
  ["deals-id.portal-docs-new-cancel", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-docs-new-cancel", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-docs-new-cancel", "/legal/:otpId", "/legal"],
  ["deals-id.portal-docs-new-due", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-docs-new-due", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-docs-new-due", "/legal/:otpId", "/legal"],
  ["deals-id.portal-docs-new-folder", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-docs-new-folder", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-docs-new-folder", "/legal/:otpId", "/legal"],
  ["deals-id.portal-docs-new-label", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-docs-new-label", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-docs-new-label", "/legal/:otpId", "/legal"],
  ["deals-id.portal-docs-new-party", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-docs-new-party", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-docs-new-party", "/legal/:otpId", "/legal"],
  ["deals-id.portal-docs-new-reason", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-docs-new-reason", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-docs-new-reason", "/legal/:otpId", "/legal"],
  ["deals-id.portal-docs-new-reason-text", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-docs-new-reason-text", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-docs-new-reason-text", "/legal/:otpId", "/legal"],
  ["deals-id.portal-docs-new-save", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-docs-new-save", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-docs-new-save", "/legal/:otpId", "/legal"],
  ["deals-id.portal-docs-open-file", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-docs-open-file", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-docs-open-file", "/legal/:otpId", "/legal"],
  ["deals-id.portal-docs-pagination", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-docs-pagination", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-docs-pagination", "/legal/:otpId", "/legal"],
  ["deals-id.portal-docs-party-filter", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-docs-party-filter", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-docs-party-filter", "/legal/:otpId", "/legal"],
  ["deals-id.portal-docs-send-back", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-docs-send-back", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-docs-send-back", "/legal/:otpId", "/legal"],
  ["deals-id.portal-docs-send-back-cancel", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-docs-send-back-cancel", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-docs-send-back-cancel", "/legal/:otpId", "/legal"],
  ["deals-id.portal-docs-send-back-confirm", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-docs-send-back-confirm", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-docs-send-back-confirm", "/legal/:otpId", "/legal"],
  ["deals-id.portal-docs-send-back-reason", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-docs-send-back-reason", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-docs-send-back-reason", "/legal/:otpId", "/legal"],
  ["deals-id.portal-docs-try-again", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-docs-try-again", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-docs-try-again", "/legal/:otpId", "/legal"],
  ["deals-id.portal-done", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-done", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-done", "/legal/:otpId", "/legal"],
  ["deals-id.portal-link", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-link", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-link", "/legal/:otpId", "/legal"],
  ["deals-id.portal-open-whatsapp", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-open-whatsapp", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-open-whatsapp", "/legal/:otpId", "/legal"],
  ["deals-id.portal-party", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-party", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-party", "/legal/:otpId", "/legal"],
  ["deals-id.portal-preview-for", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-preview-for", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-preview-for", "/legal/:otpId", "/legal"],
  ["deals-id.portal-recipient-checked", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-recipient-checked", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-recipient-checked", "/legal/:otpId", "/legal"],
  ["deals-id.portal-revoke-cancel", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-revoke-cancel", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-revoke-cancel", "/legal/:otpId", "/legal"],
  ["deals-id.portal-revoke-confirm", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-revoke-confirm", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-revoke-confirm", "/legal/:otpId", "/legal"],
  ["deals-id.portal-revoke-reason", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-revoke-reason", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-revoke-reason", "/legal/:otpId", "/legal"],
  ["deals-id.portal-send", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-send", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-send", "/legal/:otpId", "/legal"],
  ["deals-id.portal-send-confirm", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-send-confirm", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-send-confirm", "/legal/:otpId", "/legal"],
  ["deals-id.portal-send-party", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-send-party", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-send-party", "/legal/:otpId", "/legal"],
  ["deals-id.portal-team-confirmed", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-team-confirmed", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-team-confirmed", "/legal/:otpId", "/legal"],
  ["deals-id.portal-try-again", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.portal-try-again", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.portal-try-again", "/legal/:otpId", "/legal"],
  ["deals-id.prepare-letter", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.prepare-letter", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.prepare-payment", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.prepare-payment", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.progress-document-view", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.progress-document-view", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.property-document-view", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.property-document-view", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.purchaser-add-party", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.purchaser-add-party", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.purchaser-capacity", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.purchaser-capacity", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.purchaser-capacity-show-all", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.purchaser-capacity-show-all", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.purchaser-case-documents", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.purchaser-case-documents", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.purchaser-received", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.purchaser-received", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.purchaser-upload", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.purchaser-upload", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.purchaser-upload-button", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.purchaser-upload-button", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.renew-add-period", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.renew-add-period", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.renew-cancel", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.renew-cancel", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.renew-commission", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.renew-commission", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.renew-create", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.renew-create", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.renew-end-date", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.renew-end-date", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.renew-lease", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.renew-lease", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.renew-remove-period", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.renew-remove-period", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.renew-rental", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.renew-rental", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.renew-start-date", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.renew-start-date", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.renew-term", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.renew-term", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.renewed-by", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.renewed-by", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.renewed-from", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.renewed-from", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.reopen-paid-closed", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.reopen-paid-closed", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.reopen-reason", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.reopen-reason", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.risk-cancel", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.risk-cancel", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.risk-cancel", "/legal/:otpId", "/legal"],
  ["deals-id.risk-edd-narrative", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.risk-edd-narrative", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.risk-edd-narrative", "/legal/:otpId", "/legal"],
  ["deals-id.risk-level", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.risk-level", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.risk-level", "/legal/:otpId", "/legal"],
  ["deals-id.risk-reason", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.risk-reason", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.risk-reason", "/legal/:otpId", "/legal"],
  ["deals-id.risk-review-date", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.risk-review-date", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.risk-review-date", "/legal/:otpId", "/legal"],
  ["deals-id.risk-save", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.risk-save", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.risk-save", "/legal/:otpId", "/legal"],
  ["deals-id.sale-commission", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.sale-commission", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.sale-date", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.sale-date", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.sale-edit", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.sale-edit", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.sale-lease-end", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.sale-lease-end", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.sale-lease-start", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.sale-lease-start", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.sale-lease-term", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.sale-lease-term", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.sale-monthly-rent", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.sale-monthly-rent", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.sale-price", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.sale-price", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.sale-type", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.sale-type", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.sale-vat", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.sale-vat", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.send-congratulations", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.send-congratulations", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.send-letter", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.send-letter", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.share-cancel", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.share-cancel", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.share-cancel", "/legal/:otpId", "/legal"],
  ["deals-id.share-capacity", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.share-capacity", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.share-capacity", "/legal/:otpId", "/legal"],
  ["deals-id.share-deal", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.share-deal", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.share-deal", "/legal/:otpId", "/legal"],
  ["deals-id.share-people-links", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.share-people-links", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.share-people-links", "/legal/:otpId", "/legal"],
  ["deals-id.share-pick-firm", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.share-pick-firm", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.share-pick-firm", "/legal/:otpId", "/legal"],
  ["deals-id.share-search", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.share-search", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.share-search", "/legal/:otpId", "/legal"],
  ["deals-id.share-suggested", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.share-suggested", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.share-suggested", "/legal/:otpId", "/legal"],
  ["deals-id.share-with-firm", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.share-with-firm", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.share-with-firm", "/legal/:otpId", "/legal"],
  ["deals-id.shares-try-again", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.shares-try-again", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.shares-try-again", "/legal/:otpId", "/legal"],
  ["deals-id.sign-off-commission-change", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.sign-off-commission-change", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.special-conditions-edit", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.special-conditions-edit", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.special-conditions-text", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.special-conditions-text", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.stage-advance", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.stage-advance", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.status-legend", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.status-legend", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.status-legend", "/legal/:otpId", "/legal"],
  ["deals-id.stop-sharing", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.stop-sharing", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.stop-sharing", "/legal/:otpId", "/legal"],
  ["deals-id.stop-sharing-cancel", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.stop-sharing-cancel", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.stop-sharing-cancel", "/legal/:otpId", "/legal"],
  ["deals-id.stop-sharing-confirm", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.stop-sharing-confirm", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.stop-sharing-confirm", "/legal/:otpId", "/legal"],
  ["deals-id.stop-sharing-reason", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.stop-sharing-reason", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.stop-sharing-reason", "/legal/:otpId", "/legal"],
  ["deals-id.stopped-shares", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.stopped-shares", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.stopped-shares", "/legal/:otpId", "/legal"],
  ["deals-id.str-cancel", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.str-cancel", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.str-create", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.str-create", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.str-mark-submitted", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.str-mark-submitted", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.str-new", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.str-new", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.str-party", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.str-party", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.str-reason", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.str-reason", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.submit-signoff", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.submit-signoff", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.tab-bond-pack", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.tab-bond-pack", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.tab-buyers-sellers", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.tab-buyers-sellers", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.tab-change-log", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.tab-change-log", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.tab-commission", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.tab-commission", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.tab-correspondence", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.tab-correspondence", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.tab-details", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.tab-details", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.tab-documents", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.tab-documents", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.tab-fica", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.tab-fica", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.tab-lease-docs", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.tab-lease-docs", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.tab-notes", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.tab-notes", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.tab-progress", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.tab-progress", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.transaction-received", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.transaction-received", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.transaction-upload", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.transaction-upload", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.transaction-upload-button", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.transaction-upload-button", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.transfer-buyer-name", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.transfer-buyer-name", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.transfer-conditions-met", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.transfer-conditions-met", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.transfer-date-lodged", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.transfer-date-lodged", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.transfer-date-registered", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.transfer-date-registered", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.transfer-edit", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.transfer-edit", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.transfer-property-name", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.transfer-property-name", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.transfer-seller-name", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.transfer-seller-name", "/crm/deals/:id", "/crm/deals"],
  ["deals-id.transfer-undertaking-received", "/admin/deals/:id", "/admin/deals"],
  ["deals-id.transfer-undertaking-received", "/crm/deals/:id", "/crm/deals"],
  ["document-vault.move-cancel", "/admin/deals/:id", "/admin/deals"],
  ["document-vault.move-cancel", "/crm/buyers/:id", "/crm/buyers"],
  ["document-vault.move-cancel", "/crm/deals/:id", "/crm/deals"],
  ["document-vault.move-cancel", "/crm/farm/:id", "/crm/farm"],
  ["document-vault.move-cancel", "/crm/listings/:id", "/crm/listings"],
  ["document-vault.move-cancel", "/legal/:otpId", "/legal"],
  ["document-vault.move-submit", "/admin/deals/:id", "/admin/deals"],
  ["document-vault.move-submit", "/crm/buyers/:id", "/crm/buyers"],
  ["document-vault.move-submit", "/crm/deals/:id", "/crm/deals"],
  ["document-vault.move-submit", "/crm/farm/:id", "/crm/farm"],
  ["document-vault.move-submit", "/crm/listings/:id", "/crm/listings"],
  ["document-vault.move-submit", "/legal/:otpId", "/legal"],
  ["document-vault.move-target", "/admin/deals/:id", "/admin/deals"],
  ["document-vault.move-target", "/crm/buyers/:id", "/crm/buyers"],
  ["document-vault.move-target", "/crm/deals/:id", "/crm/deals"],
  ["document-vault.move-target", "/crm/farm/:id", "/crm/farm"],
  ["document-vault.move-target", "/crm/listings/:id", "/crm/listings"],
  ["document-vault.move-target", "/legal/:otpId", "/legal"],
  ["feedback-curation.approve", "/admin/feedback/curation/:date", "/admin/activity"],
  ["feedback-curation.approve-all", "/admin/feedback/curation/:date", "/admin/activity"],
  ["feedback-curation.approve-all-cancel", "/admin/feedback/curation/:date", "/admin/activity"],
  ["feedback-curation.approve-all-confirm", "/admin/feedback/curation/:date", "/admin/activity"],
  ["feedback-curation.approve-with-note", "/admin/feedback/curation/:date", "/admin/activity"],
  ["feedback-curation.back-to-reports", "/admin/feedback/curation/:date", "/admin/activity"],
  ["feedback-curation.date-picker", "/admin/feedback/curation/:date", "/admin/activity"],
  ["feedback-curation.decline", "/admin/feedback/curation/:date", "/admin/activity"],
  ["feedback-curation.decline-with-note", "/admin/feedback/curation/:date", "/admin/activity"],
  ["feedback-curation.motion-link", "/admin/feedback/curation/:date", "/admin/activity"],
  ["feedback-curation.note-cancel", "/admin/feedback/curation/:date", "/admin/activity"],
  ["feedback-curation.note-confirm", "/admin/feedback/curation/:date", "/admin/activity"],
  ["feedback-curation.note-text", "/admin/feedback/curation/:date", "/admin/activity"],
  ["feedback-curation.report-chip", "/admin/feedback/curation/:date", "/admin/activity"],
  ["legal-otpid.add-address-details", "/legal/:otpId", "/legal"],
  ["legal-otpid.add-purchaser", "/legal/:otpId", "/legal"],
  ["legal-otpid.add-related-person", "/legal/:otpId", "/legal"],
  ["legal-otpid.add-seller", "/legal/:otpId", "/legal"],
  ["legal-otpid.add-update", "/legal/:otpId", "/legal"],
  ["legal-otpid.address-deeds-search", "/legal/:otpId", "/legal"],
  ["legal-otpid.address-detail-field", "/legal/:otpId", "/legal"],
  ["legal-otpid.address-details-cancel", "/legal/:otpId", "/legal"],
  ["legal-otpid.address-details-save", "/legal/:otpId", "/legal"],
  ["legal-otpid.address-erf", "/legal/:otpId", "/legal"],
  ["legal-otpid.address-farm", "/legal/:otpId", "/legal"],
  ["legal-otpid.address-listing", "/legal/:otpId", "/legal"],
  ["legal-otpid.address-loom-address", "/legal/:otpId", "/legal"],
  ["legal-otpid.address-loom-mode", "/legal/:otpId", "/legal"],
  ["legal-otpid.address-loom-search", "/legal/:otpId", "/legal"],
  ["legal-otpid.address-loom-use", "/legal/:otpId", "/legal"],
  ["legal-otpid.address-manual-erf", "/legal/:otpId", "/legal"],
  ["legal-otpid.address-manual-street", "/legal/:otpId", "/legal"],
  ["legal-otpid.address-manual-suburb", "/legal/:otpId", "/legal"],
  ["legal-otpid.address-manual-unit", "/legal/:otpId", "/legal"],
  ["legal-otpid.address-manual-use", "/legal/:otpId", "/legal"],
  ["legal-otpid.address-scheme", "/legal/:otpId", "/legal"],
  ["legal-otpid.address-search", "/legal/:otpId", "/legal"],
  ["legal-otpid.address-township", "/legal/:otpId", "/legal"],
  ["legal-otpid.address-unit", "/legal/:otpId", "/legal"],
  ["legal-otpid.attorney-add-contact", "/legal/:otpId", "/legal"],
  ["legal-otpid.attorney-call", "/legal/:otpId", "/legal"],
  ["legal-otpid.attorney-cancel", "/legal/:otpId", "/legal"],
  ["legal-otpid.attorney-contact", "/legal/:otpId", "/legal"],
  ["legal-otpid.attorney-mail", "/legal/:otpId", "/legal"],
  ["legal-otpid.attorney-new-contact", "/legal/:otpId", "/legal"],
  ["legal-otpid.attorney-new-contact-save", "/legal/:otpId", "/legal"],
  ["legal-otpid.back-to-queue", "/legal/:otpId", "/legal"],
  ["legal-otpid.bond-detail-cell", "/legal/:otpId", "/legal"],
  ["legal-otpid.bond-originator", "/legal/:otpId", "/legal"],
  ["legal-otpid.buyer-call", "/legal/:otpId", "/legal"],
  ["legal-otpid.buyer-mail", "/legal/:otpId", "/legal"],
  ["legal-otpid.cancellation-approve", "/legal/:otpId", "/legal"],
  ["legal-otpid.cancellation-close", "/legal/:otpId", "/legal"],
  ["legal-otpid.cancellation-reason", "/legal/:otpId", "/legal"],
  ["legal-otpid.cancellation-reject", "/legal/:otpId", "/legal"],
  ["legal-otpid.cancellation-reopen", "/legal/:otpId", "/legal"],
  ["legal-otpid.cancellation-reopen-status", "/legal/:otpId", "/legal"],
  ["legal-otpid.cancellation-request", "/legal/:otpId", "/legal"],
  ["legal-otpid.cancellation-submit", "/legal/:otpId", "/legal"],
  ["legal-otpid.cell-cancel", "/crm/listings/:id", "/crm/listings"],
  ["legal-otpid.cell-cancel", "/legal/:otpId", "/legal"],
  ["legal-otpid.clear-advance", "/legal/:otpId", "/legal"],
  ["legal-otpid.conveyancing-firm", "/legal/:otpId", "/legal"],
  ["legal-otpid.doc-move", "/legal/:otpId", "/legal"],
  ["legal-otpid.doc-remove", "/legal/:otpId", "/legal"],
  ["legal-otpid.doc-remove-cancel", "/legal/:otpId", "/legal"],
  ["legal-otpid.doc-remove-confirm", "/legal/:otpId", "/legal"],
  ["legal-otpid.doc-remove-reason", "/legal/:otpId", "/legal"],
  ["legal-otpid.doc-upload", "/legal/:otpId", "/legal"],
  ["legal-otpid.doc-upload-drop", "/legal/:otpId", "/legal"],
  ["legal-otpid.doc-view", "/legal/:otpId", "/legal"],
  ["legal-otpid.edit-party", "/legal/:otpId", "/legal"],
  ["legal-otpid.edit-related-person", "/legal/:otpId", "/legal"],
  ["legal-otpid.fica-add-purchaser", "/legal/:otpId", "/legal"],
  ["legal-otpid.fica-add-seller", "/legal/:otpId", "/legal"],
  ["legal-otpid.fica-copy-cancel", "/admin/deals/:id", "/admin/deals"],
  ["legal-otpid.fica-copy-cancel", "/crm/deals/:id", "/crm/deals"],
  ["legal-otpid.fica-copy-cancel", "/legal/:otpId", "/legal"],
  ["legal-otpid.fica-copy-confirm", "/admin/deals/:id", "/admin/deals"],
  ["legal-otpid.fica-copy-confirm", "/crm/deals/:id", "/crm/deals"],
  ["legal-otpid.fica-copy-confirm", "/legal/:otpId", "/legal"],
  ["legal-otpid.fica-copy-done", "/admin/deals/:id", "/admin/deals"],
  ["legal-otpid.fica-copy-done", "/crm/deals/:id", "/crm/deals"],
  ["legal-otpid.fica-copy-done", "/legal/:otpId", "/legal"],
  ["legal-otpid.fica-copy-open", "/legal/:otpId", "/legal"],
  ["legal-otpid.fica-copy-send-link", "/admin/deals/:id", "/admin/deals"],
  ["legal-otpid.fica-copy-send-link", "/crm/deals/:id", "/crm/deals"],
  ["legal-otpid.fica-copy-send-link", "/legal/:otpId", "/legal"],
  ["legal-otpid.fica-copy-source", "/admin/deals/:id", "/admin/deals"],
  ["legal-otpid.fica-copy-source", "/crm/deals/:id", "/crm/deals"],
  ["legal-otpid.fica-copy-source", "/legal/:otpId", "/legal"],
  ["legal-otpid.fica-copy-target", "/admin/deals/:id", "/admin/deals"],
  ["legal-otpid.fica-copy-target", "/crm/deals/:id", "/crm/deals"],
  ["legal-otpid.fica-copy-target", "/legal/:otpId", "/legal"],
  ["legal-otpid.fica-move", "/legal/:otpId", "/legal"],
  ["legal-otpid.fica-received", "/legal/:otpId", "/legal"],
  ["legal-otpid.fica-remove", "/legal/:otpId", "/legal"],
  ["legal-otpid.fica-upload", "/legal/:otpId", "/legal"],
  ["legal-otpid.fica-upload-cancel", "/legal/:otpId", "/legal"],
  ["legal-otpid.fica-upload-here", "/legal/:otpId", "/legal"],
  ["legal-otpid.fica-upload-to", "/legal/:otpId", "/legal"],
  ["legal-otpid.file-number", "/legal/:otpId", "/legal"],
  ["legal-otpid.history-next", "/legal/:otpId", "/legal"],
  ["legal-otpid.history-previous", "/legal/:otpId", "/legal"],
  ["legal-otpid.history-retry", "/legal/:otpId", "/legal"],
  ["legal-otpid.letter-body", "/legal/:otpId", "/legal"],
  ["legal-otpid.letter-close", "/legal/:otpId", "/legal"],
  ["legal-otpid.letter-edit", "/legal/:otpId", "/legal"],
  ["legal-otpid.letter-send", "/legal/:otpId", "/legal"],
  ["legal-otpid.letter-subject", "/legal/:otpId", "/legal"],
  ["legal-otpid.letter-template", "/legal/:otpId", "/legal"],
  ["legal-otpid.letter-templates-link", "/legal/:otpId", "/legal"],
  ["legal-otpid.link-attorney", "/legal/:otpId", "/legal"],
  ["legal-otpid.mark-advance", "/legal/:otpId", "/legal"],
  ["legal-otpid.milestone-cell", "/legal/:otpId", "/legal"],
  ["legal-otpid.milestone-choice", "/legal/:otpId", "/legal"],
  ["legal-otpid.milestone-na", "/legal/:otpId", "/legal"],
  ["legal-otpid.party-anc", "/legal/:otpId", "/legal"],
  ["legal-otpid.party-call", "/legal/:otpId", "/legal"],
  ["legal-otpid.party-cancel", "/legal/:otpId", "/legal"],
  ["legal-otpid.party-cell", "/legal/:otpId", "/legal"],
  ["legal-otpid.party-company-name", "/legal/:otpId", "/legal"],
  ["legal-otpid.party-compliance", "/legal/:otpId", "/legal"],
  ["legal-otpid.party-email", "/legal/:otpId", "/legal"],
  ["legal-otpid.party-entity-type", "/legal/:otpId", "/legal"],
  ["legal-otpid.party-first-name", "/legal/:otpId", "/legal"],
  ["legal-otpid.party-id-number", "/legal/:otpId", "/legal"],
  ["legal-otpid.party-last-name", "/legal/:otpId", "/legal"],
  ["legal-otpid.party-mail", "/legal/:otpId", "/legal"],
  ["legal-otpid.party-marriage-status", "/legal/:otpId", "/legal"],
  ["legal-otpid.party-reg-no", "/legal/:otpId", "/legal"],
  ["legal-otpid.party-save", "/legal/:otpId", "/legal"],
  ["legal-otpid.party-search", "/legal/:otpId", "/legal"],
  ["legal-otpid.party-search-clear", "/legal/:otpId", "/legal"],
  ["legal-otpid.party-search-result", "/legal/:otpId", "/legal"],
  ["legal-otpid.party-tel", "/legal/:otpId", "/legal"],
  ["legal-otpid.party-title", "/legal/:otpId", "/legal"],
  ["legal-otpid.pcr-add", "/crm/listings/:id", "/crm/listings"],
  ["legal-otpid.pcr-add", "/legal/:otpId", "/legal"],
  ["legal-otpid.pcr-add-item", "/crm/listings/:id", "/crm/listings"],
  ["legal-otpid.pcr-add-item", "/legal/:otpId", "/legal"],
  ["legal-otpid.pcr-cancel", "/crm/listings/:id", "/crm/listings"],
  ["legal-otpid.pcr-cancel", "/legal/:otpId", "/legal"],
  ["legal-otpid.pcr-comment", "/crm/listings/:id", "/crm/listings"],
  ["legal-otpid.pcr-comment", "/legal/:otpId", "/legal"],
  ["legal-otpid.pcr-condition", "/crm/listings/:id", "/crm/listings"],
  ["legal-otpid.pcr-condition", "/legal/:otpId", "/legal"],
  ["legal-otpid.pcr-copy-from-listing", "/legal/:otpId", "/legal"],
  ["legal-otpid.pcr-date-signed", "/legal/:otpId", "/legal"],
  ["legal-otpid.pcr-new-item", "/crm/listings/:id", "/crm/listings"],
  ["legal-otpid.pcr-new-item", "/legal/:otpId", "/legal"],
  ["legal-otpid.pcr-remove", "/crm/listings/:id", "/crm/listings"],
  ["legal-otpid.pcr-remove", "/legal/:otpId", "/legal"],
  ["legal-otpid.pcr-signed-by", "/legal/:otpId", "/legal"],
  ["legal-otpid.print", "/legal/:otpId", "/legal"],
  ["legal-otpid.property-document-confirm-cancel", "/legal/:otpId", "/legal"],
  ["legal-otpid.property-document-confirm-file", "/legal/:otpId", "/legal"],
  ["legal-otpid.property-document-confirm-otp", "/legal/:otpId", "/legal"],
  ["legal-otpid.property-document-fica-cancel", "/legal/:otpId", "/legal"],
  ["legal-otpid.property-document-fica-confirm", "/legal/:otpId", "/legal"],
  ["legal-otpid.property-document-fica-line", "/legal/:otpId", "/legal"],
  ["legal-otpid.property-document-fica-submit", "/legal/:otpId", "/legal"],
  ["legal-otpid.property-document-file-fica", "/legal/:otpId", "/legal"],
  ["legal-otpid.property-document-file-loom", "/legal/:otpId", "/legal"],
  ["legal-otpid.property-document-file-otp", "/legal/:otpId", "/legal"],
  ["legal-otpid.property-document-view", "/legal/:otpId", "/legal"],
  ["legal-otpid.related-person-address", "/legal/:otpId", "/legal"],
  ["legal-otpid.related-person-call", "/legal/:otpId", "/legal"],
  ["legal-otpid.related-person-cancel", "/legal/:otpId", "/legal"],
  ["legal-otpid.related-person-cell", "/legal/:otpId", "/legal"],
  ["legal-otpid.related-person-email", "/legal/:otpId", "/legal"],
  ["legal-otpid.related-person-id", "/legal/:otpId", "/legal"],
  ["legal-otpid.related-person-mail", "/legal/:otpId", "/legal"],
  ["legal-otpid.related-person-name", "/legal/:otpId", "/legal"],
  ["legal-otpid.related-person-remove-confirm", "/legal/:otpId", "/legal"],
  ["legal-otpid.related-person-representative", "/legal/:otpId", "/legal"],
  ["legal-otpid.related-person-role", "/legal/:otpId", "/legal"],
  ["legal-otpid.related-person-save", "/legal/:otpId", "/legal"],
  ["legal-otpid.related-person-shareholding", "/legal/:otpId", "/legal"],
  ["legal-otpid.related-person-tax", "/legal/:otpId", "/legal"],
  ["legal-otpid.remove-party", "/legal/:otpId", "/legal"],
  ["legal-otpid.remove-party-cancel", "/legal/:otpId", "/legal"],
  ["legal-otpid.remove-party-confirm", "/legal/:otpId", "/legal"],
  ["legal-otpid.remove-related-person", "/legal/:otpId", "/legal"],
  ["legal-otpid.report-confirm", "/legal/:otpId", "/legal"],
  ["legal-otpid.report-date", "/legal/:otpId", "/legal"],
  ["legal-otpid.report-read", "/legal/:otpId", "/legal"],
  ["legal-otpid.report-reject", "/legal/:otpId", "/legal"],
  ["legal-otpid.report-text", "/legal/:otpId", "/legal"],
  ["legal-otpid.report-upload", "/legal/:otpId", "/legal"],
  ["legal-otpid.save-attorney", "/legal/:otpId", "/legal"],
  ["legal-otpid.section-nav", "/legal/:otpId", "/legal"],
  ["legal-otpid.section-toggle", "/legal/:otpId", "/legal"],
  ["legal-otpid.set-address", "/legal/:otpId", "/legal"],
  ["legal-otpid.stage-advance", "/legal/:otpId", "/legal"],
  ["legal-otpid.stage-advance-upload", "/admin/deals/:id", "/admin/deals"],
  ["legal-otpid.stage-advance-upload", "/crm/deals/:id", "/crm/deals"],
  ["legal-otpid.stage-advance-upload", "/legal/:otpId", "/legal"],
  ["legal-otpid.stage-advance-upload-drop", "/admin/deals/:id", "/admin/deals"],
  ["legal-otpid.stage-advance-upload-drop", "/crm/deals/:id", "/crm/deals"],
  ["legal-otpid.stage-advance-upload-drop", "/legal/:otpId", "/legal"],
  ["legal-otpid.update-date", "/legal/:otpId", "/legal"],
  ["legal-otpid.update-edit", "/legal/:otpId", "/legal"],
  ["legal-otpid.update-edit-cancel", "/legal/:otpId", "/legal"],
  ["legal-otpid.update-edit-date", "/legal/:otpId", "/legal"],
  ["legal-otpid.update-edit-note", "/legal/:otpId", "/legal"],
  ["legal-otpid.update-edit-save", "/legal/:otpId", "/legal"],
  ["legal-otpid.update-edit-status", "/legal/:otpId", "/legal"],
  ["legal-otpid.update-edit-visibility", "/legal/:otpId", "/legal"],
  ["legal-otpid.update-note", "/legal/:otpId", "/legal"],
  ["legal-otpid.update-status", "/legal/:otpId", "/legal"],
  ["legal-otpid.update-visibility", "/legal/:otpId", "/legal"],
  ["paralegal.capture-add-lease", "/legal/:otpId", "/legal"],
  ["paralegal.capture-add-listing", "/legal/:otpId", "/legal"],
  ["paralegal.capture-add-sale", "/legal/:otpId", "/legal"],
  ["paralegal.capture-on-behalf", "/legal/:otpId", "/legal"],
  ["partners-id.add-person", "/admin/deals/:id", "/admin/deals"],
  ["partners-id.add-person", "/admin/partners/:id", "/admin/partners"],
  ["partners-id.add-person", "/crm/deals/:id", "/crm/deals"],
  ["partners-id.add-person", "/crm/partners/:id", "/crm/partners"],
  ["partners-id.add-person", "/legal/:otpId", "/legal"],
  ["partners-id.all-partners", "/admin/partners/:id", "/admin/partners"],
  ["partners-id.all-partners", "/crm/partners/:id", "/crm/partners"],
  ["partners-id.copy-link", "/admin/deals/:id", "/admin/deals"],
  ["partners-id.copy-link", "/admin/partners/:id", "/admin/partners"],
  ["partners-id.copy-link", "/crm/deals/:id", "/crm/deals"],
  ["partners-id.copy-link", "/crm/partners/:id", "/crm/partners"],
  ["partners-id.copy-link", "/legal/:otpId", "/legal"],
  ["partners-id.delete-firm", "/admin/partners/:id", "/admin/partners"],
  ["partners-id.delete-firm", "/crm/partners/:id", "/crm/partners"],
  ["partners-id.delete-person", "/admin/deals/:id", "/admin/deals"],
  ["partners-id.delete-person", "/admin/partners/:id", "/admin/partners"],
  ["partners-id.delete-person", "/crm/deals/:id", "/crm/deals"],
  ["partners-id.delete-person", "/crm/partners/:id", "/crm/partners"],
  ["partners-id.delete-person", "/legal/:otpId", "/legal"],
  ["partners-id.edit-firm", "/admin/partners/:id", "/admin/partners"],
  ["partners-id.edit-firm", "/crm/partners/:id", "/crm/partners"],
  ["partners-id.edit-person", "/admin/deals/:id", "/admin/deals"],
  ["partners-id.edit-person", "/admin/partners/:id", "/admin/partners"],
  ["partners-id.edit-person", "/crm/deals/:id", "/crm/deals"],
  ["partners-id.edit-person", "/crm/partners/:id", "/crm/partners"],
  ["partners-id.edit-person", "/legal/:otpId", "/legal"],
  ["partners-id.issue-cancel", "/admin/deals/:id", "/admin/deals"],
  ["partners-id.issue-cancel", "/admin/partners/:id", "/admin/partners"],
  ["partners-id.issue-cancel", "/crm/deals/:id", "/crm/deals"],
  ["partners-id.issue-cancel", "/crm/partners/:id", "/crm/partners"],
  ["partners-id.issue-cancel", "/legal/:otpId", "/legal"],
  ["partners-id.issue-confirm", "/admin/deals/:id", "/admin/deals"],
  ["partners-id.issue-confirm", "/admin/partners/:id", "/admin/partners"],
  ["partners-id.issue-confirm", "/crm/deals/:id", "/crm/deals"],
  ["partners-id.issue-confirm", "/crm/partners/:id", "/crm/partners"],
  ["partners-id.issue-confirm", "/legal/:otpId", "/legal"],
  ["partners-id.issue-done", "/admin/deals/:id", "/admin/deals"],
  ["partners-id.issue-done", "/admin/partners/:id", "/admin/partners"],
  ["partners-id.issue-done", "/crm/deals/:id", "/crm/deals"],
  ["partners-id.issue-done", "/crm/partners/:id", "/crm/partners"],
  ["partners-id.issue-done", "/legal/:otpId", "/legal"],
  ["partners-id.issue-link", "/admin/deals/:id", "/admin/deals"],
  ["partners-id.issue-link", "/admin/partners/:id", "/admin/partners"],
  ["partners-id.issue-link", "/crm/deals/:id", "/crm/deals"],
  ["partners-id.issue-link", "/crm/partners/:id", "/crm/partners"],
  ["partners-id.issue-link", "/legal/:otpId", "/legal"],
  ["partners-id.issued-link", "/admin/deals/:id", "/admin/deals"],
  ["partners-id.issued-link", "/admin/partners/:id", "/admin/partners"],
  ["partners-id.issued-link", "/crm/deals/:id", "/crm/deals"],
  ["partners-id.issued-link", "/crm/partners/:id", "/crm/partners"],
  ["partners-id.issued-link", "/legal/:otpId", "/legal"],
  ["partners-id.open-shared-deal", "/admin/partners/:id", "/admin/partners"],
  ["partners-id.open-shared-deal", "/crm/partners/:id", "/crm/partners"],
  ["partners-id.people-try-again", "/admin/deals/:id", "/admin/deals"],
  ["partners-id.people-try-again", "/admin/partners/:id", "/admin/partners"],
  ["partners-id.people-try-again", "/crm/deals/:id", "/crm/deals"],
  ["partners-id.people-try-again", "/crm/partners/:id", "/crm/partners"],
  ["partners-id.people-try-again", "/legal/:otpId", "/legal"],
  ["partners-id.person-cancel", "/admin/deals/:id", "/admin/deals"],
  ["partners-id.person-cancel", "/admin/partners/:id", "/admin/partners"],
  ["partners-id.person-cancel", "/crm/deals/:id", "/crm/deals"],
  ["partners-id.person-cancel", "/crm/partners/:id", "/crm/partners"],
  ["partners-id.person-cancel", "/legal/:otpId", "/legal"],
  ["partners-id.person-cell", "/admin/deals/:id", "/admin/deals"],
  ["partners-id.person-cell", "/admin/partners/:id", "/admin/partners"],
  ["partners-id.person-cell", "/crm/deals/:id", "/crm/deals"],
  ["partners-id.person-cell", "/crm/partners/:id", "/crm/partners"],
  ["partners-id.person-cell", "/legal/:otpId", "/legal"],
  ["partners-id.person-email", "/admin/deals/:id", "/admin/deals"],
  ["partners-id.person-email", "/admin/partners/:id", "/admin/partners"],
  ["partners-id.person-email", "/crm/deals/:id", "/crm/deals"],
  ["partners-id.person-email", "/crm/partners/:id", "/crm/partners"],
  ["partners-id.person-email", "/legal/:otpId", "/legal"],
  ["partners-id.person-name", "/admin/deals/:id", "/admin/deals"],
  ["partners-id.person-name", "/admin/partners/:id", "/admin/partners"],
  ["partners-id.person-name", "/crm/deals/:id", "/crm/deals"],
  ["partners-id.person-name", "/crm/partners/:id", "/crm/partners"],
  ["partners-id.person-name", "/legal/:otpId", "/legal"],
  ["partners-id.person-save", "/admin/deals/:id", "/admin/deals"],
  ["partners-id.person-save", "/admin/partners/:id", "/admin/partners"],
  ["partners-id.person-save", "/crm/deals/:id", "/crm/deals"],
  ["partners-id.person-save", "/crm/partners/:id", "/crm/partners"],
  ["partners-id.person-save", "/legal/:otpId", "/legal"],
  ["partners-id.revoke-cancel", "/admin/deals/:id", "/admin/deals"],
  ["partners-id.revoke-cancel", "/admin/partners/:id", "/admin/partners"],
  ["partners-id.revoke-cancel", "/crm/deals/:id", "/crm/deals"],
  ["partners-id.revoke-cancel", "/crm/partners/:id", "/crm/partners"],
  ["partners-id.revoke-cancel", "/legal/:otpId", "/legal"],
  ["partners-id.revoke-confirm", "/admin/deals/:id", "/admin/deals"],
  ["partners-id.revoke-confirm", "/admin/partners/:id", "/admin/partners"],
  ["partners-id.revoke-confirm", "/crm/deals/:id", "/crm/deals"],
  ["partners-id.revoke-confirm", "/crm/partners/:id", "/crm/partners"],
  ["partners-id.revoke-confirm", "/legal/:otpId", "/legal"],
  ["partners-id.revoke-link", "/admin/deals/:id", "/admin/deals"],
  ["partners-id.revoke-link", "/admin/partners/:id", "/admin/partners"],
  ["partners-id.revoke-link", "/crm/deals/:id", "/crm/deals"],
  ["partners-id.revoke-link", "/crm/partners/:id", "/crm/partners"],
  ["partners-id.revoke-link", "/legal/:otpId", "/legal"],
  ["partners-id.revoke-reason", "/admin/deals/:id", "/admin/deals"],
  ["partners-id.revoke-reason", "/admin/partners/:id", "/admin/partners"],
  ["partners-id.revoke-reason", "/crm/deals/:id", "/crm/deals"],
  ["partners-id.revoke-reason", "/crm/partners/:id", "/crm/partners"],
  ["partners-id.revoke-reason", "/legal/:otpId", "/legal"],
  ["partners-id.shared-deals-pages", "/admin/partners/:id", "/admin/partners"],
  ["partners-id.shared-deals-pages", "/crm/partners/:id", "/crm/partners"],
  ["partners-id.show-stopped", "/admin/partners/:id", "/admin/partners"],
  ["partners-id.show-stopped", "/crm/partners/:id", "/crm/partners"],
  ["partners-id.try-again", "/admin/partners/:id", "/admin/partners"],
  ["partners-id.try-again", "/crm/partners/:id", "/crm/partners"],
  ["partners.active", "/admin/partners/:id", "/admin/partners"],
  ["partners.active", "/crm/partners/:id", "/crm/partners"],
  ["partners.conveyancer-result", "/admin/partners/:id", "/admin/partners"],
  ["partners.conveyancer-result", "/crm/partners/:id", "/crm/partners"],
  ["partners.firm-email", "/admin/partners/:id", "/admin/partners"],
  ["partners.firm-email", "/crm/partners/:id", "/crm/partners"],
  ["partners.firm-name-field", "/admin/partners/:id", "/admin/partners"],
  ["partners.firm-name-field", "/crm/partners/:id", "/crm/partners"],
  ["partners.firm-type", "/admin/partners/:id", "/admin/partners"],
  ["partners.firm-type", "/crm/partners/:id", "/crm/partners"],
  ["partners.form-cancel", "/admin/partners/:id", "/admin/partners"],
  ["partners.form-cancel", "/crm/partners/:id", "/crm/partners"],
  ["partners.form-save", "/admin/partners/:id", "/admin/partners"],
  ["partners.form-save", "/crm/partners/:id", "/crm/partners"],
  ["partners.linked-conveyancer", "/admin/partners/:id", "/admin/partners"],
  ["partners.linked-conveyancer", "/crm/partners/:id", "/crm/partners"],
  ["partners.phone", "/admin/partners/:id", "/admin/partners"],
  ["partners.phone", "/crm/partners/:id", "/crm/partners"],
  ["partners.remove-conveyancer", "/admin/partners/:id", "/admin/partners"],
  ["partners.remove-conveyancer", "/crm/partners/:id", "/crm/partners"],
  ["partners.show-contact", "/admin/partners/:id", "/admin/partners"],
  ["partners.show-contact", "/crm/partners/:id", "/crm/partners"],
];
